export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents a DateTime. The DateTime is serialized as an RFC 3339 quoted string */
  DateTime: any;
  /** String value for currency */
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf) */
  JSON: any;
  /** Upload file scalar */
  Upload: any;
  /** Convert Core Status to ltms status */
  WarehouseStatusConvert: any;
};

export enum AwbCompleteStatusEnum {
  Failed = 'FAILED',
  FullyCompleted = 'FULLY_COMPLETED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED'
}

export enum AwbIncompleteReason {
  AreaNotReady = 'AREA_NOT_READY',
  CustomerDidNotOrder = 'CUSTOMER_DID_NOT_ORDER',
  DuplicateOrder = 'DUPLICATE_ORDER',
  ExternalCancel = 'EXTERNAL_CANCEL',
  ExternalPickupFailed = 'EXTERNAL_PICKUP_FAILED',
  InsufficientFund = 'INSUFFICIENT_FUND',
  InsufficientTime = 'INSUFFICIENT_TIME',
  InternalCancel = 'INTERNAL_CANCEL',
  InternalPickupFailed = 'INTERNAL_PICKUP_FAILED',
  ItemsDamaged = 'ITEMS_DAMAGED',
  ItemsNotReady = 'ITEMS_NOT_READY',
  OutOfStock = 'OUT_OF_STOCK',
  OverloadFleet = 'OVERLOAD_FLEET',
  StoreClosed = 'STORE_CLOSED',
  StoreNotFound = 'STORE_NOT_FOUND',
  WrongPrice = 'WRONG_PRICE',
  WrongQuantity = 'WRONG_QUANTITY',
  WrongSku = 'WRONG_SKU'
}

export enum AwbSortEnum {
  AwbId = 'AWB_ID',
  CancelReason = 'CANCEL_REASON',
  CodAmount = 'COD_AMOUNT',
  CompleteStatus = 'COMPLETE_STATUS',
  DeliveryDate = 'DELIVERY_DATE',
  DestinationCity = 'DESTINATION_CITY',
  DestinationPhone = 'DESTINATION_PHONE',
  DestinationZipcode = 'DESTINATION_ZIPCODE',
  DoNumber = 'DO_NUMBER',
  DropOrder = 'DROP_ORDER',
  EtaDestination = 'ETA_DESTINATION',
  EtdDestination = 'ETD_DESTINATION',
  IncompleteReason = 'INCOMPLETE_REASON',
  ItemDetails = 'ITEM_DETAILS',
  LatestDropTime = 'LATEST_DROP_TIME',
  LoadingDatetime = 'LOADING_DATETIME',
  OriginCity = 'ORIGIN_CITY',
  PodUpload = 'POD_UPLOAD',
  PolUpload = 'POL_UPLOAD',
  ShipperName = 'SHIPPER_NAME',
  TaskId = 'TASK_ID',
  TourId = 'TOUR_ID',
  TransporterName = 'TRANSPORTER_NAME',
  UnloadingDatetime = 'UNLOADING_DATETIME',
  UpdatedAt = 'UPDATED_AT'
}

export enum AwbStatusEnum {
  ArriveAtDestination = 'ARRIVE_AT_DESTINATION',
  ArriveAtPickup = 'ARRIVE_AT_PICKUP',
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  FinishLoading = 'FINISH_LOADING',
  FinishUnloading = 'FINISH_UNLOADING',
  OngoingToPickup = 'ONGOING_TO_PICKUP',
  OnShipment = 'ON_SHIPMENT',
  PodApproved = 'POD_APPROVED',
  Routing = 'ROUTING',
  ShipmentComplete = 'SHIPMENT_COMPLETE',
  StartLoading = 'START_LOADING',
  StartUnloading = 'START_UNLOADING',
  Unassigned = 'UNASSIGNED',
  Unfulfilled = 'UNFULFILLED'
}

export enum AgreementType {
  FleetOnlyRental = 'FLEET_ONLY_RENTAL',
  Revertback = 'REVERTBACK',
  Tip = 'TIP'
}

export type AwbJobNode = {
  __typename?: 'AwbJobNode';
  /** Actual shipment completed */
  actualCompleted?: Maybe<Scalars['String']>;
  /** Actual overtime hours */
  actualOvertimeHours?: Maybe<Scalars['Float']>;
  /** Actual pricing unit */
  actualPricingUnit?: Maybe<Scalars['Float']>;
  /** AWB id */
  awbId?: Maybe<Scalars['String']>;
  /** AWB cancel reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** AWB's cod amount */
  codAmount?: Maybe<Scalars['Decimal']>;
  /** AWB's actual cod amount */
  collectedCodAmount?: Maybe<Scalars['Decimal']>;
  /** AWB complete status */
  completeStatus?: Maybe<AwbCompleteStatusEnum>;
  /** actor who completed awb */
  completedBy?: Maybe<Scalars['String']>;
  /** Total complete drift in M (meter) from flynd app */
  completedDrift?: Maybe<Scalars['Int']>;
  /** AWB's delivery date */
  deliveryDate?: Maybe<Scalars['String']>;
  /** Destination phone */
  destinationPhone?: Maybe<Scalars['String']>;
  /** Destination zipcode */
  destinationZipcode?: Maybe<Scalars['String']>;
  /** AWB's drop order/sequence */
  dropOrder?: Maybe<Scalars['Int']>;
  /** Earliest possibility shipment completed */
  earliestPossibleCompleted?: Maybe<Scalars['String']>;
  /** AWB's estimated time arrive (will be Depreciate to etaDestination) */
  eta?: Maybe<Scalars['String']>;
  /** AWB's estimated time arrive to destination */
  etaDestination?: Maybe<Scalars['String']>;
  /** AWB's estimated time departure (will be Depreciate to etdDestination) */
  etd?: Maybe<Scalars['String']>;
  /** AWB's estimated time departure to destination */
  etdDestination?: Maybe<Scalars['String']>;
  /** Flynd Driver Confirmed At */
  flyndDriverConfirmedAt?: Maybe<Scalars['String']>;
  /** AWB incomplete reason */
  incompleteReason?: Maybe<Scalars['String']>;
  /** AWB created at */
  insertedAt?: Maybe<Scalars['String']>;
  /** Product shipped details */
  itemDetails?: Maybe<Scalars['String']>;
  /** AWB's job details */
  job?: Maybe<JobNode>;
  /** AWB job ksuid */
  jobKsuid?: Maybe<Scalars['String']>;
  /** AWB ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Latest possibility shipment completed */
  latestPossibleCompleted?: Maybe<Scalars['String']>;
  /** order reference from shipper */
  orderReference?: Maybe<Scalars['String']>;
  /** POD signature url */
  podSignatureUrl?: Maybe<Scalars['String']>;
  /** AWB pod upload */
  podUpload?: Maybe<Scalars['String']>;
  /** Receiver name */
  receiverName?: Maybe<Scalars['String']>;
  /** AWB's shipment failed counter */
  shipmentFailedCounter?: Maybe<ShipmentFailedCounterNode>;
  /** Shipment Notes */
  shipmentNotes?: Maybe<Scalars['String']>;
  /** AWB shipment timestamp */
  shipmentTimestamp?: Maybe<ShipmentTimestampType>;
  /** AWB status */
  status?: Maybe<Scalars['String']>;
  /** Task id */
  taskId?: Maybe<Scalars['String']>;
  /** AWB shipment timestamp */
  timestampStatus?: Maybe<Scalars['String']>;
  /** Tour id */
  tourId?: Maybe<Scalars['String']>;
  /** AWB latest update */
  updatedAt?: Maybe<Scalars['String']>;
};

export type AwbNode = {
  __typename?: 'AwbNode';
  /** Actual shipment completed */
  actualCompleted?: Maybe<Scalars['String']>;
  /** Actual overtime hours */
  actualOvertimeHours?: Maybe<Scalars['Float']>;
  /** Actual pricing unit */
  actualPricingUnit?: Maybe<Scalars['Float']>;
  /** AWB id */
  awbId?: Maybe<Scalars['String']>;
  /** AWB cancel reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** AWB's cod amount */
  codAmount?: Maybe<Scalars['Decimal']>;
  /** AWB's actual cod amount */
  collectedCodAmount?: Maybe<Scalars['Decimal']>;
  /** AWB complete status */
  completeStatus?: Maybe<AwbCompleteStatusEnum>;
  /** actor who completed awb */
  completedBy?: Maybe<Scalars['String']>;
  /** Total complete drift in M (meter) from flynd app */
  completedDrift?: Maybe<Scalars['Int']>;
  /** AWB's delivery date */
  deliveryDate?: Maybe<Scalars['String']>;
  /** AWB's job details */
  deliveryOrder?: Maybe<DeliveryOrder>;
  /** Destination phone */
  destinationPhone?: Maybe<Scalars['String']>;
  /** Destination zipcode */
  destinationZipcode?: Maybe<Scalars['String']>;
  /** AWB's drop order/sequence */
  dropOrder?: Maybe<Scalars['Int']>;
  /** Earliest possibility shipment completed */
  earliestPossibleCompleted?: Maybe<Scalars['String']>;
  /** AWB's estimated time arrive (will be Depreciate to etaDestination) */
  eta?: Maybe<Scalars['String']>;
  /** AWB's estimated time arrive to destination */
  etaDestination?: Maybe<Scalars['String']>;
  /** AWB's estimated time departure (will be Depreciate to etdDestination) */
  etd?: Maybe<Scalars['String']>;
  /** AWB's estimated time departure to destination */
  etdDestination?: Maybe<Scalars['String']>;
  /** Flynd Driver Confirmed At */
  flyndDriverConfirmedAt?: Maybe<Scalars['String']>;
  /** AWB incomplete reason */
  incompleteReason?: Maybe<Scalars['String']>;
  /** AWB created at */
  insertedAt?: Maybe<Scalars['String']>;
  /** Product shipped details */
  itemDetails?: Maybe<Scalars['String']>;
  /** AWB's job details */
  job?: Maybe<JobNode>;
  /** AWB job ksuid */
  jobKsuid?: Maybe<Scalars['String']>;
  /** AWB ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Latest possibility shipment completed */
  latestPossibleCompleted?: Maybe<Scalars['String']>;
  /** order reference from shipper */
  orderReference?: Maybe<Scalars['String']>;
  /** POD signature url */
  podSignatureUrl?: Maybe<Scalars['String']>;
  /** AWB pod upload */
  podUpload?: Maybe<Scalars['String']>;
  /** Receiver name */
  receiverName?: Maybe<Scalars['String']>;
  /** Shipment Notes */
  shipmentNotes?: Maybe<Scalars['String']>;
  /** AWB shipment timestamp */
  shipmentTimestamp?: Maybe<ShipmentTimestampType>;
  /** AWB status */
  status?: Maybe<Scalars['String']>;
  /** Task id */
  taskId?: Maybe<Scalars['String']>;
  /** AWB shipment timestamp */
  timestampStatus?: Maybe<Scalars['String']>;
  /** Tour id */
  tourId?: Maybe<Scalars['String']>;
  /** AWB latest update */
  updatedAt?: Maybe<Scalars['String']>;
};

export type BankNode = {
  __typename?: 'BankNode';
  /** Bank Internal Code */
  internalCode?: Maybe<Scalars['String']>;
  /** Bank Ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Bank Name */
  name?: Maybe<Scalars['String']>;
};

export type BasicContractNode = {
  __typename?: 'BasicContractNode';
  /** Contract's agreement file url */
  agreement?: Maybe<Scalars['String']>;
  /** Contract cc Notes */
  ccNotes?: Maybe<Scalars['String']>;
  /** Deprecated. It will be move to codFeeText variable */
  codFee?: Maybe<Scalars['Boolean']>;
  /** Contract's cod fee */
  codFeeText?: Maybe<Scalars['String']>;
  /** Contract's cod flat value */
  codFlat?: Maybe<Scalars['Float']>;
  /** Contract's cod percentage value */
  codPercentage?: Maybe<Scalars['Float']>;
  /** Contract's cod type */
  codType?: Maybe<Scalars['String']>;
  /** Contract's code */
  contractCode?: Maybe<Scalars['String']>;
  /** Daily Incentive Price */
  dailyIncentivePrice?: Maybe<Scalars['Decimal']>;
  /** Daily Rental Price */
  dailyRentalPrice?: Maybe<Scalars['Decimal']>;
  /** Contract's downtime fee */
  downtimeFee?: Maybe<Scalars['Float']>;
  /** Contract's end date to active */
  endDate?: Maybe<Scalars['String']>;
  /** Contract's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Contract's total of drop point for scheme DROP_POINT */
  numberOfDropPoint?: Maybe<Scalars['Int']>;
  /** Contract's overtime fee */
  overtimeFee?: Maybe<Scalars['Float']>;
  /** Payment scheme */
  paymentScheme?: Maybe<PaymentSchemeType>;
  /** Contract's price */
  price?: Maybe<Scalars['Float']>;
  /** Contract's scheme type */
  schemeType?: Maybe<Scalars['String']>;
  /** Contract's start date to active */
  startDate?: Maybe<Scalars['String']>;
  /** Contract's status */
  status?: Maybe<Status>;
  /** Contract's supply type */
  supplyType?: Maybe<Scalars['String']>;
  /** Contract's traveling expenses value */
  travelingExpenses?: Maybe<Scalars['Float']>;
  /** Contract type */
  type?: Maybe<Scalars['String']>;
  /** Contract's unfulfilled fee */
  unfulfilledFee?: Maybe<Scalars['Float']>;
};

export enum CapacityUnitEnum {
  Ton = 'TON'
}

export type CityNode = {
  __typename?: 'CityNode';
  /** City Id */
  id?: Maybe<Scalars['String']>;
  /** City name */
  name?: Maybe<Scalars['String']>;
  /** Province id of city */
  provinceId?: Maybe<Scalars['String']>;
};

export type ClusterProjectMigrationResponse = {
  __typename?: 'ClusterProjectMigrationResponse';
  /** Project Cluster Id */
  clusterId?: Maybe<Scalars['String']>;
  /** project ksuid */
  ksuid?: Maybe<Scalars['String']>;
};

export enum CompanyContactDivisionEnum {
  AccountReceivable = 'ACCOUNT_RECEIVABLE',
  Canvasser = 'CANVASSER',
  Claims = 'CLAIMS',
  Finance = 'FINANCE',
  Logistics = 'LOGISTICS',
  Operations = 'OPERATIONS',
  Procurement = 'PROCUREMENT',
  Sales = 'SALES',
  SalesSupport = 'SALES_SUPPORT',
  Treasury = 'TREASURY',
  Warehouse = 'WAREHOUSE'
}

export type CompanyDocumentNode = {
  __typename?: 'CompanyDocumentNode';
  /** Company ksuid */
  companyKsuid?: Maybe<Scalars['String']>;
  /** Document type */
  documentType?: Maybe<Scalars['String']>;
  /** Document metadata */
  documentUpload?: Maybe<Scalars['String']>;
  /** Document expiry date */
  expiryDate?: Maybe<Scalars['String']>;
  /** Document ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Document metadata */
  metadata?: Maybe<Scalars['String']>;
};

export type CompanyDriver = {
  __typename?: 'CompanyDriver';
  /** List of company driver document */
  companyDriverDocuments?: Maybe<Array<Maybe<CompanyDriverDocumentNode>>>;
  /** Company which register this company driver */
  companyKsuid?: Maybe<Scalars['String']>;
  /** Driver's related contracts */
  contracts?: Maybe<Array<Maybe<BasicContractNode>>>;
  /** Driver's dedication to specific contract */
  dedicatedContract?: Maybe<BasicContractNode>;
  /** Driver's dedication state to specific contract */
  dedicatedToContract?: Maybe<Scalars['Boolean']>;
  /** Driver detail */
  driver?: Maybe<Driver>;
  /** Driver ID */
  driverKsuid?: Maybe<Scalars['String']>;
  /** ID for company driver */
  ksuid?: Maybe<Scalars['String']>;
  /** Company driver status */
  status?: Maybe<Scalars['String']>;
  /** Transporter detail */
  transporter?: Maybe<CompanyNode>;
  /** Transporter which register this company driver */
  transporterKsuid?: Maybe<Scalars['String']>;
  /** Company driver verification status */
  verificationStatus?: Maybe<Scalars['String']>;
};

export type CompanyDriverDocumentNode = {
  __typename?: 'CompanyDriverDocumentNode';
  /** Document type */
  documentType?: Maybe<Scalars['String']>;
  /** Document expiry date */
  expiryDate?: Maybe<Scalars['String']>;
  /** Document files */
  files?: Maybe<Array<Maybe<File>>>;
  /** Document ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Document metadata */
  metadata?: Maybe<Scalars['String']>;
};

export enum CompanyDriverLicenseType {
  SimA = 'SIM_A',
  SimAUmum = 'SIM_A_UMUM',
  SimB1 = 'SIM_B1',
  SimB1Umum = 'SIM_B1_UMUM',
  SimB2 = 'SIM_B2',
  SimB2Umum = 'SIM_B2_UMUM'
}

export enum CompanyDriverSortByEnum {
  CreatedAt = 'CREATED_AT',
  DriverLicenseType = 'DRIVER_LICENSE_TYPE',
  DriverName = 'DRIVER_NAME',
  PhoneNumber = 'PHONE_NUMBER',
  UpdatedAt = 'UPDATED_AT'
}

export enum CompanyDriverVerificationStatusEnum {
  Rejected = 'REJECTED',
  Verified = 'VERIFIED'
}

export type CompanyNode = {
  __typename?: 'CompanyNode';
  /** Company address */
  address?: Maybe<Scalars['String']>;
  /** List of company document */
  companyDocuments?: Maybe<Array<Maybe<CompanyDocumentNode>>>;
  /** List of company PIC */
  companyPics?: Maybe<Array<Maybe<CompanyPicNode>>>;
  /** Owner's email */
  email?: Maybe<Scalars['String']>;
  /** Company's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Company's name */
  name?: Maybe<Scalars['String']>;
  /** Owner's phone number */
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CompanyPicNode = {
  __typename?: 'CompanyPICNode';
  /** Company PIC's division */
  division?: Maybe<Scalars['String']>;
  /** Company PIC's email */
  email?: Maybe<Scalars['String']>;
  /** Company PIC's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Company PIC's name */
  name?: Maybe<Scalars['String']>;
  /** Company PIC's phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Company PIC's position */
  position?: Maybe<Scalars['String']>;
  /** Company PIC's type */
  type?: Maybe<Scalars['String']>;
};

export type CompanyPicInput = {
  /** Company PIC's division */
  division?: InputMaybe<CompanyContactDivisionEnum>;
  /** Company PIC's email */
  email?: InputMaybe<Scalars['String']>;
  /** Company PIC's name */
  name?: InputMaybe<Scalars['String']>;
  /** Company PIC's phone number */
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Company PIC's position */
  position?: InputMaybe<Scalars['String']>;
  /** Company PIC's type */
  type?: InputMaybe<Scalars['String']>;
};

export type CompanyVehicleNode = {
  __typename?: 'CompanyVehicleNode';
  /** Vehicle's body type */
  bodyType?: Maybe<Scalars['String']>;
  /** Vehicle's company owner ksuid */
  companyKsuid: Scalars['String'];
  /** List of company vehicle document */
  companyVehicleDocuments?: Maybe<Array<Maybe<CompanyDriverDocumentNode>>>;
  /** Vehicle's related contracts */
  contracts?: Maybe<Array<Maybe<BasicContractNode>>>;
  /** Vehicle's dedication to specific contract */
  dedicatedContract?: Maybe<BasicContractNode>;
  /** Vehicle's dedication state to specific contract */
  dedicatedToContract?: Maybe<Scalars['Boolean']>;
  /** Vehicle's dimension */
  dimension?: Maybe<Scalars['String']>;
  /** Company Vehicle ksuid */
  ksuid: Scalars['String'];
  /** Vehicle's status */
  status?: Maybe<Scalars['String']>;
  /** Transporter detail */
  transporter?: Maybe<CompanyNode>;
  /** Vehicle's details */
  vehicle?: Maybe<VehicleNode>;
};

export enum ContractCodFee {
  IncludedInRentalPrice = 'INCLUDED_IN_RENTAL_PRICE',
  NeedAdditionalCodFee = 'NEED_ADDITIONAL_COD_FEE'
}

export enum ContractCodType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type ContractNode = {
  __typename?: 'ContractNode';
  /** Addendum Or Termination Link */
  addendumOrTerminationLink?: Maybe<Scalars['String']>;
  /** Contract's agreement file url */
  agreement?: Maybe<Scalars['String']>;
  /** Agreement Number */
  agreementNumber?: Maybe<Scalars['String']>;
  /** Agreement Type */
  agreementType?: Maybe<AgreementType>;
  /** Contract cc Notes */
  ccNotes?: Maybe<Scalars['String']>;
  /** Deprecated. It will be move to codFeeText variable */
  codFee?: Maybe<Scalars['Boolean']>;
  /** Contract's cod fee */
  codFeeText?: Maybe<Scalars['String']>;
  /** Contract's cod flat value */
  codFlat?: Maybe<Scalars['Float']>;
  /** Contract's cod percentage value */
  codPercentage?: Maybe<Scalars['Float']>;
  /** Contract's cod type */
  codType?: Maybe<Scalars['String']>;
  /** Contract's code */
  contractCode?: Maybe<Scalars['String']>;
  /** Daily Incentive Price */
  dailyIncentivePrice?: Maybe<Scalars['Decimal']>;
  /** Daily Rental Price */
  dailyRentalPrice?: Maybe<Scalars['Decimal']>;
  /** Delivery Order External Id */
  deliveryOrderId?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Contract's downtime fee */
  downtimeFee?: Maybe<Scalars['Float']>;
  /** Driver which allocated for this contract */
  driverAllocations?: Maybe<Array<Maybe<DriverAllocationNode>>>;
  /** Contract's end date to active */
  endDate?: Maybe<Scalars['String']>;
  /** Extra Helper */
  hasExtraHelper?: Maybe<Scalars['Boolean']>;
  /** Kargo Entity */
  kargoEntity?: Maybe<Scalars['String']>;
  /** Contract's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Contract's total of drop point for scheme DROP_POINT */
  numberOfDropPoint?: Maybe<Scalars['Int']>;
  /** Number Of Trip */
  numberOfTrip?: Maybe<Scalars['String']>;
  /** Contract's overtime fee */
  overtimeFee?: Maybe<Scalars['Float']>;
  /** Payment scheme */
  paymentScheme?: Maybe<PaymentSchemeType>;
  /** Contract's price */
  price?: Maybe<Scalars['Float']>;
  /** Contract's project */
  project?: Maybe<ProjectNode>;
  /** Contract's Project ksuid */
  projectKsuid?: Maybe<Scalars['String']>;
  /** Contract's scheme type */
  schemeType?: Maybe<Scalars['String']>;
  /** Contract's Shipper Company */
  shipper?: Maybe<CompanyNode>;
  /** Contract's Shipper Company ksuid */
  shipperKsuid?: Maybe<Scalars['String']>;
  /** Contract's start date to active */
  startDate?: Maybe<Scalars['String']>;
  /** Contract's status */
  status?: Maybe<Status>;
  /** Contract's supply type */
  supplyType?: Maybe<Scalars['String']>;
  /** Contract's Transporter Company */
  transporter?: Maybe<CompanyNode>;
  /** Contract's Transporter Company ksuid */
  transporterKsuid?: Maybe<Scalars['String']>;
  /** Transporter Pipeline */
  transporterPipeline?: Maybe<TransporterPipelineNode>;
  /** Contract's traveling expenses value */
  travelingExpenses?: Maybe<Scalars['Float']>;
  /** Contract type */
  type?: Maybe<Scalars['String']>;
  /** Contract's unfulfilled fee */
  unfulfilledFee?: Maybe<Scalars['Float']>;
  /** Vehicle which allocated for this contract */
  vehicleAllocations?: Maybe<Array<Maybe<VehicleAllocationNode>>>;
};

export enum ContractSchemeType {
  Daily = 'DAILY',
  DropPoint = 'DROP_POINT',
  Monthly = 'MONTHLY'
}

export enum ContractSortBy {
  CodFee = 'COD_FEE',
  CodFlat = 'COD_FLAT',
  CodPercentage = 'COD_PERCENTAGE',
  CodType = 'COD_TYPE',
  ContractCode = 'CONTRACT_CODE',
  DowntimeFee = 'DOWNTIME_FEE',
  EndDate = 'END_DATE',
  Ksuid = 'KSUID',
  NumberOfDropPoint = 'NUMBER_OF_DROP_POINT',
  OvertimeFee = 'OVERTIME_FEE',
  PaymentScheme = 'PAYMENT_SCHEME',
  Price = 'PRICE',
  SchemeType = 'SCHEME_TYPE',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  SupplyType = 'SUPPLY_TYPE',
  TravelingExpenses = 'TRAVELING_EXPENSES',
  Type = 'TYPE',
  UnfulfilledFee = 'UNFULFILLED_FEE'
}

export enum ContractSupplyType {
  AllIn = 'ALL_IN',
  DriverOnlyRental = 'DRIVER_ONLY_RENTAL',
  FleetAndDriverRental = 'FLEET_AND_DRIVER_RENTAL',
  FleetOnlyRental = 'FLEET_ONLY_RENTAL'
}

export enum ContractType {
  Dedicated = 'DEDICATED',
  Oncall = 'ONCALL'
}

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CoordinateInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type CorrectDeliveryOrder = {
  __typename?: 'CorrectDeliveryOrder';
  /** payables created */
  payables?: Maybe<Array<Maybe<PayableNode>>>;
  /** receivable created */
  receivable?: Maybe<ReceivableNode>;
};

export enum DoAllocationStatuses {
  Assigned = 'ASSIGNED',
  Planned = 'PLANNED',
  Queued = 'QUEUED',
  Unassigned = 'UNASSIGNED'
}

export enum DoPricingScheme {
  PerCbm = 'PER_CBM',
  PerDropPoint = 'PER_DROP_POINT',
  PerKm = 'PER_KM',
  PerLoad = 'PER_LOAD',
  PerOrder = 'PER_ORDER',
  PerRoute = 'PER_ROUTE',
  Rental = 'RENTAL'
}

export enum DoProductTypeEnum {
  Bakery = 'BAKERY',
  CookingAndBakingIngredients = 'COOKING_AND_BAKING_INGREDIENTS',
  DairyProducts = 'DAIRY_PRODUCTS',
  Fmcg = 'FMCG',
  FrozenFood = 'FROZEN_FOOD',
  GrainsRiceAndCereal = 'GRAINS_RICE_AND_CEREAL',
  NutsAndSeeds = 'NUTS_AND_SEEDS',
  Others = 'OTHERS',
  PreparedFood = 'PREPARED_FOOD',
  Snacks = 'SNACKS',
  Soda = 'SODA'
}

export enum DoShipmentStatuses {
  Assigned = 'ASSIGNED',
  CancelledByInternal = 'CANCELLED_BY_INTERNAL',
  OnShipment = 'ON_SHIPMENT',
  Planned = 'PLANNED',
  ShipmentComplete = 'SHIPMENT_COMPLETE',
  Unassigned = 'UNASSIGNED',
  Unfulfilled = 'UNFULFILLED'
}

export enum DoSortEnum {
  AllocationStatus = 'ALLOCATION_STATUS',
  CancelReason = 'CANCEL_REASON',
  DeliveryDate = 'DELIVERY_DATE',
  DoNumber = 'DO_NUMBER',
  DriverId = 'DRIVER_ID',
  DriverName = 'DRIVER_NAME',
  LicensePlateNumber = 'LICENSE_PLATE_NUMBER',
  PricingScheme = 'PRICING_SCHEME',
  ProjectId = 'PROJECT_ID',
  ProjectName = 'PROJECT_NAME',
  ShipmentStatus = 'SHIPMENT_STATUS',
  ShipperId = 'SHIPPER_ID',
  ShipperName = 'SHIPPER_NAME',
  TourId = 'TOUR_ID',
  TransporterId = 'TRANSPORTER_ID',
  TransporterName = 'TRANSPORTER_NAME'
}

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  /** Deleted Status */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Deleted ksuid */
  ksuid?: Maybe<Scalars['String']>;
};

export type DeliveryOrder = {
  __typename?: 'DeliveryOrder';
  /** Actual overtime hours */
  actualOvertimeHours?: Maybe<Scalars['Float']>;
  /** Actual pricing unit */
  actualPricingUnit?: Maybe<Scalars['Float']>;
  /** DO's additional trip */
  additionalTrip?: Maybe<Scalars['Boolean']>;
  /** DO's additional trip notes */
  additionalTripNotes?: Maybe<Scalars['String']>;
  /** DO allocation status */
  allocationStatus?: Maybe<Scalars['String']>;
  /** List of AWBs */
  awbs?: Maybe<Array<Maybe<AwbJobNode>>>;
  /** DO cancelation reason */
  cancelReason?: Maybe<Scalars['String']>;
  /** Company Driver detail */
  companyDriver?: Maybe<CompanyDriver>;
  /** Driver assigned to DO */
  companyDriverKsuid?: Maybe<Scalars['String']>;
  /** Company Vehicle details */
  companyVehicle?: Maybe<CompanyVehicleNode>;
  /** Vehicle assigned to DO */
  companyVehicleKsuid?: Maybe<Scalars['String']>;
  /** Company Vehicle Replacement details */
  companyVehicleReplacement?: Maybe<CompanyVehicleNode>;
  /** Company Vehicle Replacement Ksuid */
  companyVehicleReplacementKsuid?: Maybe<Scalars['String']>;
  /** Contract detail */
  contract?: Maybe<ContractNode>;
  /** Contract Driver detail */
  contractDriver?: Maybe<ContractNode>;
  /** Contract Driver assigned to DO */
  contractDriverKsuid?: Maybe<Scalars['String']>;
  /** Contract assigned to DO */
  contractKsuid?: Maybe<Scalars['String']>;
  /** Contract Vehicle detail */
  contractVehicle?: Maybe<ContractNode>;
  /** Contract Vehicle assigned to DO */
  contractVehicleKsuid?: Maybe<Scalars['String']>;
  /** DO delivery date */
  deliveryDate?: Maybe<Scalars['String']>;
  /** DO has discount or not */
  discount?: Maybe<Scalars['Boolean']>;
  /** DO's discount flat value */
  discountFlatValue?: Maybe<Scalars['Float']>;
  /** DO's discount maximum percentage value */
  discountPercentageMax?: Maybe<Scalars['Float']>;
  /** DO's discount percentage value */
  discountPercentageValue?: Maybe<Scalars['Float']>;
  /** DO's discount type */
  discountType?: Maybe<Scalars['String']>;
  /** DO's driver notes */
  driverNotes?: Maybe<Scalars['String']>;
  /** DO external id */
  externalId?: Maybe<Scalars['String']>;
  /** DO's extra helper amount */
  extraHelperAmount?: Maybe<Scalars['Int']>;
  /** DO's extra helper price */
  extraHelperPrice?: Maybe<Scalars['Float']>;
  /** DO insurance load value */
  insuranceLoadValue?: Maybe<Scalars['Float']>;
  /** DO insurance load value */
  insurancePrice?: Maybe<Scalars['Float']>;
  /** DO's internal notes */
  internalNotes?: Maybe<Scalars['String']>;
  /** DO's job details */
  job?: Maybe<JobNode>;
  /** DO's job ksuid */
  jobKsuid?: Maybe<Scalars['String']>;
  /** DO's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** DO's planned pricing unit */
  plannedPricingUnit?: Maybe<Scalars['Float']>;
  /** DO's pod return address */
  podReturnAddress?: Maybe<Scalars['String']>;
  /** DO's pod return price */
  podReturnPrice?: Maybe<Scalars['Float']>;
  /** POL signature url */
  polSignatureUrl?: Maybe<Scalars['String']>;
  /** DO pol upload */
  polUpload?: Maybe<Scalars['String']>;
  /** Price final of delivery order */
  priceFinal?: Maybe<Scalars['Float']>;
  /** DO's price suggestion */
  priceSuggestion?: Maybe<Scalars['Float']>;
  /** Project detail */
  project?: Maybe<ProjectNode>;
  /** Project assigned to DO */
  projectKsuid?: Maybe<Scalars['String']>;
  /** Receivable of delivery order */
  receivable?: Maybe<ReceivableDeliveryOrder>;
  /** DO's shipment ksuid */
  shipmentKsuid?: Maybe<Scalars['String']>;
  /** Shipper Company detail */
  shipper?: Maybe<CompanyNode>;
  /** Shipper detail */
  shipperDetail?: Maybe<ShipperNode>;
  /** Shipper assigned to DO */
  shipperKsuid?: Maybe<Scalars['String']>;
  /** DO's shipper notes */
  shipperNotes?: Maybe<Scalars['String']>;
  /** DO status */
  status?: Maybe<Scalars['String']>;
  /** DO's Tour id */
  tourId?: Maybe<Scalars['String']>;
  /** Transporter detail */
  transporter?: Maybe<CompanyNode>;
  /** Transporter Driver detail */
  transporterDriver?: Maybe<CompanyNode>;
  /** Transporter Driver assigned to DO */
  transporterDriverKsuid?: Maybe<Scalars['String']>;
  /** Transporter assigned to DO */
  transporterKsuid?: Maybe<Scalars['String']>;
  /** DO's transporter price */
  transporterPrice?: Maybe<Scalars['Decimal']>;
  /** Transporter Vehicle detail */
  transporterVehicle?: Maybe<CompanyNode>;
  /** Transporter Vehicle assigned to DO */
  transporterVehicleKsuid?: Maybe<Scalars['String']>;
};

export type DeliveryOrderConnection = {
  __typename?: 'DeliveryOrderConnection';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<DeliveryOrderConnectionEdge>>>;
  pageInfo: PageInfo;
};

export type DeliveryOrderConnectionEdge = {
  __typename?: 'DeliveryOrderConnectionEdge';
  cursor: Scalars['String'];
  node?: Maybe<DeliveryOrder>;
};

export type DeliveryOrderInput = {
  /** Actual Overtime Hours */
  actualOvertimeHours?: InputMaybe<Scalars['Float']>;
  /** Actual pricing unit */
  actualPricingUnit?: InputMaybe<Scalars['Float']>;
  /** Company Vehicle Replacement Ksuid */
  companyVehicleReplacementKsuid?: InputMaybe<Scalars['String']>;
  /** DO delivery date */
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  /** DO has discount or not */
  discount?: InputMaybe<Scalars['Boolean']>;
  /** DO's discount flat value */
  discountFlatValue?: InputMaybe<Scalars['Float']>;
  /** DO's discount maximum percentage value */
  discountPercentageMaxAmount?: InputMaybe<Scalars['Float']>;
  /** DO's discount percentage value */
  discountPercentageValue?: InputMaybe<Scalars['Float']>;
  /** DO's discount type */
  discountType?: InputMaybe<Scalars['String']>;
  /** Delivery order number */
  doNumber?: InputMaybe<Scalars['String']>;
  /** DO's driver notes */
  driverNotes?: InputMaybe<Scalars['String']>;
  /** DO's extra helper amount */
  extraHelperAmount?: InputMaybe<Scalars['Int']>;
  /** DO's extra helper price */
  extraHelperPrice?: InputMaybe<Scalars['Float']>;
  /** DO insurance load value */
  insuranceLoadValue?: InputMaybe<Scalars['Float']>;
  /** DO insurance load value */
  insurancePrice?: InputMaybe<Scalars['Float']>;
  /** DO's internal notes */
  internalNotes?: InputMaybe<Scalars['String']>;
  /** Delivery order ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Datetime when any initiate action on origin */
  originActionDateTime?: InputMaybe<Scalars['DateTime']>;
  /** Origin warehouse ksuid */
  originKsuid?: InputMaybe<Scalars['String']>;
  /** Planned Pricing Unit for a DO */
  plannedPricingUnit?: InputMaybe<Scalars['Float']>;
  /** DO's pod return address */
  podReturnAddress?: InputMaybe<Scalars['String']>;
  /** DO's pod return price */
  podReturnPrice?: InputMaybe<Scalars['Float']>;
  /** DO pol upload */
  polUpload?: InputMaybe<Scalars['String']>;
  /** Shipper Final Price */
  priceFinal?: InputMaybe<Scalars['Float']>;
  /** DO's price suggestion */
  priceSuggestion?: InputMaybe<Scalars['Float']>;
  /** Type of product that shipped */
  productType?: InputMaybe<DoProductTypeEnum>;
  /** Project ksuid */
  projectKsuid?: InputMaybe<Scalars['String']>;
  /** DO's shipment status */
  shipmentStatus?: InputMaybe<DoShipmentStatuses>;
  /** Shipper ksuid */
  shipperKsuid?: InputMaybe<Scalars['String']>;
  /** DO's shipper notes */
  shipperNotes?: InputMaybe<Scalars['String']>;
  /** DO's transporter price as create contract requirement */
  transporterPrice?: InputMaybe<Scalars['Float']>;
};

export type DispatchGroupPipelineContractNode = {
  __typename?: 'DispatchGroupPipelineContractNode';
  /** End Date */
  endDate?: Maybe<Scalars['String']>;
  /** Rental Price */
  rentalPrice?: Maybe<Scalars['Float']>;
  /** Start Date */
  startDate?: Maybe<Scalars['String']>;
  /** Contract supplyType */
  supplyType?: Maybe<Scalars['String']>;
};

export type DispatchGroupPipelineDispatchesDrivenByNode = {
  __typename?: 'DispatchGroupPipelineDispatchesDrivenByNode';
  /** driver phone number */
  contact?: Maybe<Scalars['String']>;
  /** sim expiration date */
  expirationDate?: Maybe<Scalars['String']>;
  /** helper phone number */
  helperContact?: Maybe<Scalars['String']>;
  /** helper name */
  helperName?: Maybe<Scalars['String']>;
  /** driver ktp number */
  ktp?: Maybe<Scalars['String']>;
  /** Driver name */
  name?: Maybe<Scalars['String']>;
  /** driver npwp number */
  npwp?: Maybe<Scalars['String']>;
  /** replacement dricer end date */
  replacementDriverEndDate?: Maybe<Scalars['String']>;
  /** replacement driver name */
  replacementDriverName?: Maybe<Scalars['String']>;
  /** replacement driver start date */
  replacementDriverStartDate?: Maybe<Scalars['String']>;
  /** driver sim number */
  sim?: Maybe<Scalars['String']>;
};

export type DispatchGroupPipelineDispatchesNode = {
  __typename?: 'DispatchGroupPipelineDispatchesNode';
  /** fleet driven by */
  drivenBy?: Maybe<DispatchGroupPipelineDispatchesDrivenByNode>;
  /** Fleet plate number */
  plateNumber?: Maybe<Scalars['String']>;
  /** fleet replacement end date */
  replacementEndDate?: Maybe<Scalars['String']>;
  /** fleet replacement plate number */
  replacementFleetPlate?: Maybe<Scalars['String']>;
  /** fleet replacement start date */
  replacementStartDate?: Maybe<Scalars['String']>;
};

export type DispatchGroupPipelineFleetNode = {
  __typename?: 'DispatchGroupPipelineFleetNode';
  /** Fleet Body Type */
  fleetBodyType?: Maybe<Scalars['String']>;
  /** Fleet Type */
  fleetType?: Maybe<Scalars['String']>;
};

export type DispatchGroupPipelineNode = {
  __typename?: 'DispatchGroupPipelineNode';
  /** Pipeline's Contract information */
  contracts?: Maybe<Array<Maybe<DispatchGroupPipelineContractNode>>>;
  /** Pipeline's Dispatches information */
  dispatches?: Maybe<Array<Maybe<DispatchGroupPipelineDispatchesNode>>>;
  /** Pipeline's Fleet information. */
  fleet?: Maybe<DispatchGroupPipelineFleetNode>;
  /** Pipeline's code */
  pipelineCode?: Maybe<Scalars['String']>;
  /** Pipeline's Transporter information. */
  transporter?: Maybe<DispatchGroupPipelineTransporterNode>;
};

export type DispatchGroupPipelineTransporterNode = {
  __typename?: 'DispatchGroupPipelineTransporterNode';
  /** Transporter name */
  name?: Maybe<Scalars['String']>;
  /** Transporter type */
  transporterType?: Maybe<Scalars['String']>;
};

export type DispatchGroupProjectNode = {
  __typename?: 'DispatchGroupProjectNode';
  /** Given name of the project before validation (pipeline). */
  alias?: Maybe<Scalars['String']>;
  /** Project ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Project name after validation. */
  name?: Maybe<Scalars['String']>;
};

export type DispatchGroupShipperNode = {
  __typename?: 'DispatchGroupShipperNode';
  /** Given name of the company before validation (pipeline). */
  alias?: Maybe<Scalars['String']>;
  /** Company's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Company's name after validation. */
  name?: Maybe<Scalars['String']>;
};

export type DispatchGroups = {
  __typename?: 'DispatchGroups';
  /** Dispatch Group Contract type */
  contractType?: Maybe<Scalars['String']>;
  /** Dispatch Group Pipeline Information */
  pipelines?: Maybe<Array<Maybe<DispatchGroupPipelineNode>>>;
  /** Dispatch Group Project Node */
  project?: Maybe<DispatchGroupProjectNode>;
  /** Dispatch Group Shipper Node */
  shipper?: Maybe<DispatchGroupShipperNode>;
};

export type DoDeliveryDateRange = {
  /** Shipment date filter by end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Shipment date filter by start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentInput = {
  /** Document expiry date */
  expiryDate?: InputMaybe<Scalars['String']>;
  /** Document file */
  file?: InputMaybe<Scalars['Upload']>;
  /** Document file url */
  fileUrl?: InputMaybe<Scalars['String']>;
  /** Document ksuid (optional) */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Document metadata */
  number?: InputMaybe<Scalars['String']>;
  /** Document type ksuid */
  type?: InputMaybe<Scalars['String']>;
};

export enum DocumentStatus {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Uploaded = 'UPLOADED'
}

export enum DocumentType {
  Kir = 'KIR',
  Stnk = 'STNK'
}

export type Driver = {
  __typename?: 'Driver';
  /** Phone number for driver */
  contactNumber?: Maybe<Scalars['String']>;
  /** Driver ID */
  driverKsuid?: Maybe<Scalars['String']>;
  /** Expiration date for driver (if any) */
  driverLicenseExpiryDate?: Maybe<Scalars['String']>;
  /** License number (SIM) for driver */
  driverLicenseNumber?: Maybe<Scalars['String']>;
  /** License type (if any) */
  driverLicenseType?: Maybe<Scalars['String']>;
  /** ID Card (KTP) number */
  idCardNumber?: Maybe<Scalars['String']>;
  /** ID for driver */
  ksuid?: Maybe<Scalars['String']>;
  /** Name of driver */
  name?: Maybe<Scalars['String']>;
  /** User ID (for login at driver app) associated with this driver */
  userKsuid?: Maybe<Scalars['String']>;
};

export type DriverAllocationInput = {
  /** Company driver ksuid */
  companyDriverKsuid?: InputMaybe<Scalars['String']>;
  /** Driver name */
  driverName?: InputMaybe<Scalars['String']>;
};

export type DriverAllocationNode = {
  __typename?: 'DriverAllocationNode';
  /** Company driver node */
  companyDriver?: Maybe<CompanyDriver>;
  /** Driver's details */
  driver?: Maybe<Driver>;
  /** drive Allocation ksuid */
  ksuid?: Maybe<Scalars['String']>;
};

export type DriverConnection = {
  __typename?: 'DriverConnection';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<DriverConnectionEdge>>>;
  pageInfo: PageInfo;
};

export type DriverConnectionEdge = {
  __typename?: 'DriverConnectionEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompanyDriver>;
};

export enum DriverDocumentType {
  Ktp = 'KTP',
  Sim = 'SIM'
}

export type DriverInput = {
  /** Driver Bank account number */
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  /** Driver Bank name */
  bankName?: InputMaybe<Scalars['String']>;
  /** Driver Bank account owner name */
  bankOwnerName?: InputMaybe<Scalars['String']>;
  /** Driver Bank branch */
  branch?: InputMaybe<Scalars['String']>;
  /** Driver phone number */
  contact?: InputMaybe<Scalars['String']>;
  /** Expiration date */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Helper phone number */
  helperContact?: InputMaybe<Scalars['String']>;
  /** Helper name */
  helperName?: InputMaybe<Scalars['String']>;
  /** Driver's ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Driver KTP */
  ktp?: InputMaybe<Scalars['String']>;
  /** Driver name */
  name?: InputMaybe<Scalars['String']>;
  /** Driver NPWP */
  npwp?: InputMaybe<Scalars['String']>;
  /** Replacement driver end date */
  replacementDriverEndDate?: InputMaybe<Scalars['String']>;
  /** Replacement driver name */
  replacementDriverName?: InputMaybe<Scalars['String']>;
  /** Replacement driver start date */
  replacementDriverStartDate?: InputMaybe<Scalars['String']>;
  /** Driver Sim */
  sim?: InputMaybe<Scalars['String']>;
};

export enum DriverLicenseType {
  SimA = 'SIM_A',
  SimAUmum = 'SIM_A_UMUM',
  SimB1 = 'SIM_B1',
  SimB1Umum = 'SIM_B1_UMUM',
  SimB2 = 'SIM_B2',
  SimB2Umum = 'SIM_B2_UMUM'
}

export enum DriverStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum DueStatusEnum {
  Completed = 'COMPLETED',
  NotDueStatus = 'NOT_DUE_STATUS',
  Overdue = 'OVERDUE',
  Upcoming = 'UPCOMING'
}

export type EventNode = {
  __typename?: 'EventNode';
  /** Actor Ksuid */
  actorKsuid?: Maybe<Scalars['String']>;
  /** Actor name  */
  actorName?: Maybe<Scalars['String']>;
  /** Created At */
  createdAt?: Maybe<Scalars['String']>;
  /** Event Name */
  eventName?: Maybe<Scalars['String']>;
  /** Audit Event Ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Audit Event metadata */
  metadata?: Maybe<Scalars['JSON']>;
  /** Resource ksuid */
  resourceKsuid?: Maybe<Scalars['String']>;
};

export type File = {
  __typename?: 'File';
  /** File name */
  fileName?: Maybe<Scalars['String']>;
  /** File ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** File uploaded at */
  uploadedAt?: Maybe<Scalars['String']>;
  /** File url */
  url?: Maybe<Url>;
};

export type FilterDoDeliveryDate = {
  /** Shipment date filter by end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Shipment date filter by start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export enum FleetBodyType {
  Bak = 'BAK',
  BakAirGalon = 'BAK_AIR_GALON',
  BakLong = 'BAK_LONG',
  BlindVan = 'BLIND_VAN',
  Box = 'BOX',
  BoxLasah = 'BOX_LASAH',
  BoxPallet = 'BOX_PALLET',
  BoxReefer = 'BOX_REEFER',
  CarCarrier = 'CAR_CARRIER',
  Dump = 'DUMP',
  Jumbo = 'JUMBO',
  LongBox = 'LONG_BOX',
  LongReefer = 'LONG_REEFER',
  LosBak = 'LOS_BAK',
  MotorCarrierLong = 'MOTOR_CARRIER_LONG',
  Mpv = 'MPV',
  PintuSamping = 'PINTU_SAMPING',
  Reefer = 'REEFER',
  SelfLoader = 'SELF_LOADER',
  ThreeWay = 'THREE_WAY',
  Wingbox = 'WINGBOX',
  XlBox = 'XL_BOX'
}

export type FleetDetailsInput = {
  /** fleet brand */
  brand?: InputMaybe<Scalars['String']>;
  /** Machine CC */
  ccMesin?: InputMaybe<Scalars['String']>;
  /** Fleet driver By */
  drivenBy?: InputMaybe<DriverInput>;
  /** fleet color */
  fleetColor?: InputMaybe<Scalars['String']>;
  /** KIR */
  kir?: InputMaybe<Scalars['String']>;
  /** KIR Expiration date */
  kirExpirationDate?: InputMaybe<Scalars['String']>;
  /** Fleet's ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** fleet machine number */
  noMesin?: InputMaybe<Scalars['String']>;
  /** No Rangka */
  noRangka?: InputMaybe<Scalars['String']>;
  /** fleet plate color */
  plateColor?: InputMaybe<VehiclePlateType>;
  /** fleet plate number */
  plateNumber?: InputMaybe<Scalars['String']>;
  /** Production date */
  productionDate?: InputMaybe<Scalars['String']>;
  /** Replacement fleet end date */
  replacementFleetEndDate?: InputMaybe<Scalars['String']>;
  /** Replacement Fleet Plate number */
  replacementFleetPlate?: InputMaybe<Scalars['String']>;
  /** Replacement fleet start date */
  replacementFleetStartDate?: InputMaybe<Scalars['String']>;
  /** Tax expiration date */
  taxExpirationDate?: InputMaybe<Scalars['String']>;
};

export type FleetDetailsNode = {
  __typename?: 'FleetDetailsNode';
  /** fleet brand */
  brand?: Maybe<Scalars['String']>;
  /** Machine CC */
  ccMesin?: Maybe<Scalars['String']>;
  /** Fleet driver By */
  drivenBy?: Maybe<TpDriverNode>;
  /** fleet color */
  fleetColor?: Maybe<Scalars['String']>;
  /** KIR */
  kir?: Maybe<Scalars['String']>;
  /** KIR Expiration date */
  kirExpirationDate?: Maybe<Scalars['String']>;
  /** Fleet's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** fleet machine number */
  noMesin?: Maybe<Scalars['String']>;
  /** No Rangka */
  noRangka?: Maybe<Scalars['String']>;
  /** fleet plate color */
  plateColor?: Maybe<VehiclePlateType>;
  /** fleet plate number */
  plateNumber?: Maybe<Scalars['String']>;
  /** Production date */
  productionDate?: Maybe<Scalars['String']>;
  /** Replacement fleet end date */
  replacementFleetEndDate?: Maybe<Scalars['String']>;
  /** Replacement Fleet Plate number */
  replacementFleetPlate?: Maybe<Scalars['String']>;
  /** Replacement fleet start date */
  replacementFleetStartDate?: Maybe<Scalars['String']>;
  /** Tax expiration date */
  taxExpirationDate?: Maybe<Scalars['String']>;
};

export type FleetInput = {
  /** Fleet body type */
  fleetBodyType?: InputMaybe<FleetBodyType>;
  /** Fleet Details */
  fleetDetails?: InputMaybe<Array<InputMaybe<FleetDetailsInput>>>;
  /** Fleet Type */
  fleetType?: InputMaybe<FleetType>;
};

export enum FleetStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum FleetType {
  Cdd = 'CDD',
  Cde = 'CDE',
  Fuso = 'FUSO',
  L300 = 'L300',
  Motorcycle = 'MOTORCYCLE',
  Mpv = 'MPV',
  Pickup = 'PICKUP',
  Tronton = 'TRONTON',
  Van = 'VAN'
}

export enum InvoiceEntityEnum {
  Kos = 'KOS',
  Pbi = 'PBI',
  Pus = 'PUS',
  Tbk = 'TBK'
}

export type InvoiceableFee = {
  __typename?: 'InvoiceableFee';
  /** Invoiceable fee amount */
  amount?: Maybe<Scalars['Int']>;
  /** invoice fee ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** status */
  status?: Maybe<Scalars['String']>;
  /** Invoiceable fee type */
  type?: Maybe<InvoiceableFeeTypeEnum>;
};

export enum InvoiceableFeeTypeEnum {
  CodFee = 'COD_FEE',
  ShipmentFee = 'SHIPMENT_FEE'
}

export type JobNode = {
  __typename?: 'JobNode';
  /** Brokerage company ksuid */
  brokerageCompanyKsuid?: Maybe<Scalars['String']>;
  /** destination attribute */
  destination?: Maybe<Warehouse>;
  /** Destination address */
  destinationAddress?: Maybe<Scalars['String']>;
  /** Destination city */
  destinationCity?: Maybe<Scalars['String']>;
  /** Destination latitude */
  destinationGpsLat?: Maybe<Scalars['Float']>;
  /** Destination longitude */
  destinationGpsLng?: Maybe<Scalars['Float']>;
  /** Destination name */
  destinationName?: Maybe<Scalars['String']>;
  /** Destination ksuid */
  destinationWarehouseKsuid?: Maybe<Scalars['String']>;
  /** Delivery order number */
  doNumber?: Maybe<Scalars['String']>;
  /** Job number */
  jobNumber?: Maybe<Scalars['String']>;
  /** Job timestamp */
  jobTimestamp?: Maybe<JobTimestampType>;
  /** Job ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Job loading date */
  loadingDate?: Maybe<Scalars['String']>;
  /** Job loading date time */
  loadingDateTime?: Maybe<Scalars['String']>;
  /** Product's capacity node */
  loadsCapacity?: Maybe<LoadsCapacityNode>;
  /** origin attribute */
  origin?: Maybe<Warehouse>;
  /** Origin address */
  originAddress?: Maybe<Scalars['String']>;
  /** Origin city */
  originCity?: Maybe<Scalars['String']>;
  /** Origin latitude */
  originGpsLat?: Maybe<Scalars['Float']>;
  /** Origin longitude */
  originGpsLng?: Maybe<Scalars['Float']>;
  /** Origin name */
  originName?: Maybe<Scalars['String']>;
  /** Origin ksuid */
  originWarehouseKsuid?: Maybe<Scalars['String']>;
  /** Type of product that shipped */
  productType?: Maybe<Scalars['String']>;
  /** Job scope */
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Shipment of the job */
  shipment?: Maybe<ShipmentType>;
  /** Shipper company ksuid */
  shipperCompanyKsuid?: Maybe<Scalars['String']>;
  /** Delivery order status */
  status?: Maybe<Scalars['String']>;
  /** Transporter company ksuid */
  transporterCompanyKsuid?: Maybe<Scalars['String']>;
  /** Delivery order unloading date */
  unloadingDate?: Maybe<Scalars['String']>;
  /** Delviery order vehicle type id */
  vehicleTypeId?: Maybe<Scalars['String']>;
};

export type JobTimestampType = {
  __typename?: 'JobTimestampType';
  bidding?: Maybe<Scalars['String']>;
  cancelled?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['String']>;
  confirmationExpired?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['String']>;
  proceedToShipping?: Maybe<Scalars['String']>;
  rejectedByTransporter?: Maybe<Scalars['String']>;
  transporterConfirmed?: Maybe<Scalars['String']>;
  unassigned?: Maybe<Scalars['String']>;
  unfulfilled?: Maybe<Scalars['String']>;
  waitingForConfirmation?: Maybe<Scalars['String']>;
  waitingForTruckData?: Maybe<Scalars['String']>;
};

export type LoadsCapacityNode = {
  __typename?: 'LoadsCapacityNode';
  /** product load capacity */
  capacity?: Maybe<Scalars['Float']>;
  /** product load unit */
  unit?: Maybe<Scalars['String']>;
};

export type MdVehicleMasterNode = {
  __typename?: 'MDVehicleMasterNode';
  /** MDVehicle average speed */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** MDVehicle capacity */
  capacity?: Maybe<Scalars['String']>;
  /** MDVehicle dimension (in dam, multiply by 10 convert to meter) */
  dimension?: Maybe<Scalars['String']>;
  /** MDVehicle id */
  id: Scalars['String'];
  /** MDVehicle sub truct name */
  subTruckName?: Maybe<Scalars['String']>;
  /** MDVehicle sub truct type */
  subTruckType?: Maybe<Scalars['String']>;
  /** MDVehicle target */
  target?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** MDVehicle Type for vehicle */
  vehicleType?: Maybe<Scalars['String']>;
  /** MDVehicle Type name */
  vehicleTypeName?: Maybe<Scalars['String']>;
};

export type MdVehicleNode = {
  __typename?: 'MDVehicleNode';
  /** Master data vehicle's average_speed (in km/h) */
  averageSpeed?: Maybe<Scalars['Float']>;
  /** Master data vehicle's capacity in ton */
  capacity?: Maybe<Scalars['Float']>;
  /** Master data vehicle's height(in mm) */
  height?: Maybe<Scalars['Float']>;
  /** Master data vehicle's type ID */
  id?: Maybe<Scalars['String']>;
  /** Master data vehicle's length(in mm) */
  length?: Maybe<Scalars['Float']>;
  /** Master data vehicle's name */
  name?: Maybe<Scalars['String']>;
  /** Master data vehicle's sub truck type. E.g Wingbox */
  subType?: Maybe<Scalars['String']>;
  /** Master data vehicle's type. E.g CDD */
  type?: Maybe<Scalars['String']>;
  /** Master data vehicle's width(in mm) */
  width?: Maybe<Scalars['Float']>;
};

/** Represent master data city type */
export type MdCity = {
  __typename?: 'MdCity';
  /** City ID */
  id?: Maybe<Scalars['String']>;
  /** City Name */
  name?: Maybe<Scalars['String']>;
  /** Province of city */
  province?: Maybe<MdProvince>;
};

/** Represent master data district type */
export type MdDistrict = {
  __typename?: 'MdDistrict';
  /** City of district */
  city?: Maybe<MdCity>;
  /** District ID */
  id?: Maybe<Scalars['String']>;
  /** District Name */
  name?: Maybe<Scalars['String']>;
};

/** Represent master data province type */
export type MdProvince = {
  __typename?: 'MdProvince';
  /** Province ID */
  id?: Maybe<Scalars['String']>;
  /** Province Name */
  name?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Sync Shipper to Kargo Payment(UPI) */
  SyncShippersToKargoPayment?: Maybe<SyncResponse>;
  /** Payment statement link data */
  broadcastPaymentStatementByEmail?: Maybe<PaymentStatementNotification>;
  /** Broadcast WA Payment Statement Page */
  broadcastWAPaymentStatement?: Maybe<BroadcastWaPaymentStatementNode>;
  /** Correct delivery order derivatives data */
  correctDeliveryOrderData?: Maybe<Array<Maybe<CorrectDeliveryOrder>>>;
  /** Cron for payable item TIP amount */
  cronPayableItem?: Maybe<PayableItemNode>;
  /** Delete payable adjustment data */
  deletePayableAdjustment?: Maybe<DeleteResponse>;
  /** Sync delivery order to flynd via kafka */
  doSyncToKafka?: Maybe<Result>;
  /** Update Transporter Pipeline Status */
  duplicateTransporterPipeline?: Maybe<TransporterPipelineNode>;
  /** Upsert awb data */
  saveAwb?: Maybe<AwbNode>;
  /** Upsert contract */
  saveContract?: Maybe<ContractNode>;
  /** Update delivery order */
  saveDeliveryOrder?: Maybe<DeliveryOrder>;
  /** Create or Update Company Driver */
  saveDrivers?: Maybe<CompanyDriver>;
  /** Upsert payable data */
  savePayable?: Maybe<PayableNode>;
  /** Upsert/update payable adjustment data */
  savePayableAdjustment?: Maybe<PayableAdjustmentNode>;
  /** Upsert/update/delete payable file data */
  savePayableFile?: Maybe<PayableFileNode>;
  /** Upsert/update payable item data */
  savePayableItem?: Maybe<PayableItemNode>;
  /** Upsert project */
  saveProject?: Maybe<ProjectNode>;
  /** Project Cluster Migration */
  saveProjectCluster?: Maybe<ClusterProjectMigrationResponse>;
  /** Upsert shipper data */
  saveShipper?: Maybe<ShipperNode>;
  /** Upsert transporter data */
  saveTransporter?: Maybe<TransporterNode>;
  /** Save Transporter Pipeline */
  saveTransporterPipeline?: Maybe<TransporterPipelineNode>;
  /** Create or Update company vehicle */
  saveVehicle?: Maybe<CompanyVehicleNode>;
  /** Create warehouse */
  saveWarehouse?: Maybe<Warehouse>;
  /** Submit payables data */
  submitPayables?: Maybe<Array<Maybe<PayableKsuidNode>>>;
  /** Sync awb data to flynd */
  syncFlyndAwbs?: Maybe<SyncResponse>;
  /** Sync Company Driver to Flynd */
  syncFlyndDrivers?: Maybe<SyncResponse>;
  /** Sync Project to Flynd */
  syncFlyndProjects?: Maybe<SyncResponse>;
  /** Sync Shipper to Flynd */
  syncFlyndShippers?: Maybe<SyncResponse>;
  /** Sync transporter data to flynd */
  syncFlyndTransporters?: Maybe<SyncResponse>;
  /** Sync Vehicles to Flynd */
  syncFlyndVehicles?: Maybe<SyncResponse>;
  /** Sync Warehouse to Flynd */
  syncFlyndWarehouses?: Maybe<SyncResponse>;
  /** Upsert payable data */
  syncShipperPayable?: Maybe<Array<Maybe<PayableItemNode>>>;
  /** Update Transporter Pipeline Status */
  updateTransporterPipelineStatus?: Maybe<TransporterPipelineNode>;
};


export type MutationSyncShippersToKargoPaymentArgs = {
  first?: InputMaybe<Scalars['Int']>;
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type MutationBroadcastPaymentStatementByEmailArgs = {
  bccRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ccRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contractEndDate: Scalars['DateTime'];
  contractStartDate: Scalars['DateTime'];
  contractType: Scalars['String'];
  licensePlate: Scalars['String'];
  payableKsuid: Scalars['String'];
  paymentScheme: Scalars['String'];
  recipients: Array<InputMaybe<Scalars['String']>>;
  supplyType: Scalars['String'];
  transporterName: Scalars['String'];
  vehicleContractCode: Scalars['String'];
};


export type MutationBroadcastWaPaymentStatementArgs = {
  contractCode?: InputMaybe<Scalars['String']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transporterName?: InputMaybe<Scalars['String']>;
};


export type MutationCorrectDeliveryOrderDataArgs = {
  doExternalIDs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationCronPayableItemArgs = {
  currentTime?: InputMaybe<Scalars['String']>;
};


export type MutationDeletePayableAdjustmentArgs = {
  ksuid: Scalars['String'];
};


export type MutationDoSyncToKafkaArgs = {
  ksuid?: InputMaybe<Scalars['String']>;
};


export type MutationDuplicateTransporterPipelineArgs = {
  pipelineCode?: InputMaybe<Scalars['String']>;
};


export type MutationSaveAwbArgs = {
  actualCompleted?: InputMaybe<Scalars['DateTime']>;
  actualOvertimeHours?: InputMaybe<Scalars['Float']>;
  actualPricingUnit?: InputMaybe<Scalars['Float']>;
  awbId?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  codAmount?: InputMaybe<Scalars['Float']>;
  completeStatus?: InputMaybe<AwbCompleteStatusEnum>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrder?: InputMaybe<DeliveryOrderInput>;
  destination?: InputMaybe<WarehouseInputType>;
  destinationActionDatetime?: InputMaybe<Scalars['DateTime']>;
  dropOrder?: InputMaybe<Scalars['Int']>;
  earliestPossibleCompleted?: InputMaybe<Scalars['DateTime']>;
  eta?: InputMaybe<Scalars['DateTime']>;
  etaDestination?: InputMaybe<Scalars['DateTime']>;
  etd?: InputMaybe<Scalars['DateTime']>;
  etdDestination?: InputMaybe<Scalars['DateTime']>;
  incompleteReason?: InputMaybe<AwbIncompleteReason>;
  itemDetails?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  latestPossibleCompleted?: InputMaybe<Scalars['DateTime']>;
  loadingDateTime?: InputMaybe<Scalars['DateTime']>;
  orderReference?: InputMaybe<Scalars['String']>;
  originActionDatetime?: InputMaybe<Scalars['DateTime']>;
  originKsuid?: InputMaybe<Scalars['String']>;
  podUpload?: InputMaybe<Scalars['String']>;
  receiverName?: InputMaybe<Scalars['String']>;
  shipmentNotes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AwbStatusEnum>;
  taskId?: InputMaybe<Scalars['String']>;
  timestampStatus?: InputMaybe<Scalars['DateTime']>;
  tourId?: InputMaybe<Scalars['String']>;
};


export type MutationSaveContractArgs = {
  addendumOrTerminationLink?: InputMaybe<Scalars['String']>;
  agreementFile?: InputMaybe<Scalars['Upload']>;
  agreementFileLink?: InputMaybe<Scalars['String']>;
  agreementNumber?: InputMaybe<Scalars['String']>;
  agreementType?: InputMaybe<AgreementType>;
  ccNotes?: InputMaybe<Scalars['String']>;
  codFee?: InputMaybe<Scalars['Boolean']>;
  codFeeText?: InputMaybe<Scalars['String']>;
  codFlat?: InputMaybe<Scalars['Float']>;
  codPercentage?: InputMaybe<Scalars['Float']>;
  codType?: InputMaybe<ContractCodType>;
  dailyIncentivePrice?: InputMaybe<Scalars['Float']>;
  dailyRentalPrice?: InputMaybe<Scalars['Float']>;
  downtimeFee?: InputMaybe<Scalars['Float']>;
  driverAllocations?: InputMaybe<Array<InputMaybe<DriverAllocationInput>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  hasExtraHelper?: InputMaybe<Scalars['Boolean']>;
  includeTravelingExpenses?: InputMaybe<Scalars['Boolean']>;
  kargoEntity?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  numberOfDropPoint?: InputMaybe<Scalars['Int']>;
  numberOfTrip?: InputMaybe<Scalars['String']>;
  overtimeFee?: InputMaybe<Scalars['Float']>;
  paymentScheme?: InputMaybe<PaymentSchemeType>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  projectKsuid?: InputMaybe<Scalars['String']>;
  projectName?: InputMaybe<Scalars['String']>;
  schemeType?: InputMaybe<ContractSchemeType>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  supplyType?: InputMaybe<ContractSupplyType>;
  transporterKsuid?: InputMaybe<Scalars['String']>;
  transporterName?: InputMaybe<Scalars['String']>;
  travelingExpenses?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ContractType>;
  unfulfilledFee?: InputMaybe<Scalars['Float']>;
  vehicleAllocations?: InputMaybe<Array<InputMaybe<VehicleAllocationInput>>>;
  vehicleQuantity?: InputMaybe<Scalars['Int']>;
};


export type MutationSaveDeliveryOrderArgs = {
  actualOvertimeHours?: InputMaybe<Scalars['Float']>;
  actualPricingUnit?: InputMaybe<Scalars['Float']>;
  additionalTrip?: InputMaybe<Scalars['Boolean']>;
  additionalTripNotes?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  companyDriverKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleReplacementKsuid?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  discount?: InputMaybe<Scalars['Boolean']>;
  discountFlatValue?: InputMaybe<Scalars['Float']>;
  discountPercentageMaxAmount?: InputMaybe<Scalars['Float']>;
  discountPercentageValue?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<Scalars['String']>;
  doNumber?: InputMaybe<Scalars['String']>;
  driverNotes?: InputMaybe<Scalars['String']>;
  extraHelperAmount?: InputMaybe<Scalars['Int']>;
  extraHelperPrice?: InputMaybe<Scalars['Float']>;
  insuranceLoadValue?: InputMaybe<Scalars['Float']>;
  insurancePrice?: InputMaybe<Scalars['Float']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  isCancel?: InputMaybe<Scalars['Boolean']>;
  ksuid?: InputMaybe<Scalars['String']>;
  originActionDateTime?: InputMaybe<Scalars['DateTime']>;
  originKsuid?: InputMaybe<Scalars['String']>;
  plannedPricingUnit?: InputMaybe<Scalars['Float']>;
  podReturnAddress?: InputMaybe<Scalars['String']>;
  podReturnPrice?: InputMaybe<Scalars['Float']>;
  polUpload?: InputMaybe<Scalars['String']>;
  priceFinal?: InputMaybe<Scalars['Float']>;
  priceSuggestion?: InputMaybe<Scalars['Float']>;
  productType?: InputMaybe<DoProductTypeEnum>;
  projectKsuid?: InputMaybe<Scalars['String']>;
  shipmentStatus?: InputMaybe<DoShipmentStatuses>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperNotes?: InputMaybe<Scalars['String']>;
  transporterKsuid?: InputMaybe<Scalars['String']>;
  transporterPrice?: InputMaybe<Scalars['Float']>;
  transporterVehicleKsuid?: InputMaybe<Scalars['String']>;
};


export type MutationSaveDriversArgs = {
  companyKsuid?: InputMaybe<Scalars['String']>;
  contactNumber?: InputMaybe<Scalars['String']>;
  contractKsuid?: InputMaybe<Scalars['String']>;
  dedicatedToContract: Scalars['Boolean'];
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  driverLicenseExpiryDate?: InputMaybe<Scalars['String']>;
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  driverLicenseType?: InputMaybe<CompanyDriverLicenseType>;
  idCardNumber?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  verificationStatus?: InputMaybe<CompanyDriverVerificationStatusEnum>;
};


export type MutationSavePayableArgs = {
  holdReason?: InputMaybe<Scalars['String']>;
  isHoldDo?: InputMaybe<Scalars['Boolean']>;
  ksuid: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableReviewStatusEnum>;
};


export type MutationSavePayableAdjustmentArgs = {
  amount: Scalars['Int'];
  ksuid?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payableItemKsuid?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableAdjustmentReviewStatusEnum>;
  status?: InputMaybe<PayableAdjustmentStatusEnum>;
  typeName?: InputMaybe<PayableAdjustmentTypeEnum>;
};


export type MutationSavePayableFileArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationSavePayableItemArgs = {
  awb?: InputMaybe<PayableItemAwbInput>;
  awbKsuid?: InputMaybe<Scalars['String']>;
  dspUpload?: InputMaybe<Scalars['String']>;
  holdReason?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableItemReviewStatusEnum>;
  reviewStatusCategory?: InputMaybe<PayableItemReviewStatusCategoryEnum>;
  reviewStatusReason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableItemStatusEnum>;
};


export type MutationSaveProjectArgs = {
  capacity?: InputMaybe<Scalars['Float']>;
  capacityUnit?: InputMaybe<Scalars['String']>;
  cityName?: InputMaybe<Scalars['String']>;
  clusterId?: InputMaybe<Scalars['String']>;
  codFlat?: InputMaybe<Scalars['Float']>;
  codPercentage?: InputMaybe<Scalars['Float']>;
  codType?: InputMaybe<ProjectCodType>;
  enableTiering?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  fleetQuantity?: InputMaybe<Scalars['Int']>;
  ksuid?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  overtimeFee?: InputMaybe<Scalars['Float']>;
  paymentScheduleDay?: InputMaybe<Scalars['Int']>;
  paymentScheduleOffset?: InputMaybe<Scalars['Int']>;
  paymentScheduleTime?: InputMaybe<Scalars['String']>;
  paymentScheduleUsingWeekday?: InputMaybe<Scalars['Boolean']>;
  paymentWorkingDays?: InputMaybe<Array<InputMaybe<ProjectPaymentWorkingDays>>>;
  pricingScheme?: InputMaybe<ProjectPricingScheme>;
  projectBanks?: InputMaybe<Array<InputMaybe<ProjectBankInput>>>;
  projectVehicles?: InputMaybe<Array<InputMaybe<ProjectVehicleInput>>>;
  provinceName?: InputMaybe<Scalars['String']>;
  routeType?: InputMaybe<ProjectRouteType>;
  schemePrice?: InputMaybe<Scalars['Float']>;
  schemeUnit?: InputMaybe<ProjectSchemeUnit>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
  slaLatestDropTime?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  tierValue?: InputMaybe<Scalars['Float']>;
  tieredBy?: InputMaybe<ProjectTieredBy>;
  tkbmFee?: InputMaybe<Scalars['Float']>;
  totalWorkingDays?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ProjectType>;
  typeOfApp?: InputMaybe<TypeOfApp>;
  unitValue?: InputMaybe<Scalars['Float']>;
  vehicleId?: InputMaybe<Scalars['String']>;
};


export type MutationSaveProjectClusterArgs = {
  clusterId: Scalars['String'];
  ksuid: Scalars['String'];
};


export type MutationSaveShipperArgs = {
  address?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingGmapsLocation?: InputMaybe<Scalars['String']>;
  billingOfficeDistrict?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<CompanyPicInput>;
  contractUpload?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  gmapsLocation?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<ShipperIndustryEnum>;
  invoiceAttention?: InputMaybe<Scalars['String']>;
  invoiceCode?: InputMaybe<Scalars['String']>;
  invoiceDetails?: InputMaybe<Scalars['String']>;
  invoiceEntity?: InputMaybe<InvoiceEntityEnum>;
  invoiceReceiptDeadline?: InputMaybe<Scalars['String']>;
  invoiceReceiptSchedule?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officeDistrict?: InputMaybe<Scalars['String']>;
  paymentDays?: InputMaybe<Scalars['Int']>;
  paymentTerms?: InputMaybe<ShipperPaymentTerms>;
  postalCode?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  salesName?: InputMaybe<Scalars['String']>;
  salesStartDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<ShipperAccountType>;
};


export type MutationSaveTransporterArgs = {
  accountType?: InputMaybe<TransporterAccountType>;
  address?: InputMaybe<Scalars['String']>;
  bankAccountHolder?: InputMaybe<Scalars['String']>;
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankBranch?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<CompanyPicInput>;
  defaultPaymentScheme?: InputMaybe<TransporterDefaultPaymentScheme>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  gmapsLocation?: InputMaybe<Scalars['String']>;
  initial?: InputMaybe<Scalars['String']>;
  insuranceActive?: InputMaybe<Scalars['Boolean']>;
  insuranceEndDate?: InputMaybe<Scalars['DateTime']>;
  insuranceStartDate?: InputMaybe<Scalars['DateTime']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officeDistrict?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  skbOwnership?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  taxVat?: InputMaybe<Scalars['Float']>;
  taxWht?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<TransporterType>;
};


export type MutationSaveTransporterPipelineArgs = {
  addendumOrTerminationLink?: InputMaybe<Scalars['String']>;
  adminName?: InputMaybe<Scalars['String']>;
  agreementNumber?: InputMaybe<Scalars['String']>;
  agreementType?: InputMaybe<AgreementType>;
  approvalCode?: InputMaybe<Scalars['String']>;
  areaCoverage?: InputMaybe<Scalars['String']>;
  bdName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cluster?: InputMaybe<Scalars['String']>;
  codServices?: InputMaybe<Scalars['Boolean']>;
  contractType?: InputMaybe<ContractType>;
  drivers?: InputMaybe<Array<InputMaybe<DriverInput>>>;
  duplicatedFrom?: InputMaybe<Scalars['String']>;
  fleet?: InputMaybe<FleetInput>;
  id?: InputMaybe<Scalars['String']>;
  kargoEntity?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  numberOfTrip?: InputMaybe<Scalars['String']>;
  paymentScheme?: InputMaybe<PaymentSchemeType>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ProjectInput>;
  proofOfSigning?: InputMaybe<Scalars['String']>;
  routePriceDetails?: InputMaybe<Array<InputMaybe<RoutePriceDetail>>>;
  shipper?: InputMaybe<ShipperInput>;
  source?: InputMaybe<Source>;
  status?: InputMaybe<PipelineStatus>;
  statusTimestamp?: InputMaybe<Scalars['String']>;
  supplyType?: InputMaybe<ContractSupplyType>;
  transporter?: InputMaybe<TransporterInput>;
};


export type MutationSaveVehicleArgs = {
  bodyType?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Float']>;
  capacityUnit?: InputMaybe<CapacityUnitEnum>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  contractKsuid?: InputMaybe<Scalars['String']>;
  dedicatedToContract?: InputMaybe<Scalars['Boolean']>;
  dimension?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  height?: InputMaybe<Scalars['Float']>;
  ksuid?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Float']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  vehiclePlateType?: InputMaybe<VehiclePlateType>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};


export type MutationSaveWarehouseArgs = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  coordinate?: InputMaybe<CoordinateInput>;
  country?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  googleMapUrl?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  operatingHoursData?: InputMaybe<Array<InputMaybe<WarehouseOperatingHourInput>>>;
  picName?: InputMaybe<Scalars['String']>;
  picTelephone?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<WarehouseStatusEnum>;
  type?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitPayablesArgs = {
  grandTotal?: InputMaybe<Scalars['Float']>;
  ksuids: Array<InputMaybe<Scalars['String']>>;
  reviewStatus: PayableSubmitReviewStatusEnum;
};


export type MutationSyncFlyndAwbsArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndDriversArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndProjectsArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndShippersArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndTransportersArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndVehiclesArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncFlyndWarehousesArgs = {
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationSyncShipperPayableArgs = {
  ksuid: Scalars['String'];
};


export type MutationUpdateTransporterPipelineStatusArgs = {
  notes?: InputMaybe<Scalars['String']>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PipelineStatus>;
};

export enum PkpStatusEnum {
  NonPkp = 'NON_PKP',
  Pkp = 'PKP'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedContracts = {
  __typename?: 'PaginatedContracts';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedContractsEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedContractsEdge = {
  __typename?: 'PaginatedContractsEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContractNode>;
};

export enum PayableAdjustmentReviewStatusEnum {
  Disbursed = 'DISBURSED',
  DisbursementFailed = 'DISBURSEMENT_FAILED',
  FinanceApproved = 'FINANCE_APPROVED',
  FinanceCancelled = 'FINANCE_CANCELLED',
  FinanceOnHold = 'FINANCE_ON_HOLD',
  Hold = 'HOLD',
  NeedsReview = 'NEEDS_REVIEW',
  NotDue = 'NOT_DUE',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  RequestApproved = 'REQUEST_APPROVED',
  RequestSent = 'REQUEST_SENT',
  Reviewed = 'REVIEWED'
}

export enum PayableAdjustmentStatusEnum {
  Approve = 'APPROVE',
  Hold = 'HOLD'
}

export enum PayableAdjustmentTypeEnum {
  Claims = 'CLAIMS',
  ContractTermination = 'CONTRACT_TERMINATION',
  Downtime = 'DOWNTIME',
  FinalAmount = 'FINAL_AMOUNT',
  Insurance = 'INSURANCE',
  Other = 'OTHER',
  Penalty = 'PENALTY',
  Price = 'PRICE',
  Unfulfilled = 'UNFULFILLED'
}

export type PayableCountSummary = {
  __typename?: 'PayableCountSummary';
  /** Total data payables filter by review_status */
  count?: Maybe<Scalars['Int']>;
  /** due_status of payables ex: NOT_DUE */
  dueStatus?: Maybe<Scalars['String']>;
  /** review_status of payables ex: ARRIVED_AT_HUB */
  reviewStatus?: Maybe<Scalars['String']>;
};

export enum PayableDateFilterEnum {
  PaymentSchedule = 'PAYMENT_SCHEDULE',
  ShipmentDate = 'SHIPMENT_DATE'
}

export type PayableDoSummaryNode = {
  __typename?: 'PayableDoSummaryNode';
  /** Days summary data */
  daysSummary?: Maybe<DaysSummary>;
  /** List of DO */
  doList?: Maybe<Array<Maybe<DoSnapshot>>>;
};

export type PayableItemAwbInput = {
  /** Actual collected COD amount */
  collectedCodAmount?: InputMaybe<Scalars['Int']>;
};

export enum PayableItemReviewStatusCategoryEnum {
  ContractTermination = 'CONTRACT_TERMINATION',
  DeductFromTip = 'DEDUCT_FROM_TIP',
  InvoiceSent = 'INVOICE_SENT',
  NeedMoreInformation = 'NEED_MORE_INFORMATION',
  NotExceed_13Days = 'NOT_EXCEED_13_DAYS',
  NotYetPaymentSchedule = 'NOT_YET_PAYMENT_SCHEDULE',
  NoTip = 'NO_TIP',
  Other = 'OTHER',
  WaitingInvoiceRevision = 'WAITING_INVOICE_REVISION'
}

export enum PayableItemReviewStatusEnum {
  Cancelled = 'CANCELLED',
  Disbursed = 'DISBURSED',
  DisbursementFailed = 'DISBURSEMENT_FAILED',
  FinanceApproved = 'FINANCE_APPROVED',
  FinanceCancelled = 'FINANCE_CANCELLED',
  FinanceOnHold = 'FINANCE_ON_HOLD',
  Hold = 'HOLD',
  NeedsReview = 'NEEDS_REVIEW',
  NotDue = 'NOT_DUE',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  RequestApproved = 'REQUEST_APPROVED',
  RequestSent = 'REQUEST_SENT',
  Reviewed = 'REVIEWED'
}

export enum PayableItemStatusEnum {
  Approve = 'APPROVE',
  Cancelled = 'CANCELLED',
  DisbursedToShipper = 'DISBURSED_TO_SHIPPER',
  Hold = 'HOLD',
  SecondAttempt = 'SECOND_ATTEMPT'
}

export type PayableKsuidNode = {
  __typename?: 'PayableKsuidNode';
  /** Payable ksuid */
  ksuid?: Maybe<Scalars['String']>;
};

export type PayableNode = {
  __typename?: 'PayableNode';
  /** Payable amount (for transporter payable) */
  amount?: Maybe<Scalars['Float']>;
  /** Payable collected amount */
  collectedAmount?: Maybe<Scalars['Decimal']>;
  /** Payable's contract detail */
  contract?: Maybe<ContractNode>;
  /** Payable's contract ksuid */
  contractKsuid?: Maybe<Scalars['String']>;
  /** Payable's delivery order detail */
  deliveryOrder?: Maybe<DeliveryOrder>;
  /** Payable's delivery order ksuid */
  deliveryOrderKsuid?: Maybe<Scalars['String']>;
  /** Payable's due status */
  dueStatus?: Maybe<Scalars['String']>;
  /** Payable expected amount */
  expectedAmount?: Maybe<Scalars['Decimal']>;
  /** Payable hold reason */
  holdReason?: Maybe<Scalars['String']>;
  /** Payable ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Payable's next review status */
  nextReviewStatus?: Maybe<Scalars['String']>;
  /** Payable notes */
  notes?: Maybe<Scalars['String']>;
  /** Payable's adjustments */
  payableAdjustments?: Maybe<Array<Maybe<PayableAdjustmentNode>>>;
  /** Payable's adjustments */
  payableFiles?: Maybe<Array<Maybe<PayableFileNode>>>;
  /** Payable's items detail */
  payableItems?: Maybe<Array<Maybe<PayableItemNode>>>;
  /** Payable payment request status */
  paymentRequestStatus?: Maybe<Scalars['String']>;
  /** Payable payment schedule */
  paymentSchedule?: Maybe<Scalars['String']>;
  /** Current payable payment stage (for transporter payable) */
  paymentStageCurrent?: Maybe<Scalars['Int']>;
  /** Payable's pod from latest delivered destination */
  podUpload?: Maybe<Scalars['String']>;
  /** Payable pot link */
  potUpload?: Maybe<Scalars['String']>;
  /** Payable's project detail */
  project?: Maybe<ProjectNode>;
  /** Payable's project ksuid */
  projectKsuid?: Maybe<Scalars['String']>;
  /** Payable review status */
  reviewStatus?: Maybe<Scalars['String']>;
  /** Payable's shipper detail */
  shipper?: Maybe<CompanyNode>;
  /** Payable's shipper ksuid */
  shipperKsuid?: Maybe<Scalars['String']>;
  /** Payable's transporter detail */
  transporter?: Maybe<TransporterNode>;
  /** Payable's transporter ksuid */
  transporterKsuid?: Maybe<Scalars['String']>;
  /** Payable type */
  type?: Maybe<Scalars['String']>;
  /** Payable latest updated */
  updatedAt?: Maybe<Scalars['String']>;
  /** Payable's vehicle allocation detail */
  vehicleAllocation?: Maybe<VehicleAllocationNode>;
  /** Payable's vehicle contract code */
  vehicleContractCode?: Maybe<Scalars['String']>;
};

export enum PayablePaymentSchemeEnum {
  PaymentScheme_25_25_25_25 = 'PAYMENT_SCHEME_25_25_25_25',
  PaymentScheme_50_50 = 'PAYMENT_SCHEME_50_50',
  PaymentScheme_50_50Tip = 'PAYMENT_SCHEME_50_50_TIP',
  PaymentScheme_100 = 'PAYMENT_SCHEME_100'
}

export enum PayableReviewStatusEnum {
  ArrivedAtHub = 'ARRIVED_AT_HUB',
  Cancelled = 'CANCELLED',
  Disbursed = 'DISBURSED',
  DisbursementFailed = 'DISBURSEMENT_FAILED',
  FinanceApproved = 'FINANCE_APPROVED',
  FinanceCancelled = 'FINANCE_CANCELLED',
  FinanceOnHold = 'FINANCE_ON_HOLD',
  Hold = 'HOLD',
  NeedsReview = 'NEEDS_REVIEW',
  NotDue = 'NOT_DUE',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  Reviewed = 'REVIEWED'
}

export enum PayableSortEnum {
  CollectedAmount = 'COLLECTED_AMOUNT',
  ExpectedAmount = 'EXPECTED_AMOUNT',
  PaymentSchedule = 'PAYMENT_SCHEDULE',
  PaymentStage = 'PAYMENT_STAGE',
  PotUpload = 'POT_UPLOAD',
  ReviewStatus = 'REVIEW_STATUS',
  ShipmentDate = 'SHIPMENT_DATE',
  Type = 'TYPE',
  VehicleContractCode = 'VEHICLE_CONTRACT_CODE'
}

export enum PayableSubmitReviewStatusEnum {
  NeedsReview = 'NEEDS_REVIEW',
  Reviewed = 'REVIEWED'
}

export type PayableSummary = {
  __typename?: 'PayableSummary';
  /** The summary data */
  amount?: Maybe<Scalars['Decimal']>;
  /** The type of summary data, ex: TOTAL_REQUESTED_AMOUNT */
  type?: Maybe<Scalars['String']>;
};

export enum PayableTypeEnum {
  ShipperPayable = 'SHIPPER_PAYABLE',
  TransporterDedicated = 'TRANSPORTER_DEDICATED',
  TransporterOnCall = 'TRANSPORTER_ON_CALL'
}

export enum PaymentSchemeType {
  PaymentScheme_25_25_25_25 = 'PAYMENT_SCHEME_25_25_25_25',
  PaymentScheme_50_50 = 'PAYMENT_SCHEME_50_50',
  PaymentScheme_50_50Tip = 'PAYMENT_SCHEME_50_50_TIP',
  PaymentScheme_100 = 'PAYMENT_SCHEME_100'
}

export enum PipelineSortEnum {
  AccountType = 'ACCOUNT_TYPE',
  AdminName = 'ADMIN_NAME',
  ApprovalCode = 'APPROVAL_CODE',
  AreaCoverage = 'AREA_COVERAGE',
  BdName = 'BD_NAME',
  City = 'CITY',
  Cluster = 'CLUSTER',
  ContractType = 'CONTRACT_TYPE',
  DriverName = 'DRIVER_NAME',
  DriverPhoneNumber = 'DRIVER_PHONE_NUMBER',
  FleetBodyType = 'FLEET_BODY_TYPE',
  FleetPlateNumber = 'FLEET_PLATE_NUMBER',
  FleetType = 'FLEET_TYPE',
  Name = 'NAME',
  NeedCoordinator = 'NEED_COORDINATOR',
  OnBoarded = 'ON_BOARDED',
  PipelineCode = 'PIPELINE_CODE',
  PipelineId = 'PIPELINE_ID',
  PipelineStatus = 'PIPELINE_STATUS',
  ProjectCode = 'PROJECT_CODE',
  SupplyType = 'SUPPLY_TYPE',
  TransporterName = 'TRANSPORTER_NAME',
  TransporterType = 'TRANSPORTER_TYPE'
}

export enum PipelineStatus {
  AgreementCreated = 'AGREEMENT_CREATED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  NeedsMoreInfo = 'NEEDS_MORE_INFO',
  NeedsReview = 'NEEDS_REVIEW',
  SentToLegal = 'SENT_TO_LEGAL',
  SentToTransporter = 'SENT_TO_TRANSPORTER',
  TransporterContacted = 'TRANSPORTER_CONTACTED',
  TransporterSigned = 'TRANSPORTER_SIGNED',
  Verified = 'VERIFIED',
  Voided = 'VOIDED'
}

export type ProjectBankInput = {
  /** Project's bank account name */
  accountName?: InputMaybe<Scalars['String']>;
  /** Project's bank account number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Project's bank branch */
  branch?: InputMaybe<Scalars['String']>;
  /** Project's bank name */
  name?: InputMaybe<Scalars['String']>;
};

export type ProjectBankNode = {
  __typename?: 'ProjectBankNode';
  /** Project's bank account name */
  accountName?: Maybe<Scalars['String']>;
  /** Project's bank account number */
  accountNumber?: Maybe<Scalars['String']>;
  /** Project's bank details */
  bank?: Maybe<BankNode>;
  /** Project's bank branch */
  branch?: Maybe<Scalars['String']>;
  /** Project's bank internal code */
  internalCode?: Maybe<Scalars['String']>;
  /** Project's bank name */
  name?: Maybe<Scalars['String']>;
};

export enum ProjectCodType {
  Flat = 'FLAT',
  Percentage = 'PERCENTAGE'
}

export type ProjectInput = {
  /** Project alias */
  alias?: InputMaybe<Scalars['String']>;
  /** Project's code */
  code?: InputMaybe<Scalars['String']>;
  /** Project ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Project name */
  name?: InputMaybe<Scalars['String']>;
};

export type ProjectNode = {
  __typename?: 'ProjectNode';
  /** will be deprecated */
  capacity?: Maybe<Scalars['Float']>;
  /** will be deprecated */
  capacityUnit?: Maybe<Scalars['String']>;
  /** Project's city details */
  city?: Maybe<CityNode>;
  /** Project's cluster */
  clusterId?: Maybe<Scalars['String']>;
  /** Project's cod fee */
  codFee?: Maybe<Scalars['Boolean']>;
  /** Project's cod flat value */
  codFlat?: Maybe<Scalars['Float']>;
  /** Project's cod percentage value */
  codPercentage?: Maybe<Scalars['Float']>;
  /** Project's cod type */
  codType?: Maybe<Scalars['String']>;
  /** Project end date to active */
  endDate?: Maybe<Scalars['String']>;
  /** Project's Fleet Quantity  */
  fleetQuantity?: Maybe<Scalars['Int']>;
  /** Project's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Minimum value for pricing scheme */
  minValue?: Maybe<Scalars['Float']>;
  /** Project name */
  name?: Maybe<Scalars['String']>;
  /** Project's overtime fee */
  overtimeFee?: Maybe<Scalars['Float']>;
  /** Payment schedule of shipper */
  paymentScheduleDays?: Maybe<Scalars['String']>;
  /** Day of payment offset in numbers */
  paymentScheduleOffset?: Maybe<Scalars['Int']>;
  /** Time of payment schedule in seconds */
  paymentScheduleTime?: Maybe<Scalars['String']>;
  /** Payment schedule using weekday or not */
  paymentScheduleUsingWeekday?: Maybe<Scalars['Boolean']>;
  /** Working days of shipper */
  paymentWorkingDays?: Maybe<Scalars['String']>;
  /** Project's pricing scheme */
  pricingScheme?: Maybe<Scalars['String']>;
  /** Project's bank list */
  projectBanks?: Maybe<Array<Maybe<ProjectBankNode>>>;
  /** Project Vehicle list */
  projectVehicles?: Maybe<Array<Maybe<ProjectVehicleNode>>>;
  /** Project's province details */
  province?: Maybe<ProvinceNode>;
  /** Project's route type */
  routeType?: Maybe<Scalars['String']>;
  /** Project's pricing scheme price */
  schemePrice?: Maybe<Scalars['Float']>;
  /** Project's pricing scheme unit */
  schemeUnit?: Maybe<Scalars['String']>;
  /** Project of Shipper Company's ksuid */
  shipper?: Maybe<CompanyNode>;
  /** Project's SLA Latest Drop Time */
  slaLatestDropTime?: Maybe<Scalars['String']>;
  /** Project start date to active */
  startDate?: Maybe<Scalars['String']>;
  /** Project's status */
  status?: Maybe<Scalars['String']>;
  /** Project's pricing scheme tier value */
  tierValue?: Maybe<Scalars['Float']>;
  /** Project's pricing scheme tiered category */
  tieredBy?: Maybe<Scalars['String']>;
  /** Project's Total working days */
  totalWorkingDays?: Maybe<Scalars['Float']>;
  /** Project type */
  type?: Maybe<Scalars['String']>;
  /** Project's type of app integration */
  typeOfApp?: Maybe<Scalars['String']>;
  /** Project's pricing scheme unit */
  unitValue?: Maybe<Scalars['Float']>;
  /** will be deprecated */
  vehicle?: Maybe<MdVehicleMasterNode>;
};

export enum ProjectPaymentWorkingDays {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum ProjectPricingScheme {
  PerCbm = 'PER_CBM',
  PerDropPoint = 'PER_DROP_POINT',
  PerKm = 'PER_KM',
  PerLoad = 'PER_LOAD',
  PerOrder = 'PER_ORDER',
  PerRoute = 'PER_ROUTE',
  Rental = 'RENTAL'
}

export enum ProjectRouteType {
  Multidrop = 'MULTIDROP',
  Multipickup = 'MULTIPICKUP',
  MultipickupMultidrop = 'MULTIPICKUP_MULTIDROP',
  Single = 'SINGLE'
}

export enum ProjectSchemeUnit {
  Cbm = 'CBM',
  Daily = 'DAILY',
  Drop = 'DROP',
  Kg = 'KG',
  Km = 'KM',
  Monthly = 'MONTHLY',
  Order = 'ORDER',
  Route = 'ROUTE',
  Weekday = 'WEEKDAY',
  Weekend = 'WEEKEND'
}

export enum ProjectSchemeUnitFilter {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export enum ProjectSortBy {
  CodFlat = 'COD_FLAT',
  CodPercentage = 'COD_PERCENTAGE',
  CodType = 'COD_TYPE',
  EndDate = 'END_DATE',
  Name = 'NAME',
  OvertimeFee = 'OVERTIME_FEE',
  PricingScheme = 'PRICING_SCHEME',
  RouteType = 'ROUTE_TYPE',
  SchemePrice = 'SCHEME_PRICE',
  SchemeUnit = 'SCHEME_UNIT',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TieredBy = 'TIERED_BY',
  TierValue = 'TIER_VALUE',
  Type = 'TYPE',
  UnitValue = 'UNIT_VALUE',
  VehicleCapacityNumber = 'VEHICLE_CAPACITY_NUMBER',
  VehicleCapacityUnit = 'VEHICLE_CAPACITY_UNIT'
}

export enum ProjectStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum ProjectTieredBy {
  Drop = 'DROP',
  Kg = 'KG',
  Km = 'KM'
}

export enum ProjectType {
  Dedicated = 'DEDICATED',
  Oncall = 'ONCALL'
}

export type ProjectVehicleInput = {
  /** Project's vehicle capacity */
  capacity?: InputMaybe<Scalars['Float']>;
  /** Project's vehicle capacity */
  capacityUnit?: InputMaybe<Scalars['String']>;
  /** Project's vehicles requirement id */
  vehicleId?: InputMaybe<Scalars['String']>;
};

export type ProjectVehicleNode = {
  __typename?: 'ProjectVehicleNode';
  /** Project's vehicle capacity */
  capacity?: Maybe<Scalars['Float']>;
  /** Project's vehicle capacity */
  capacityUnit?: Maybe<Scalars['String']>;
  /** Project's vehicles requirement */
  vehicle?: Maybe<MdVehicleMasterNode>;
};

export type ProvinceNode = {
  __typename?: 'ProvinceNode';
  /** Province Id */
  id?: Maybe<Scalars['String']>;
  /** Province name */
  name?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get user for current logged in user */
  MyUser?: Maybe<User>;
  /** Get list of master data vehicle */
  allMDVehicle?: Maybe<Array<Maybe<MdVehicleMasterNode>>>;
  /** Get audit Event */
  auditEvents?: Maybe<Array<Maybe<EventNode>>>;
  /** Get detail of awb */
  awbDetails?: Maybe<AwbNode>;
  /** Get DO detail */
  deliveryOrderDetails?: Maybe<DeliveryOrder>;
  /** Get Driver detail */
  driverDetails?: Maybe<CompanyDriver>;
  /** Get paginated list of awb */
  paginatedAwbs?: Maybe<PaginatedAwbs>;
  /** Get paginated list of contract */
  paginatedContracts?: Maybe<PaginatedContracts>;
  /** Get list of DO */
  paginatedDeliveryOrders?: Maybe<DeliveryOrderConnection>;
  /** Get paginated list of dispatch groups */
  paginatedDispatchGroups?: Maybe<PaginatedDispatchGroups>;
  /** Get list of Driver */
  paginatedDrivers?: Maybe<DriverConnection>;
  /** Get paginated list of payable file */
  paginatedPayableFiles?: Maybe<PaginatedPayableFiles>;
  /** Get paginated list of payable */
  paginatedPayables?: Maybe<PaginatedPayables>;
  /** Get paginated list of projects */
  paginatedProjects?: Maybe<PaginatedProjects>;
  /** Get paginated list of receiveable */
  paginatedReceivables?: Maybe<PaginatedReceivables>;
  /** Get paginated list of shipper */
  paginatedShippers?: Maybe<PaginatedShippers>;
  /** Get paginated list pipeline */
  paginatedTransporterPipelines?: Maybe<PaginatedTransporterPipelines>;
  /** Get paginated list of transporter */
  paginatedTransporters?: Maybe<PaginatedTransporters>;
  /** Get list of company vehicle */
  paginatedVehicles?: Maybe<PaginatedVehicles>;
  /** Get list of warehouse */
  paginatedWarehouses?: Maybe<WarehouseConnection>;
  /** Get count data each payables by filter */
  payableCountSummary?: Maybe<Array<Maybe<PayableCountSummary>>>;
  /** Get payable DO summary data */
  payableDoSummary?: Maybe<PayableDoSummaryNode>;
  /** Get payable summary data */
  payableSummary?: Maybe<Array<Maybe<PayableSummary>>>;
  /** Return all data needed for payment */
  paymentStatementPage?: Maybe<PaymentStatementPageNode>;
  /** Return all data needed for payment */
  paymentStatementPagePublic?: Maybe<PaymentStatementPageNode>;
  /** Review Payable Item */
  reviewPayableItem?: Maybe<ReviewPayableItemNode>;
  /** Get detail of shipper */
  shipperDetails?: Maybe<ShipperNode>;
  /** Get transporter detail */
  transporterDetail?: Maybe<TransporterNode>;
  /** Get detail of transporter pipeline */
  transporterPipelineDetails?: Maybe<TransporterPipelineNode>;
  /** Get vehicle details */
  vehicleDetails?: Maybe<CompanyVehicleNode>;
  /** Get warehouse details */
  warehouseDetails?: Maybe<Warehouse>;
};


export type QueryAllMdVehicleArgs = {
  ksuid?: InputMaybe<Scalars['String']>;
  subTruckType?: InputMaybe<Scalars['String']>;
  target?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  vehicleType?: InputMaybe<Scalars['String']>;
};


export type QueryAuditEventsArgs = {
  resourceKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAwbDetailsArgs = {
  ksuid: Scalars['String'];
};


export type QueryDeliveryOrderDetailsArgs = {
  ksuid?: InputMaybe<Scalars['String']>;
};


export type QueryDriverDetailsArgs = {
  ksuid: Scalars['String'];
};


export type QueryPaginatedAwbsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchAwbId?: InputMaybe<Scalars['String']>;
  searchCancelReason?: InputMaybe<Scalars['String']>;
  searchCompleteStatuses?: InputMaybe<Array<InputMaybe<AwbCompleteStatusEnum>>>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDestinationCity?: InputMaybe<Scalars['String']>;
  searchDestinationName?: InputMaybe<Scalars['String']>;
  searchDestinationPhone?: InputMaybe<Scalars['String']>;
  searchDestinationZipcode?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchDriverId?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchIncompleteReasons?: InputMaybe<Array<InputMaybe<AwbIncompleteReason>>>;
  searchItemDetails?: InputMaybe<Scalars['String']>;
  searchOriginName?: InputMaybe<Scalars['String']>;
  searchPodUpload?: InputMaybe<Scalars['String']>;
  searchPolUpload?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTaskId?: InputMaybe<Scalars['String']>;
  searchTourId?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleId?: InputMaybe<Scalars['String']>;
  searchVehicleLicensePlate?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<AwbSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  statuses?: InputMaybe<Array<InputMaybe<AwbStatusEnum>>>;
};


export type QueryPaginatedContractsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  endDateLessThan?: InputMaybe<Scalars['DateTime']>;
  endDateMoreThan?: InputMaybe<Scalars['DateTime']>;
  filterByAgreementTypes?: InputMaybe<Array<InputMaybe<AgreementType>>>;
  filterByCodFees?: InputMaybe<Array<InputMaybe<ContractCodFee>>>;
  filterByCodTypes?: InputMaybe<Array<InputMaybe<ProjectCodType>>>;
  filterByExtraHelpers?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  filterByPaymentSchemes?: InputMaybe<Array<InputMaybe<PaymentSchemeType>>>;
  filterBySchemeTypes?: InputMaybe<Array<InputMaybe<ContractSchemeType>>>;
  filterByStatuses?: InputMaybe<Array<InputMaybe<Status>>>;
  filterBySupplyTypes?: InputMaybe<Array<InputMaybe<ContractSupplyType>>>;
  filterByTypes?: InputMaybe<Array<InputMaybe<ContractType>>>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchAgreementNumber?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDriverKsuid?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchKsuid?: InputMaybe<Scalars['String']>;
  searchPipelineCode?: InputMaybe<Scalars['String']>;
  searchProjectKsuid?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchShipperKsuid?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTransporterKsuid?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
  searchVehicleKsuid?: InputMaybe<Scalars['String']>;
  searchVehiclePlate?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ContractSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedDeliveryOrdersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<Scalars['Int']>;
  searchAllocationStatus?: InputMaybe<Array<InputMaybe<DoAllocationStatuses>>>;
  searchCancelReason?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDeliveryDate?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchDriverId?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchLicensePlateNumber?: InputMaybe<Scalars['String']>;
  searchPricingSchemes?: InputMaybe<Array<InputMaybe<DoPricingScheme>>>;
  searchProjectId?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchShipmentDate?: InputMaybe<FilterDoDeliveryDate>;
  searchShipmentStatus?: InputMaybe<Array<InputMaybe<DoShipmentStatuses>>>;
  searchShipperId?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTourId?: InputMaybe<Scalars['String']>;
  searchTransporterId?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<DoSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedDispatchGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterByContractType?: InputMaybe<Array<InputMaybe<ContractType>>>;
  filterByShipmentDate?: InputMaybe<Scalars['DateTime']>;
  filterBySupplyType?: InputMaybe<Array<InputMaybe<ContractSupplyType>>>;
  filterByTransporterType?: InputMaybe<Array<InputMaybe<TransporterType>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchPaymentStage?: InputMaybe<Scalars['String']>;
  searchPotUpload?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchReviewStatus?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
};


export type QueryPaginatedDriversArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  projectKsuid?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchContractKsuid?: InputMaybe<Scalars['String']>;
  searchDedicatedToContract?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  searchDriverDocument?: InputMaybe<Array<InputMaybe<DriverDocumentType>>>;
  searchDriverKsuid?: InputMaybe<Scalars['String']>;
  searchDriverLicenseNumber?: InputMaybe<Scalars['String']>;
  searchDriverLicenseType?: InputMaybe<Array<InputMaybe<DriverLicenseType>>>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchDriverPhoneNumber?: InputMaybe<Scalars['String']>;
  searchDriverStatus?: InputMaybe<Array<InputMaybe<DriverStatus>>>;
  searchTransporterKsuid?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<CompanyDriverSortByEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  withContractActiveOnDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryPaginatedPayableFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  payableKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPaginatedPayablesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dueStatuses?: InputMaybe<Array<InputMaybe<DueStatusEnum>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  filterByPaymentSchemes?: InputMaybe<Array<InputMaybe<PayablePaymentSchemeEnum>>>;
  filterByPaymentStages?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  filterBySupplyType?: InputMaybe<Array<InputMaybe<SupplyTypeEnum>>>;
  filterDateBy?: InputMaybe<PayableDateFilterEnum>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  paymentRequestStatuses?: InputMaybe<Array<InputMaybe<PayablePaymentRequestStatusEnum>>>;
  pkpStatuses?: InputMaybe<Array<InputMaybe<PkpStatusEnum>>>;
  reviewStatuses?: InputMaybe<Array<InputMaybe<PayableReviewStatusEnum>>>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchPaymentStage?: InputMaybe<Scalars['String']>;
  searchPotUpload?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchReviewStatus?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<PayableSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<PayableTypeEnum>>>;
};


export type QueryPaginatedProjectsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  filterByCodType?: InputMaybe<Array<InputMaybe<ProjectCodType>>>;
  filterByRouteType?: InputMaybe<Array<InputMaybe<ProjectRouteType>>>;
  filterByStatus?: InputMaybe<Array<InputMaybe<ProjectStatus>>>;
  filterByTieringState?: InputMaybe<Scalars['Boolean']>;
  filterByType?: InputMaybe<Array<InputMaybe<ProjectType>>>;
  filterByVehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchCodType?: InputMaybe<Scalars['String']>;
  searchFleetCapacity?: InputMaybe<Scalars['Float']>;
  searchKsuid?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
  searchPricingScheme?: InputMaybe<Scalars['String']>;
  searchRouteType?: InputMaybe<Scalars['String']>;
  searchSchemeUnit?: InputMaybe<Scalars['String']>;
  searchShipperKsuid?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchStatus?: InputMaybe<Scalars['String']>;
  searchTieredBy?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ProjectSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedReceivablesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  doDeliveryDateRange?: InputMaybe<DoDeliveryDateRange>;
  endProjectEndDate?: InputMaybe<Scalars['DateTime']>;
  endProjectStartDate?: InputMaybe<Scalars['DateTime']>;
  filterDeliveryOrderNumber?: InputMaybe<Scalars['String']>;
  filterProjectPricingSchemeUnits?: InputMaybe<Array<InputMaybe<ProjectSchemeUnitFilter>>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  projectTypes?: InputMaybe<Array<InputMaybe<ProjectType>>>;
  searchKeyword?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ReceivableSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  startProjectEndDate?: InputMaybe<Scalars['DateTime']>;
  startProjectStartDate?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<InputMaybe<ReceivableStatusEnum>>>;
  type?: InputMaybe<ReceivableTypeEnum>;
};


export type QueryPaginatedShippersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchBillingAddress?: InputMaybe<Scalars['String']>;
  searchBillingGmapsLocation?: InputMaybe<Scalars['String']>;
  searchBillingOfficeDistrict?: InputMaybe<Scalars['String']>;
  searchBrand?: InputMaybe<Scalars['String']>;
  searchDocumentTypes?: InputMaybe<Array<InputMaybe<ShipperDocumentType>>>;
  searchGmapsLocation?: InputMaybe<Scalars['String']>;
  searchIndustry?: InputMaybe<Scalars['String']>;
  searchInvoiceAttention?: InputMaybe<Scalars['String']>;
  searchInvoiceDetails?: InputMaybe<Scalars['String']>;
  searchInvoiceReceiptSchedule?: InputMaybe<Scalars['String']>;
  searchOfficeDistrict?: InputMaybe<Scalars['String']>;
  searchPaymentDays?: InputMaybe<Scalars['String']>;
  searchPaymentTerms?: InputMaybe<Scalars['String']>;
  searchPhoneNumber?: InputMaybe<Scalars['String']>;
  searchPostalCode?: InputMaybe<Scalars['String']>;
  searchProjectTypes?: InputMaybe<Array<InputMaybe<ShipperProjectType>>>;
  searchSalesChannel?: InputMaybe<Scalars['String']>;
  searchSalesName?: InputMaybe<Scalars['String']>;
  searchShipperId?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchStatuses?: InputMaybe<Array<InputMaybe<Status>>>;
  searchTypes?: InputMaybe<Array<InputMaybe<ShipperAccountType>>>;
  sortBy?: InputMaybe<ShipperSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedTransporterPipelinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterByAccountType?: InputMaybe<Array<InputMaybe<TransporterAccountType>>>;
  filterByContractType?: InputMaybe<Array<InputMaybe<ContractType>>>;
  filterByDocumentStatus?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  filterByFleetBodyType?: InputMaybe<Array<InputMaybe<FleetBodyType>>>;
  filterByFleetType?: InputMaybe<Array<InputMaybe<FleetType>>>;
  filterByNeedCoordinator?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  filterByOnBoarded?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  filterByPipelineStatus?: InputMaybe<Array<InputMaybe<PipelineStatus>>>;
  filterBySupplyType?: InputMaybe<Array<InputMaybe<ContractSupplyType>>>;
  filterByTransporterType?: InputMaybe<Array<InputMaybe<TransporterType>>>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchAdminName?: InputMaybe<Scalars['String']>;
  searchApprovalCode?: InputMaybe<Scalars['String']>;
  searchBDName?: InputMaybe<Scalars['String']>;
  searchBdName?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchDriverPhoneNumber?: InputMaybe<Scalars['String']>;
  searchFleetPlateNumber?: InputMaybe<Scalars['String']>;
  searchPipelineCode?: InputMaybe<Scalars['String']>;
  searchPipelineId?: InputMaybe<Scalars['String']>;
  searchProjectCode?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<PipelineSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedTransportersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterByAccountTypes?: InputMaybe<Array<InputMaybe<TransporterAccountType>>>;
  filterByDocumentTypes?: InputMaybe<Array<InputMaybe<TransporterDocumentType>>>;
  filterByStatuses?: InputMaybe<Array<InputMaybe<Status>>>;
  filterByTypes?: InputMaybe<Array<InputMaybe<TransporterType>>>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchBankAccountHolder?: InputMaybe<Scalars['String']>;
  searchBankAccountNumber?: InputMaybe<Scalars['String']>;
  searchBankBranchName?: InputMaybe<Scalars['String']>;
  searchBankName?: InputMaybe<Scalars['String']>;
  searchContactEmailAddress?: InputMaybe<Scalars['String']>;
  searchContactName?: InputMaybe<Scalars['String']>;
  searchContactPhoneNumber?: InputMaybe<Scalars['String']>;
  searchGmapsLocation?: InputMaybe<Scalars['String']>;
  searchId?: InputMaybe<Scalars['String']>;
  searchInitial?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
  searchOfficeDistrict?: InputMaybe<Scalars['String']>;
  searchPaymentScheme?: InputMaybe<Scalars['String']>;
  searchPostalCode?: InputMaybe<Scalars['String']>;
  searchStatus?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<TransporterSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryPaginatedVehiclesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first: Scalars['Int'];
  isReplacementFleet?: InputMaybe<Scalars['Boolean']>;
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  projectKsuid?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDedicatedToSpecificContract?: InputMaybe<Scalars['Boolean']>;
  searchDocumentTypes?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  searchFleetBodyTypes?: InputMaybe<Array<InputMaybe<FleetBodyType>>>;
  searchFleetId?: InputMaybe<Scalars['String']>;
  searchFleetPlateColors?: InputMaybe<Array<InputMaybe<VehiclePlateType>>>;
  searchFleetStatuses?: InputMaybe<Array<InputMaybe<FleetStatus>>>;
  searchFleetTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchLicensePlate?: InputMaybe<Scalars['String']>;
  searchTransporterId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<VehicleSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  vehicleTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withContractActiveOnDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryPaginatedWarehousesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterByStatus?: InputMaybe<Array<InputMaybe<WarehouseStatusEnum>>>;
  filterByType?: InputMaybe<Array<InputMaybe<WarehouseTypeEnum>>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  searchAddress?: InputMaybe<Scalars['String']>;
  searchDistrictCityProvince?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
  searchPicPhone?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<WarehouseSortInput>;
};


export type QueryPayableCountSummaryArgs = {
  dueStatuses?: InputMaybe<Array<InputMaybe<DueStatusEnum>>>;
  payableType: PayableTypeEnum;
  reviewStatuses?: InputMaybe<Array<InputMaybe<TotalPayablesByReviewStatus>>>;
};


export type QueryPayableDoSummaryArgs = {
  payableKsuid: Scalars['String'];
};


export type QueryPayableSummaryArgs = {
  payableType: PayableTypeEnum;
  requestedSummaries: Array<InputMaybe<PayableRequestedSummariesEnum>>;
};


export type QueryPaymentStatementPageArgs = {
  payableKsuid: Scalars['String'];
};


export type QueryPaymentStatementPagePublicArgs = {
  payableKsuid: Scalars['String'];
};


export type QueryReviewPayableItemArgs = {
  payableItemKsuid: Scalars['String'];
};


export type QueryShipperDetailsArgs = {
  ksuid: Scalars['String'];
};


export type QueryTransporterDetailArgs = {
  ksuid: Scalars['String'];
};


export type QueryTransporterPipelineDetailsArgs = {
  pipelineCode: Scalars['String'];
};


export type QueryVehicleDetailsArgs = {
  ksuid: Scalars['String'];
};


export type QueryWarehouseDetailsArgs = {
  ksuid: Scalars['String'];
};

export type ReceivableDeliveryOrder = {
  __typename?: 'ReceivableDeliveryOrder';
  /** COD fee */
  codFee?: Maybe<Scalars['Int']>;
  /** External Type of Receivable */
  externalType?: Maybe<Scalars['String']>;
  /** Invoiceable fees */
  invoicableFees?: Maybe<Array<Maybe<InvoiceableFee>>>;
  /** Receivable's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Shipment fee */
  shipmentFee?: Maybe<Scalars['Int']>;
  /** Shipper Price Final */
  shipperPriceFinal?: Maybe<Scalars['Int']>;
  /** Status of receivable */
  status?: Maybe<Scalars['String']>;
};

export type ReceivableNode = {
  __typename?: 'ReceivableNode';
  /** COD fee */
  codFee?: Maybe<Scalars['Int']>;
  /** Receivable's do details */
  deliveryOrder?: Maybe<DeliveryOrder>;
  /** External Type of Receivable */
  externalType?: Maybe<Scalars['String']>;
  /** Invoiceable fees */
  invoiceableFees?: Maybe<Array<Maybe<InvoiceableFee>>>;
  /** Receivable's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Shipment fee */
  shipmentFee?: Maybe<Scalars['Int']>;
  /** Shipper Price Final */
  shipperPriceFinal?: Maybe<Scalars['Int']>;
  /** status */
  status?: Maybe<Scalars['String']>;
  /** Last Update Receivable */
  updatedAt?: Maybe<Scalars['String']>;
  /** Driver which allocated for this contract */
  vehicleAllocation?: Maybe<VehicleAllocationNode>;
};

export enum ReceivableSortEnum {
  DoDeliveryDate = 'DO_DELIVERY_DATE',
  DoNumber = 'DO_NUMBER',
  ProjectEndDate = 'PROJECT_END_DATE',
  ProjectName = 'PROJECT_NAME',
  ProjectStartDate = 'PROJECT_START_DATE',
  ProjectType = 'PROJECT_TYPE',
  Status = 'STATUS',
  VehicleContractCode = 'VEHICLE_CONTRACT_CODE',
  VehiclePlateNumber = 'VEHICLE_PLATE_NUMBER'
}

export enum ReceivableStatusEnum {
  NotInvoiced = 'NOT_INVOICED',
  OngoingInvoice = 'ONGOING_INVOICE',
  Paid = 'PAID',
  PartiallyInvoiced = 'PARTIALLY_INVOICED',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export enum ReceivableTypeEnum {
  DeliveryOrder = 'DELIVERY_ORDER',
  VehicleContractCode = 'VEHICLE_CONTRACT_CODE'
}

export type ReplacementVehicleAllocationNode = {
  __typename?: 'ReplacementVehicleAllocationNode';
  /** New Vehicle Contract Code end date */
  endDate?: Maybe<Scalars['String']>;
  /** New Vehicle Contract Code start date */
  startDate?: Maybe<Scalars['String']>;
  /** Main Fleet Which Is Replaced */
  vccGroup?: Maybe<Scalars['String']>;
  /** Vehicle Plate Number */
  vehiclePlateNumber?: Maybe<Scalars['String']>;
};

export type Result = {
  __typename?: 'Result';
  /** DO's ksuid */
  doKsuid?: Maybe<Scalars['String']>;
};

export type RoutePriceDetail = {
  /** Dropoff Route */
  dropOffRoute?: InputMaybe<Scalars['String']>;
  /** End date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Pickup Route */
  pickupRoute?: InputMaybe<Scalars['String']>;
  /** Rental price */
  rentalPrice?: InputMaybe<Scalars['Float']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** TIP price */
  tipPrice?: InputMaybe<Scalars['Float']>;
  /** Unfulfill Fee */
  unfulfillFee?: InputMaybe<Scalars['Float']>;
};

export type RoutePriceDetailNode = {
  __typename?: 'RoutePriceDetailNode';
  /** Dropoff Route */
  dropOffRoute?: Maybe<Scalars['String']>;
  /** End date */
  endDate?: Maybe<Scalars['String']>;
  /** Pickup Route */
  pickupRoute?: Maybe<Scalars['String']>;
  /** Rental price */
  rentalPrice?: Maybe<Scalars['Float']>;
  /** Start date */
  startDate?: Maybe<Scalars['String']>;
  /** TIP price */
  tipPrice?: Maybe<Scalars['Float']>;
  /** Unfulfill Fee */
  unfulfillFee?: Maybe<Scalars['Float']>;
};

export type ShipmentFailedCounterNode = {
  __typename?: 'ShipmentFailedCounterNode';
  /** Shipment Failed Counter count field */
  count?: Maybe<Scalars['Int']>;
  /** Shipment Failed Counter ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Shipment Failed Counter order reference */
  orderReference?: Maybe<Scalars['String']>;
  /** Shipment Failed Counter shipper ksuid */
  shipperKsuid?: Maybe<Scalars['String']>;
};

export type ShipmentTimestampType = {
  __typename?: 'ShipmentTimestampType';
  arriveAtDestination?: Maybe<Scalars['String']>;
  arriveAtPickup?: Maybe<Scalars['String']>;
  assigned?: Maybe<Scalars['String']>;
  cancelledByInternal?: Maybe<Scalars['String']>;
  cancelledByShipper?: Maybe<Scalars['String']>;
  cancelledByTransporter?: Maybe<Scalars['String']>;
  finishLoading?: Maybe<Scalars['String']>;
  finishUnloading?: Maybe<Scalars['String']>;
  onShipment?: Maybe<Scalars['String']>;
  ongoingToPickup?: Maybe<Scalars['String']>;
  planned?: Maybe<Scalars['String']>;
  shipmentComplete?: Maybe<Scalars['String']>;
  startLoading?: Maybe<Scalars['String']>;
  startUnloading?: Maybe<Scalars['String']>;
  unfulfilled?: Maybe<Scalars['String']>;
  upcoming?: Maybe<Scalars['String']>;
};

export type ShipmentType = {
  __typename?: 'ShipmentType';
  /** Company that posted/re-posted the shipment's job. Its either brokerage_company_ksuid or shipper_company_ksuid, depending on the job scope */
  customerKsuid?: Maybe<Scalars['String']>;
  /** Assigned driver of the shipments */
  driverKsuid?: Maybe<Scalars['String']>;
  /** Job ksuid where the shipment once belonged to */
  historicalJobKsuid?: Maybe<Scalars['String']>;
  /** Datetime the shipment is created */
  insertedAt?: Maybe<Scalars['String']>;
  /** Job ksuid where the shipment belongs to */
  jobKsuid?: Maybe<Scalars['String']>;
  /** Shipment's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Shipment's latest gps lat */
  latestGpsLat?: Maybe<Scalars['Float']>;
  /** Shipment's latest gps lng */
  latestGpsLng?: Maybe<Scalars['Float']>;
  /** Shipment's latest gps source */
  latestGpsSource?: Maybe<Scalars['Float']>;
  /** Shipment's latest gps timestamp (when is GPS is last updated) */
  latestGpsTimestamp?: Maybe<Scalars['String']>;
  /** Time taken (in seconds) from the moment the truck leaves the loading warehouse to when the truck arrives at the unloading warehouse */
  leadTime?: Maybe<Scalars['Int']>;
  /** Time taken (in seconds) from the moment the truck leaves the loading warehouse to when the truck arrives at the unloading warehouse */
  shipmentTimestamp?: Maybe<ShipmentTimestampType>;
  /** Shipper's company ksuid. The shipment is to deliver this company's goods */
  shipperCompanyKsuid?: Maybe<Scalars['String']>;
  /** Shipment status */
  status?: Maybe<Scalars['String']>;
  /** Shipment's cancel note */
  statusNote?: Maybe<Scalars['String']>;
  /** Transporter's company ksuid who serve the shipment */
  transporterCompanyKsuid?: Maybe<Scalars['String']>;
  /** Datetime the shipment is last updated */
  updatedAt?: Maybe<Scalars['String']>;
  /** Assigned vehicles of the shipments */
  vehicleKsuid?: Maybe<Scalars['String']>;
  /** license plate of the assigned vehicle, copied from profile.vehicle for easier lookup */
  vehicleLicensePlate?: Maybe<Scalars['String']>;
};

export enum ShipperAccountType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export enum ShipperDocumentType {
  Ktp = 'KTP',
  Npwp = 'NPWP',
  Siup = 'SIUP',
  Tdp = 'TDP'
}

export enum ShipperIndustryEnum {
  Automotif = 'AUTOMOTIF',
  BahanDaurUlang = 'BAHAN_DAUR_ULANG',
  Bangunan = 'BANGUNAN',
  CosmeticKecantikan = 'COSMETIC_KECANTIKAN',
  Elektronik = 'ELEKTRONIK',
  Fmcg = 'FMCG',
  Furniture = 'FURNITURE',
  Hotel = 'HOTEL',
  Kayu = 'KAYU',
  Kesehatan = 'KESEHATAN',
  Logistic = 'LOGISTIC',
  Other = 'OTHER',
  Pakaian = 'PAKAIAN',
  Pertanian = 'PERTANIAN',
  Pribadi = 'PRIBADI',
  TextileAndGarment = 'TEXTILE_AND_GARMENT'
}

export type ShipperInput = {
  /** Shipper alias */
  alias?: InputMaybe<Scalars['String']>;
  /** Shipper ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Shipper name */
  name?: InputMaybe<Scalars['String']>;
  /** Shipper price */
  price?: InputMaybe<Scalars['Float']>;
};

export type ShipperNode = {
  __typename?: 'ShipperNode';
  /** Shipper billing address */
  billingAddress?: Maybe<Scalars['String']>;
  /** Shipper billing gmaps location */
  billingGmapsLocation?: Maybe<Scalars['String']>;
  /** Shipper billing district */
  billingOfficeDistrict?: Maybe<Scalars['String']>;
  /** Shipper billing postal code */
  billingPostalCode?: Maybe<Scalars['String']>;
  /** Shipper brand */
  brand?: Maybe<Scalars['String']>;
  /** Company details of shipper */
  company?: Maybe<CompanyNode>;
  /** Shipper company's ksuid */
  companyKsuid?: Maybe<Scalars['String']>;
  /** Shipper's contract link file */
  contractUpload?: Maybe<Scalars['String']>;
  /** Shipper gmaps location */
  gmapsLocation?: Maybe<Scalars['String']>;
  /** Shipper's industry */
  industry?: Maybe<Scalars['String']>;
  /** Company invoice attention */
  invoiceAttention?: Maybe<Scalars['String']>;
  /** Shipper Invoice Code */
  invoiceCode?: Maybe<Scalars['String']>;
  /** Company invoice details */
  invoiceDetails?: Maybe<Scalars['String']>;
  /** Shipper Invoice Entity */
  invoiceEntity?: Maybe<InvoiceEntityEnum>;
  /** Company invoice receipt deadline */
  invoiceReceiptDeadline?: Maybe<Scalars['String']>;
  /** Company invoice receipt schedule */
  invoiceReceiptSchedule?: Maybe<Scalars['String']>;
  /** Company office's district */
  officeDistrict?: Maybe<Scalars['String']>;
  /** Company payment's days */
  paymentDays?: Maybe<Scalars['Int']>;
  /** Company payment's terms */
  paymentTerms?: Maybe<Scalars['String']>;
  /** Shipper postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Shipper company's project */
  projects?: Maybe<Array<Maybe<ProjectNode>>>;
  /** Shipper's sales channel */
  salesChannel?: Maybe<Scalars['String']>;
  /** Shipper's sales name */
  salesName?: Maybe<Scalars['String']>;
  /** Shipper's sales start date */
  salesStartDate?: Maybe<Scalars['String']>;
  /** Shipper office and billing is same or not */
  sameAsBillingAddress?: Maybe<Scalars['Boolean']>;
  /** Shipper's status */
  status?: Maybe<Status>;
  /** Shipper's type */
  type?: Maybe<Scalars['String']>;
};

export enum ShipperPaymentTerms {
  CalendarDays = 'CALENDAR_DAYS',
  WorkingDays = 'WORKING_DAYS'
}

export enum ShipperProjectType {
  Dedicated = 'DEDICATED',
  Oncall = 'ONCALL'
}

export enum ShipperSortBy {
  BillingAddress = 'BILLING_ADDRESS',
  BillingGmapsLocation = 'BILLING_GMAPS_LOCATION',
  BillingOfficeDistrict = 'BILLING_OFFICE_DISTRICT',
  Brand = 'BRAND',
  DocumentTypes = 'DOCUMENT_TYPES',
  GmapsLocation = 'GMAPS_LOCATION',
  Industry = 'INDUSTRY',
  InsertedAt = 'INSERTED_AT',
  InvoiceAttention = 'INVOICE_ATTENTION',
  InvoiceDetails = 'INVOICE_DETAILS',
  InvoiceReceiptSchedule = 'INVOICE_RECEIPT_SCHEDULE',
  Name = 'NAME',
  OfficeDistrict = 'OFFICE_DISTRICT',
  PaymentDays = 'PAYMENT_DAYS',
  PaymentTerms = 'PAYMENT_TERMS',
  PhoneNumber = 'PHONE_NUMBER',
  PostalCode = 'POSTAL_CODE',
  ProjectTypes = 'PROJECT_TYPES',
  SalesChannel = 'SALES_CHANNEL',
  SalesName = 'SALES_NAME',
  SalesStartDate = 'SALES_START_DATE',
  ShipperId = 'SHIPPER_ID',
  ShipperName = 'SHIPPER_NAME',
  Statuses = 'STATUSES',
  Types = 'TYPES'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Source {
  Csv = 'CSV',
  Form = 'FORM'
}

export enum Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Void = 'VOID'
}

export enum SupplyTypeEnum {
  AllIn = 'ALL_IN',
  DriverOnlyRental = 'DRIVER_ONLY_RENTAL',
  FleetAndDriverRental = 'FLEET_AND_DRIVER_RENTAL',
  FleetOnlyRental = 'FLEET_ONLY_RENTAL'
}

export type SyncResponse = {
  __typename?: 'SyncResponse';
  /** List of failed sync ksuid */
  failedKsuids?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Total sync data */
  totalData?: Maybe<Scalars['Int']>;
};

export type TpContractNode = {
  __typename?: 'TPContractNode';
  /** Contract ksuid */
  ksuid?: Maybe<Scalars['String']>;
};

export type TpDriverNode = {
  __typename?: 'TPDriverNode';
  /** Bank account number */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** Bank name */
  bankName?: Maybe<Scalars['String']>;
  /** Bank account owner name */
  bankOwnerName?: Maybe<Scalars['String']>;
  /** Bank branch */
  branch?: Maybe<Scalars['String']>;
  /** Driver phone number */
  contact?: Maybe<Scalars['String']>;
  /** Expiration date */
  expirationDate?: Maybe<Scalars['String']>;
  /** Helper phone number */
  helperContact?: Maybe<Scalars['String']>;
  /** Helper name */
  helperName?: Maybe<Scalars['String']>;
  /** Driver's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Driver KTP */
  ktp?: Maybe<Scalars['String']>;
  /** Driver name */
  name?: Maybe<Scalars['String']>;
  /** Driver NPWP */
  npwp?: Maybe<Scalars['String']>;
  /** Replacement driver end date */
  replacementDriverEndDate?: Maybe<Scalars['String']>;
  /** Replacement driver name */
  replacementDriverName?: Maybe<Scalars['String']>;
  /** Replacement driver start date */
  replacementDriverStartDate?: Maybe<Scalars['String']>;
  /** Driver Sim */
  sim?: Maybe<Scalars['String']>;
};

export type TpFleetNode = {
  __typename?: 'TPFleetNode';
  /** Fleet body type */
  fleetBodyType?: Maybe<FleetBodyType>;
  /** Fleet Details */
  fleetDetails?: Maybe<Array<Maybe<FleetDetailsNode>>>;
  /** Fleet Type */
  fleetType?: Maybe<FleetType>;
};

export type TpProjectNode = {
  __typename?: 'TPProjectNode';
  /** Project alias */
  alias?: Maybe<Scalars['String']>;
  /** Project's code */
  code?: Maybe<Scalars['String']>;
  /** Project ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Project name */
  name?: Maybe<Scalars['String']>;
};

export type TpShipperNode = {
  __typename?: 'TPShipperNode';
  /** Shipper alias */
  alias?: Maybe<Scalars['String']>;
  /** Shipper ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Shipper name */
  name?: Maybe<Scalars['String']>;
  /** Shipper price */
  price?: Maybe<Scalars['Float']>;
};

export type TpTransporterPipelineNode = {
  __typename?: 'TPTransporterPipelineNode';
  /** Account Type */
  accountType?: Maybe<TransporterAccountType>;
  /** Bank account number */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** Bank name */
  bankName?: Maybe<Scalars['String']>;
  /** Bank account owner name */
  bankOwnerName?: Maybe<Scalars['String']>;
  /** Bank branch */
  branch?: Maybe<Scalars['String']>;
  /** Days left for earliest document expired */
  documentDaysLeft?: Maybe<Scalars['Int']>;
  /** Document link */
  documentLink?: Maybe<Scalars['String']>;
  /** Document Status Enum */
  documentStatus?: Maybe<DocumentStatus>;
  /** documents */
  documents?: Maybe<Scalars['JSON']>;
  /** Transporter Email */
  email?: Maybe<Scalars['String']>;
  /** coordinator needed */
  isNeedCoordinator?: Maybe<Scalars['Boolean']>;
  /** On Boarded */
  isOnboarded?: Maybe<Scalars['Boolean']>;
  /** Transporter's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Transporter name */
  name?: Maybe<Scalars['String']>;
  /** Pic Name */
  picName?: Maybe<Scalars['String']>;
  /** Pic phone number */
  picPhoneNumber?: Maybe<Scalars['String']>;
  /** PKP amount */
  pkpAmount?: Maybe<Scalars['String']>;
  /** Pool city province */
  poolCityProvince?: Maybe<Scalars['String']>;
  /** Pool full address */
  poolFullAddress?: Maybe<Scalars['String']>;
  /** Pool postal code */
  poolPostalCode?: Maybe<Scalars['String']>;
  /** SKB amount */
  skbAmount?: Maybe<Scalars['String']>;
  /** Transporter type */
  transporterType?: Maybe<TransporterType>;
};

export enum TransporterAccountType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL',
  Operator = 'OPERATOR'
}

export enum TransporterDefaultPaymentScheme {
  PaymentScheme_50_50 = 'PAYMENT_SCHEME_50_50',
  PaymentScheme_100 = 'PAYMENT_SCHEME_100'
}

export enum TransporterDocumentType {
  Akta = 'AKTA',
  Kemenkumham = 'KEMENKUMHAM',
  Kk = 'KK',
  Ktp = 'KTP',
  Npwp = 'NPWP',
  Siup = 'SIUP',
  Skb = 'SKB',
  Sppkp = 'SPPKP',
  Tdp = 'TDP'
}

export type TransporterInput = {
  /** Account Type */
  accountType?: InputMaybe<TransporterAccountType>;
  /** Bank account number */
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  /** Bank name */
  bankName?: InputMaybe<Scalars['String']>;
  /** Bank account owner name */
  bankOwnerName?: InputMaybe<Scalars['String']>;
  /** Bank branch */
  branch?: InputMaybe<Scalars['String']>;
  /** Document link */
  documentLink?: InputMaybe<Scalars['String']>;
  /** documents */
  documents?: InputMaybe<Scalars['JSON']>;
  /** Transporter Email */
  email?: InputMaybe<Scalars['String']>;
  /** coordinator needed */
  isNeedCoordinator?: InputMaybe<Scalars['Boolean']>;
  /** On Boarded */
  isOnboarded?: InputMaybe<Scalars['Boolean']>;
  /** Transporter's ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Transporter name */
  name?: InputMaybe<Scalars['String']>;
  /** Pic Name */
  picName?: InputMaybe<Scalars['String']>;
  /** Pic phone number */
  picPhoneNumber?: InputMaybe<Scalars['String']>;
  /** PKP amount */
  pkpAmount?: InputMaybe<Scalars['String']>;
  /** Pool city province */
  poolCityProvince?: InputMaybe<Scalars['String']>;
  /** Pool full address */
  poolFullAddress?: InputMaybe<Scalars['String']>;
  /** Pool postal code */
  poolPostalCode?: InputMaybe<Scalars['String']>;
  /** SKB amount */
  skbAmount?: InputMaybe<Scalars['String']>;
  /** Transporter type */
  transporterType?: InputMaybe<TransporterType>;
};

export type TransporterNode = {
  __typename?: 'TransporterNode';
  /** Transporter account type */
  accountType?: Maybe<Scalars['String']>;
  /** Transporter's bank details */
  bank?: Maybe<BankNode>;
  /** Transporter bank account holder */
  bankAccountHolder?: Maybe<Scalars['String']>;
  /** Transporter bank's account number */
  bankAccountNumber?: Maybe<Scalars['String']>;
  /** Transporter bank's branch */
  bankBranch?: Maybe<Scalars['String']>;
  /** Transporter bank's internal code */
  bankInternalCode?: Maybe<Scalars['String']>;
  /** Transporter's bank */
  bankName?: Maybe<Scalars['String']>;
  /** Company details of transporter */
  company?: Maybe<CompanyNode>;
  /** Transporter company's ksuid */
  companyKsuid?: Maybe<Scalars['String']>;
  /** Default Transporter Payment scheme */
  defaultPaymentScheme?: Maybe<TransporterDefaultPaymentScheme>;
  /** Transporter gmaps location */
  gmapsLocation?: Maybe<Scalars['String']>;
  /** Transporter's initial */
  initial?: Maybe<Scalars['String']>;
  /** Transporter's insurance is active or not */
  insuranceActive?: Maybe<Scalars['Boolean']>;
  /** Transporter's insurance end date */
  insuranceEndDate?: Maybe<Scalars['String']>;
  /** Transporter's insurance start date */
  insuranceStartDate?: Maybe<Scalars['String']>;
  /** Transporter office district */
  officeDistrict?: Maybe<Scalars['String']>;
  /** Transporter postal code */
  postalCode?: Maybe<Scalars['String']>;
  /** Transporter's skb ownership */
  skbOwnership?: Maybe<Scalars['String']>;
  /** Transporter's status */
  status?: Maybe<Status>;
  /** Transporter's tax WHT */
  taxVat?: Maybe<Scalars['Float']>;
  /** Transporter's tax WHT */
  taxWht?: Maybe<Scalars['Float']>;
  /** Transporter type */
  type?: Maybe<Scalars['String']>;
};

export type TransporterPipelineNode = {
  __typename?: 'TransporterPipelineNode';
  /** Addendum or termination link */
  addendumOrTerminationLink?: Maybe<Scalars['String']>;
  /** admin name */
  adminName?: Maybe<Scalars['String']>;
  /** agremeent number */
  agreementNumber?: Maybe<Scalars['String']>;
  /** Agrement Type  */
  agreementType?: Maybe<AgreementType>;
  /** Approval code */
  approvalCode?: Maybe<Scalars['String']>;
  /** Area coverage */
  areaCoverage?: Maybe<Scalars['String']>;
  /** BD name */
  bdName?: Maybe<Scalars['String']>;
  /** City */
  city?: Maybe<Scalars['String']>;
  /** Cluster */
  cluster?: Maybe<Scalars['String']>;
  /** COD Services */
  codServices?: Maybe<Scalars['Boolean']>;
  /** Contract */
  contract?: Maybe<TpContractNode>;
  /** Contract Type */
  contractType?: Maybe<ContractType>;
  /** drivers */
  drivers?: Maybe<Array<Maybe<TpDriverNode>>>;
  /** Transporter Pipeline Duplicated From */
  duplicatedFrom?: Maybe<Scalars['String']>;
  /** Fleet */
  fleet?: Maybe<TpFleetNode>;
  /** kargo entity */
  kargoEntity?: Maybe<Scalars['String']>;
  /** Transporter Pipeline Notes */
  notes?: Maybe<Scalars['String']>;
  /** number of trip */
  numberOfTrip?: Maybe<Scalars['String']>;
  /** Payment Scheme */
  paymentScheme?: Maybe<PaymentSchemeType>;
  /** Transporter Pipeline Code */
  pipelineCode?: Maybe<Scalars['String']>;
  /** Transporter Pipeline id */
  pipelineId?: Maybe<Scalars['String']>;
  /** Project */
  project?: Maybe<TpProjectNode>;
  /** Prof of signing */
  proofOfSigning?: Maybe<Scalars['String']>;
  /** Pipeline Code */
  routePriceDetails?: Maybe<Array<Maybe<RoutePriceDetailNode>>>;
  /** Shipper */
  shipper?: Maybe<TpShipperNode>;
  /** Transporter Pipeline Status */
  status?: Maybe<PipelineStatus>;
  /** Transporter Pipeline Status timestamp */
  statusTimestamp?: Maybe<Scalars['JSON']>;
  /** Contact Supply Type */
  supplyType?: Maybe<ContractSupplyType>;
  /** Route Price Detail */
  transporter?: Maybe<TpTransporterPipelineNode>;
};

export enum TransporterSortBy {
  AccountType = 'ACCOUNT_TYPE',
  BankAccountHolder = 'BANK_ACCOUNT_HOLDER',
  BankAccountNumber = 'BANK_ACCOUNT_NUMBER',
  BankBranch = 'BANK_BRANCH',
  BankName = 'BANK_NAME',
  GmapsLocation = 'GMAPS_LOCATION',
  Initial = 'INITIAL',
  InsuranceEndDate = 'INSURANCE_END_DATE',
  InsuranceStartDate = 'INSURANCE_START_DATE',
  Name = 'NAME',
  OfficeDistrict = 'OFFICE_DISTRICT',
  PostalCode = 'POSTAL_CODE',
  SkbOwnership = 'SKB_OWNERSHIP',
  Status = 'STATUS',
  TaxVat = 'TAX_VAT',
  TaxWht = 'TAX_WHT',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT'
}

export enum TransporterType {
  DriverOperator = 'DRIVER_OPERATOR',
  InternalHiredDriver = 'INTERNAL_HIRED_DRIVER',
  Motorist = 'MOTORIST',
  TransporterHiredDriver = 'TRANSPORTER_HIRED_DRIVER',
  TruckAndDriverPlusUj = 'TRUCK_AND_DRIVER_PLUS_UJ'
}

export enum TypeOfApp {
  /** Integrate project to flynd dashboard app */
  Flynd = 'FLYND',
  /** Not integrate project to any app */
  NonApp = 'NON_APP',
  /** Integrate project to WA app */
  WaBot = 'WA_BOT'
}

export type Url = {
  __typename?: 'URL';
  /** Full URL */
  full?: Maybe<Scalars['String']>;
  /** Preview URL */
  preview?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  ksuid?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type VehicleAllocationInput = {
  /** Cluster ID of vehicle allocation */
  clusterId?: InputMaybe<Scalars['String']>;
  /** Company vehicle ksuid */
  companyVehicleKsuid?: InputMaybe<Scalars['String']>;
  /** Driver ksuid */
  driverKsuid?: InputMaybe<Scalars['String']>;
  /** Driver name */
  driverName?: InputMaybe<Scalars['String']>;
  /** New Vehicle Contract Code end date */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Mark VCC as Replacement */
  isReplacement?: InputMaybe<Scalars['Boolean']>;
  /** vehicle allocation ksuid */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Main Fleet Which Is Replaced */
  replacementFor?: InputMaybe<Scalars['String']>;
  /** New Vehicle Contract Code start date */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** VCC Notes */
  vccNotes?: InputMaybe<Scalars['String']>;
  /** Vehicle Contract Code Status */
  vccStatus?: InputMaybe<Scalars['String']>;
  /** Vehicle ksuid */
  vehicleKsuid?: InputMaybe<Scalars['String']>;
  /** Vehicle license plate number */
  vehiclePlateNumber?: InputMaybe<Scalars['String']>;
};

export type VehicleAllocationNode = {
  __typename?: 'VehicleAllocationNode';
  /** Cluster ID of vehicle allocation */
  clusterId?: Maybe<Scalars['String']>;
  /** Company driver node */
  companyDriver?: Maybe<CompanyDriver>;
  /** Company vehicle */
  companyVehicle?: Maybe<CompanyVehicleNode>;
  /** New Vehicle Contract Code end date */
  endDate?: Maybe<Scalars['String']>;
  /** Replacement marker */
  isReplacement?: Maybe<Scalars['Boolean']>;
  /** vehicle Allocation ksu id */
  ksuid?: Maybe<Scalars['String']>;
  /** Project */
  project?: Maybe<ProjectNode>;
  /** Project end date */
  projectEndDate?: Maybe<Scalars['String']>;
  /** Project name */
  projectName?: Maybe<Scalars['String']>;
  /** Project start date */
  projectStartDate?: Maybe<Scalars['String']>;
  /** Main Fleet Which Is Replaced */
  replacementFor?: Maybe<Scalars['String']>;
  /** Vehicle Replacements */
  replacements?: Maybe<Array<Maybe<ReplacementVehicleAllocationNode>>>;
  /** Shipment date */
  shipmentDate?: Maybe<Scalars['String']>;
  /** Project shipper */
  shipper?: Maybe<ShipperNode>;
  /** New Vehicle Contract Code start date */
  startDate?: Maybe<Scalars['String']>;
  /** Main Fleet Which Is Replaced */
  vccGroup?: Maybe<Scalars['String']>;
  /** VCC Notes */
  vccNotes?: Maybe<Scalars['String']>;
  /** Vehicle Contract Code Status */
  vccStatus?: Maybe<Scalars['String']>;
  /** Detail vehicle */
  vehicle?: Maybe<VehicleNode>;
  /** Vehicle contract code */
  vehicleContractCode?: Maybe<Scalars['String']>;
};

export type VehicleNode = {
  __typename?: 'VehicleNode';
  /** Vehicle capacity */
  capacity?: Maybe<Scalars['Float']>;
  /** Vehicle capacity unit */
  capacityUnit?: Maybe<Scalars['String']>;
  /** Vehicle height */
  height?: Maybe<Scalars['Float']>;
  /** Vehicle ksuid */
  ksuid: Scalars['String'];
  /** Vehicle latest gps latitude */
  latestGpsLatitude?: Maybe<Scalars['Float']>;
  /** Vehicle latest gps longitude */
  latestGpsLongitude?: Maybe<Scalars['Float']>;
  /** Vehicle latest gps update at */
  latestGpsUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Vehicle length */
  length?: Maybe<Scalars['Float']>;
  /** Vehicle license plate number */
  licensePlateNumber?: Maybe<Scalars['String']>;
  /** Vehicle license type */
  vehiclePlateType?: Maybe<Scalars['String']>;
  /** Master Data Vehicle Type for vehicle */
  vehicleType?: Maybe<MdVehicleNode>;
  /** ID for MD Vehicle Type */
  vehicleTypeId?: Maybe<Scalars['String']>;
  /** Vehicle width */
  width?: Maybe<Scalars['Float']>;
};

export enum VehiclePlateType {
  BlackPlate = 'BLACK_PLATE',
  WhitePlate = 'WHITE_PLATE',
  YellowPlate = 'YELLOW_PLATE'
}

export enum VehicleSortBy {
  Capacity = 'CAPACITY',
  CreatedAt = 'CREATED_AT',
  LicensePlate = 'LICENSE_PLATE',
  SubVehicleType = 'SUB_VEHICLE_TYPE',
  UpdatedAt = 'UPDATED_AT',
  VehicleType = 'VEHICLE_TYPE'
}

export type Warehouse = {
  __typename?: 'Warehouse';
  /** Warehouse's address */
  address?: Maybe<Scalars['String']>;
  /** Average rating, submitted by driver via DApp */
  averageRating?: Maybe<Scalars['String']>;
  /** Warehouse's city. This is based on google map */
  city?: Maybe<Scalars['String']>;
  /** Company who saved the warehouse */
  companyKsuid?: Maybe<Scalars['String']>;
  /** Warehouse's coordinate */
  coordinate?: Maybe<Coordinate>;
  /** Warehouse's country. This is based on google map */
  country?: Maybe<Scalars['String']>;
  /** Warehouse's district. This is based on google map */
  district?: Maybe<Scalars['String']>;
  /** Warehouse's driver notes */
  driverNotes?: Maybe<Scalars['String']>;
  /** Geofence radius in KM */
  geofenceRadiusKm?: Maybe<Scalars['Float']>;
  /** Warehouse's google map url. If this link is click, you will be redirected to google maps */
  googleMapUrl?: Maybe<Scalars['String']>;
  /** Warehouse's ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Master Data District, for strict operation, master data district is strongly prefered over `district` entry */
  mdDistrict?: Maybe<MdDistrict>;
  /** Warehouse's name */
  name?: Maybe<Scalars['String']>;
  /** Notes for shipper warehouse */
  notes?: Maybe<Scalars['String']>;
  /** Operation hours data in structured data form, mutually exclusive to free text version at `operational_hours` */
  operatingHoursData?: Maybe<Array<Maybe<WarehouseOperatingHour>>>;
  /** PIC name */
  picName?: Maybe<Scalars['String']>;
  /** PIC telephone */
  picTelephone?: Maybe<Scalars['String']>;
  /** Warehouse's province. This is based on google map */
  province?: Maybe<Scalars['String']>;
  /** Shipper detail */
  shipper?: Maybe<CompanyNode>;
  /** Warehouse's status */
  status?: Maybe<Scalars['WarehouseStatusConvert']>;
  /** Warehouse's type */
  type?: Maybe<Scalars['String']>;
  /** Warehouse's zipcode */
  zipcode?: Maybe<Scalars['String']>;
};

export type WarehouseConnection = {
  __typename?: 'WarehouseConnection';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<WarehouseConnectionEdge>>>;
  pageInfo: PageInfo;
};

export type WarehouseConnectionEdge = {
  __typename?: 'WarehouseConnectionEdge';
  cursor: Scalars['String'];
  node?: Maybe<Warehouse>;
};

export enum WarehouseFields {
  Address = 'ADDRESS',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type WarehouseInputType = {
  /** Full warehouse address */
  address?: InputMaybe<Scalars['String']>;
  /** Warehouse city */
  city?: InputMaybe<Scalars['String']>;
  /** Company that own the warehouse */
  companyKsuid?: InputMaybe<Scalars['String']>;
  /** Warehouse GPS coordinate data will be prefilled from place_id if new/existing coordinate is null */
  coordinate?: InputMaybe<CoordinateInput>;
  /** Warehouse country */
  country?: InputMaybe<Scalars['String']>;
  /** Warehouse district */
  district?: InputMaybe<Scalars['String']>;
  /** Warehouse GMaps Url */
  googleMapUrl?: InputMaybe<Scalars['String']>;
  /** Warehouse ksuid for update */
  ksuid?: InputMaybe<Scalars['String']>;
  /** Warehouse name */
  name?: InputMaybe<Scalars['String']>;
  /** Notes related to the warehouse */
  notes?: InputMaybe<Scalars['String']>;
  /** Operation hours data in structured data form, mutually exclusive to free text version at operational_hours */
  operatingHoursData?: InputMaybe<Array<InputMaybe<WarehouseOperatingHourInput>>>;
  /** Warehouse PIC name */
  picName?: InputMaybe<Scalars['String']>;
  /** Warehouse PIC telephone */
  picTelephone?: InputMaybe<Scalars['String']>;
  /** Warehouse province */
  province?: InputMaybe<Scalars['String']>;
  /** Warehouse status */
  status?: InputMaybe<WarehouseStatusEnum>;
  /** Warehouse type */
  type?: InputMaybe<Scalars['String']>;
  /** Warehouse Zipcode */
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Object representing single entry operating hour for a warehouse */
export type WarehouseOperatingHour = {
  __typename?: 'WarehouseOperatingHour';
  /** Closing hour in HH:mm format, ex: 07.00. For 24 hour this should be 00.00 */
  closingHour?: Maybe<Scalars['String']>;
  /** Day in string, ex: MONDAY, TUESDAY. refer to constants -> company -> warehouse for more detailed reference */
  day?: Maybe<Scalars['String']>;
  /** Opening hour in HH:mm format, ex: 07.00. For 24 hour this should be 00.00 */
  openingHour?: Maybe<Scalars['String']>;
};

export type WarehouseOperatingHourInput = {
  /** Closing hour in HH:mm format, ex: 07.00. For 24 hour this should be 00.00 */
  closingHour: Scalars['String'];
  /** Day in string, ex: MONDAY, TUESDAY. refer to constants -> company -> warehouse for more detailed reference */
  day: Scalars['String'];
  /** Opening hour in HH:mm format, ex: 07.00. For 24 hour this should be 00.00 */
  openingHour: Scalars['String'];
};

export type WarehouseSortInput = {
  field: WarehouseFields;
  order: SortOrder;
};

export enum WarehouseStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum WarehouseTypeEnum {
  Destination = 'DESTINATION',
  Origin = 'ORIGIN'
}

export type BroadcastWaPaymentStatementNode = {
  __typename?: 'broadcastWAPaymentStatementNode';
  /** Payable Ksuid */
  payableKsuid?: Maybe<Scalars['String']>;
  /** Result status of the process */
  result?: Maybe<Array<Maybe<BroadcastWaPaymentStatementResult>>>;
};

export type BroadcastWaPaymentStatementResult = {
  __typename?: 'broadcastWAPaymentStatementResult';
  /** Message of broadcast WA payment statement */
  message?: Maybe<Scalars['String']>;
  /** Phone number destination */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Success status of broadcast WA payment statement */
  success?: Maybe<Scalars['Boolean']>;
};

export type DaysSummary = {
  __typename?: 'daysSummary';
  /** number of days with DO within the contract period */
  daysWithDO?: Maybe<Scalars['Int']>;
  /** number of days with DO within the current payable item stage */
  daysWithDOMultiplier?: Maybe<Scalars['Int']>;
  /** number of days without DO within the contract period */
  daysWithoutDO?: Maybe<Scalars['Int']>;
  /** number of working days within the contract period */
  workingDays?: Maybe<Scalars['Int']>;
};

export type DoSnapshot = {
  __typename?: 'doSnapshot';
  /** DO delivery date */
  deliveryDate?: Maybe<Scalars['DateTime']>;
  /** DO number */
  externalID?: Maybe<Scalars['String']>;
  /** DO ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** DO status */
  status?: Maybe<Scalars['String']>;
};

export type PaginatedAwbs = {
  __typename?: 'paginatedAwbs';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedAwbsEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedAwbsEdge = {
  __typename?: 'paginatedAwbsEdge';
  cursor: Scalars['String'];
  node?: Maybe<AwbNode>;
};

export type PaginatedDispatchGroups = {
  __typename?: 'paginatedDispatchGroups';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedDispatchGroupsEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedDispatchGroupsEdge = {
  __typename?: 'paginatedDispatchGroupsEdge';
  cursor: Scalars['String'];
  node?: Maybe<DispatchGroups>;
};

export type PaginatedPayableFiles = {
  __typename?: 'paginatedPayableFiles';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedPayableFilesEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedPayableFilesEdge = {
  __typename?: 'paginatedPayableFilesEdge';
  cursor: Scalars['String'];
  node?: Maybe<PayableFileNode>;
};

export type PaginatedPayables = {
  __typename?: 'paginatedPayables';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedPayablesEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedPayablesEdge = {
  __typename?: 'paginatedPayablesEdge';
  cursor: Scalars['String'];
  node?: Maybe<PayableNode>;
};

export type PaginatedProjects = {
  __typename?: 'paginatedProjects';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedProjectsEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedProjectsEdge = {
  __typename?: 'paginatedProjectsEdge';
  cursor: Scalars['String'];
  node?: Maybe<ProjectNode>;
};

export type PaginatedReceivables = {
  __typename?: 'paginatedReceivables';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedReceivablesEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedReceivablesEdge = {
  __typename?: 'paginatedReceivablesEdge';
  cursor: Scalars['String'];
  node?: Maybe<ReceivableNode>;
};

export type PaginatedShippers = {
  __typename?: 'paginatedShippers';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedShippersEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedShippersEdge = {
  __typename?: 'paginatedShippersEdge';
  cursor: Scalars['String'];
  node?: Maybe<ShipperNode>;
};

export type PaginatedTransporterPipelines = {
  __typename?: 'paginatedTransporterPipelines';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedTransporterPipelinesEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedTransporterPipelinesEdge = {
  __typename?: 'paginatedTransporterPipelinesEdge';
  cursor: Scalars['String'];
  node?: Maybe<TransporterPipelineNode>;
};

export type PaginatedTransporters = {
  __typename?: 'paginatedTransporters';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedTransportersEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedTransportersEdge = {
  __typename?: 'paginatedTransportersEdge';
  cursor: Scalars['String'];
  node?: Maybe<TransporterNode>;
};

export type PaginatedVehicles = {
  __typename?: 'paginatedVehicles';
  count: Scalars['Int'];
  edges?: Maybe<Array<Maybe<PaginatedVehiclesEdge>>>;
  pageInfo: PageInfo;
};

export type PaginatedVehiclesEdge = {
  __typename?: 'paginatedVehiclesEdge';
  cursor: Scalars['String'];
  node?: Maybe<CompanyVehicleNode>;
};

export type PayableAdjustmentNode = {
  __typename?: 'payableAdjustmentNode';
  /** Payable Adjustment amount */
  amount?: Maybe<Scalars['Decimal']>;
  /** Payable Adjustment created */
  insertedAt?: Maybe<Scalars['String']>;
  /** Payable Adjustment ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Payable Adjustment notes */
  notes?: Maybe<Scalars['String']>;
  /** Payable Adjustment's item ksuid */
  payableItemKsuid?: Maybe<Scalars['String']>;
  /** Payable Adjustment's parent ksuid */
  payableKsuid?: Maybe<Scalars['String']>;
  /** Payable Adjustment review status */
  reviewStatus?: Maybe<Scalars['String']>;
  /** Payable Adjustment reviewed by */
  reviewedBy?: Maybe<Scalars['JSON']>;
  /** Payable Adjustment status */
  status?: Maybe<Scalars['String']>;
  /** Payable Adjustment minus state */
  typeIsMinus?: Maybe<Scalars['Boolean']>;
  /** Payable Adjustment type */
  typeName?: Maybe<Scalars['String']>;
  /** Payable Adjustment latest update */
  updatedAt?: Maybe<Scalars['String']>;
};

export type PayableFileNode = {
  __typename?: 'payableFileNode';
  /** Payable File deleted state */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Payable File ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Payable File name */
  name?: Maybe<Scalars['String']>;
  /** Payable File's parent ksuid */
  payableKsuid?: Maybe<Scalars['String']>;
  /** Payable File url */
  url?: Maybe<Scalars['String']>;
};

export type PayableItemNode = {
  __typename?: 'payableItemNode';
  /** Payable item payment amount */
  amount?: Maybe<Scalars['Decimal']>;
  /** Payable Item AWB */
  awb?: Maybe<AwbNode>;
  /** Payable Item AWB ksuid */
  awbKsuid?: Maybe<Scalars['String']>;
  /** Payable Item disburse date */
  disburseDate?: Maybe<Scalars['String']>;
  /** Payable Item distribute to shipper proof upload URL */
  dspUpload?: Maybe<Scalars['String']>;
  /** Payable Item hold reason */
  holdReason?: Maybe<Scalars['String']>;
  /** Payable Item created */
  insertedAt?: Maybe<Scalars['String']>;
  /** Payable Item ksuid */
  ksuid?: Maybe<Scalars['String']>;
  /** Payable Item notes */
  notes?: Maybe<Scalars['String']>;
  /** Payable item's adjustments */
  payableAdjustments?: Maybe<Array<Maybe<PayableAdjustmentNode>>>;
  /** Payable Item parent ksuid */
  payableKsuid?: Maybe<Scalars['String']>;
  /** Payable item payment schedule */
  paymentSchedule?: Maybe<Scalars['String']>;
  /** Payable item payment stage */
  paymentStage?: Maybe<Scalars['Int']>;
  /** Payable Item proof of transfer upload URL */
  potUpload?: Maybe<Scalars['String']>;
  /** Payable Item review status */
  reviewStatus?: Maybe<Scalars['String']>;
  /** Payable Item review status category */
  reviewStatusCategory?: Maybe<Scalars['String']>;
  /** Payable Item review status reason */
  reviewStatusReason?: Maybe<Scalars['String']>;
  /** Payable Item reviewed by */
  reviewedBy?: Maybe<Scalars['JSON']>;
  /** Payable Item status */
  status?: Maybe<Scalars['String']>;
  /** Payable Item type */
  type?: Maybe<Scalars['String']>;
  /** Payable Item latest update */
  updatedAt?: Maybe<Scalars['String']>;
};

export enum PayablePaymentRequestStatusEnum {
  Disbursed = 'DISBURSED',
  DisbursementFailed = 'DISBURSEMENT_FAILED',
  FinanceApproved = 'FINANCE_APPROVED',
  FinanceCancelled = 'FINANCE_CANCELLED',
  FinanceOnHold = 'FINANCE_ON_HOLD',
  Processing = 'PROCESSING'
}

export enum PayableRequestedSummariesEnum {
  TotalCollectedAmount = 'TOTAL_COLLECTED_AMOUNT',
  TotalRequestedAmount = 'TOTAL_REQUESTED_AMOUNT'
}

export type PaymentStatementNotification = {
  __typename?: 'paymentStatementNotification';
  /** Success sending email */
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentStatementPageNode = {
  __typename?: 'paymentStatementPageNode';
  /** Payable's adjustments */
  adjustmentDetails?: Maybe<Array<Maybe<PayableAdjustmentNode>>>;
  /** Payable's contract detail */
  contract?: Maybe<ContractNode>;
  /** Days summary data */
  daysSummary?: Maybe<DaysSummary>;
  /** List of DO */
  doList?: Maybe<Array<Maybe<DoSnapshot>>>;
  /** License plate number */
  licensePlateNumber?: Maybe<Scalars['String']>;
  /** Payable's items detail */
  paymentDetails?: Maybe<Array<Maybe<PayableItemNode>>>;
  /** Payable's transporter detail */
  transporter?: Maybe<CompanyNode>;
  /** Transporter name */
  transporterName?: Maybe<Scalars['String']>;
  /** Vehicle contract code */
  vehicleContractCode?: Maybe<Scalars['String']>;
};

export type PriceSummary = {
  __typename?: 'priceSummary';
  /** DailyIncentivePrice from Contract */
  dailyIncentivePrice?: Maybe<Scalars['Float']>;
  /** DailyRentalPrice from Contract */
  dailyRentalPrice?: Maybe<Scalars['Float']>;
};

export type ReviewPayableItemNode = {
  __typename?: 'reviewPayableItemNode';
  /** Payable Adjusment */
  adjustment?: Maybe<PayableAdjustmentNode>;
  /** Days summary data */
  daysSummary?: Maybe<DaysSummary>;
  /** PayablePriceSummary */
  price?: Maybe<PriceSummary>;
  /** Payment Stage Amount */
  rentalPayment?: Maybe<Scalars['Float']>;
};

export enum TotalPayablesByReviewStatus {
  ArrivedAtHub = 'ARRIVED_AT_HUB',
  Cancelled = 'CANCELLED',
  Disbursed = 'DISBURSED',
  DisbursementFailed = 'DISBURSEMENT_FAILED',
  FinanceApproved = 'FINANCE_APPROVED',
  FinanceCancelled = 'FINANCE_CANCELLED',
  FinanceOnHold = 'FINANCE_ON_HOLD',
  Hold = 'HOLD',
  NeedsReview = 'NEEDS_REVIEW',
  NotDue = 'NOT_DUE',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  Reviewed = 'REVIEWED'
}

export type Get_Payment_Statement_PageQueryVariables = Exact<{
  payableKsuid: Scalars['String'];
}>;


export type Get_Payment_Statement_PageQuery = { __typename?: 'Query', paymentStatementPage?: { __typename?: 'paymentStatementPageNode', vehicleContractCode?: string | null, licensePlateNumber?: string | null, transporterName?: string | null, transporter?: { __typename?: 'CompanyNode', name?: string | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', email?: string | null, phoneNumber?: string | null } | null> | null } | null, contract?: { __typename?: 'ContractNode', contractCode?: string | null, paymentScheme?: PaymentSchemeType | null, supplyType?: string | null, startDate?: string | null, endDate?: string | null } | null, paymentDetails?: Array<{ __typename?: 'payableItemNode', ksuid?: string | null, paymentStage?: number | null, type?: string | null, amount?: any | null, paymentSchedule?: string | null, reviewStatus?: string | null, disburseDate?: string | null } | null> | null, adjustmentDetails?: Array<{ __typename?: 'payableAdjustmentNode', ksuid?: string | null, typeIsMinus?: boolean | null, typeName?: string | null, notes?: string | null, amount?: any | null, reviewStatus?: string | null, status?: string | null } | null> | null, daysSummary?: { __typename?: 'daysSummary', workingDays?: number | null, daysWithDO?: number | null, daysWithoutDO?: number | null } | null, doList?: Array<{ __typename?: 'doSnapshot', deliveryDate?: any | null, externalID?: string | null, ksuid?: string | null, status?: string | null } | null> | null } | null };

export type Delete_Payable_AdjustmentMutationVariables = Exact<{
  ksuid: Scalars['String'];
}>;


export type Delete_Payable_AdjustmentMutation = { __typename?: 'Mutation', deletePayableAdjustment?: { __typename?: 'DeleteResponse', deleted?: boolean | null, ksuid?: string | null } | null };

export type Shipper_Review_Paginated_PayablesQueryVariables = Exact<{
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<PayableSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Shipper_Review_Paginated_PayablesQuery = { __typename?: 'Query', paginatedPayables?: { __typename?: 'paginatedPayables', count: number, edges?: Array<{ __typename?: 'paginatedPayablesEdge', node?: { __typename?: 'PayableNode', collectedAmount?: any | null, deliveryOrderKsuid?: string | null, expectedAmount?: any | null, holdReason?: string | null, ksuid?: string | null, nextReviewStatus?: string | null, notes?: string | null, paymentRequestStatus?: string | null, paymentSchedule?: string | null, potUpload?: string | null, projectKsuid?: string | null, reviewStatus?: string | null, shipperKsuid?: string | null, type?: string | null, updatedAt?: string | null, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryDate?: string | null, externalId?: string | null, polUpload?: string | null } | null, payableItems?: Array<{ __typename?: 'payableItemNode', awbKsuid?: string | null, dspUpload?: string | null, holdReason?: string | null, ksuid?: string | null, potUpload?: string | null, status?: string | null, awb?: { __typename?: 'AwbNode', awbId?: string | null, codAmount?: any | null, collectedCodAmount?: any | null, completeStatus?: AwbCompleteStatusEnum | null, dropOrder?: number | null, incompleteReason?: string | null, podUpload?: string | null, taskId?: string | null, job?: { __typename?: 'JobNode', destinationName?: string | null } | null } | null, payableAdjustments?: Array<{ __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableItemKsuid?: string | null, payableKsuid?: string | null, status?: string | null, typeIsMinus?: boolean | null, typeName?: string | null } | null> | null } | null> | null, project?: { __typename?: 'ProjectNode', ksuid?: string | null, name?: string | null, routeType?: string | null, type?: string | null } | null, shipper?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Shipper_Review_Save_PayableMutationVariables = Exact<{
  holdReason?: InputMaybe<Scalars['String']>;
  isHoldDo?: InputMaybe<Scalars['Boolean']>;
  ksuid: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableReviewStatusEnum>;
}>;


export type Shipper_Review_Save_PayableMutation = { __typename?: 'Mutation', savePayable?: { __typename?: 'PayableNode', collectedAmount?: any | null, expectedAmount?: any | null, holdReason?: string | null, ksuid?: string | null, notes?: string | null, paymentRequestStatus?: string | null, paymentSchedule?: string | null, potUpload?: string | null, projectKsuid?: string | null, reviewStatus?: string | null, shipperKsuid?: string | null, type?: string | null, deliveryOrder?: { __typename?: 'DeliveryOrder', externalId?: string | null, ksuid?: string | null } | null, project?: { __typename?: 'ProjectNode', ksuid?: string | null, name?: string | null } | null } | null };

export type Shipper_Review_Save_Payable_AdjustmentMutationVariables = Exact<{
  amount: Scalars['Int'];
  ksuid?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payableItemKsuid?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableAdjustmentStatusEnum>;
  typeName?: InputMaybe<PayableAdjustmentTypeEnum>;
}>;


export type Shipper_Review_Save_Payable_AdjustmentMutation = { __typename?: 'Mutation', savePayableAdjustment?: { __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, payableItemKsuid?: string | null, payableKsuid?: string | null, notes?: string | null, status?: string | null, typeName?: string | null } | null };

export type Shipper_Review_Save_Payable_ItemMutationVariables = Exact<{
  awb?: InputMaybe<PayableItemAwbInput>;
  awbKsuid?: InputMaybe<Scalars['String']>;
  dspUpload?: InputMaybe<Scalars['String']>;
  holdReason?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableItemStatusEnum>;
}>;


export type Shipper_Review_Save_Payable_ItemMutation = { __typename?: 'Mutation', savePayableItem?: { __typename?: 'payableItemNode', awbKsuid?: string | null, dspUpload?: string | null, holdReason?: string | null, ksuid?: string | null, notes?: string | null, payableKsuid?: string | null, potUpload?: string | null, status?: string | null, type?: string | null, awb?: { __typename?: 'AwbNode', actualCompleted?: string | null, awbId?: string | null, cancelReason?: string | null, codAmount?: any | null, collectedCodAmount?: any | null, completeStatus?: AwbCompleteStatusEnum | null, deliveryDate?: string | null, dropOrder?: number | null, itemDetails?: string | null, ksuid?: string | null, status?: string | null, taskId?: string | null, updatedAt?: string | null } | null } | null };

export type Submit_PayablesMutationVariables = Exact<{
  grandTotal?: InputMaybe<Scalars['Float']>;
  ksuids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  reviewStatus: PayableSubmitReviewStatusEnum;
}>;


export type Submit_PayablesMutation = { __typename?: 'Mutation', submitPayables?: Array<{ __typename?: 'PayableKsuidNode', ksuid?: string | null } | null> | null };

export type Sync_Shipper_PayableMutationVariables = Exact<{
  ksuid: Scalars['String'];
}>;


export type Sync_Shipper_PayableMutation = { __typename?: 'Mutation', syncShipperPayable?: Array<{ __typename?: 'payableItemNode', amount?: any | null, awbKsuid?: string | null, disburseDate?: string | null, insertedAt?: string | null, ksuid?: string | null, notes?: string | null, payableKsuid?: string | null, potUpload?: string | null, reviewStatus?: string | null, reviewedBy?: any | null, type?: string | null, updatedAt?: string | null, payableAdjustments?: Array<{ __typename?: 'payableAdjustmentNode', ksuid?: string | null } | null> | null } | null> | null };

export type Paginated_Payables_Due_StatusQueryVariables = Exact<{ [key: string]: never; }>;


export type Paginated_Payables_Due_StatusQuery = { __typename?: 'Query', upcomingCount?: { __typename?: 'paginatedPayables', count: number } | null, overdueCount?: { __typename?: 'paginatedPayables', count: number } | null };

export type Payables_SummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type Payables_SummaryQuery = { __typename?: 'Query', payableSummary?: Array<{ __typename?: 'PayableSummary', amount?: any | null, type?: string | null } | null> | null };

export type Get_Payable_Do_SummaryQueryVariables = Exact<{
  payableKsuid: Scalars['String'];
}>;


export type Get_Payable_Do_SummaryQuery = { __typename?: 'Query', payableDoSummary?: { __typename?: 'PayableDoSummaryNode', daysSummary?: { __typename?: 'daysSummary', workingDays?: number | null, daysWithDO?: number | null, daysWithoutDO?: number | null } | null, doList?: Array<{ __typename?: 'doSnapshot', deliveryDate?: any | null, externalID?: string | null, ksuid?: string | null, status?: string | null } | null> | null } | null };

export type Get_Review_Payable_ItemQueryVariables = Exact<{
  payableItemKsuid: Scalars['String'];
}>;


export type Get_Review_Payable_ItemQuery = { __typename?: 'Query', reviewPayableItem?: { __typename?: 'reviewPayableItemNode', rentalPayment?: number | null, adjustment?: { __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableItemKsuid?: string | null, payableKsuid?: string | null, reviewStatus?: string | null, reviewedBy?: any | null, status?: string | null, typeIsMinus?: boolean | null, updatedAt?: string | null } | null, daysSummary?: { __typename?: 'daysSummary', daysWithDO?: number | null, daysWithoutDO?: number | null, workingDays?: number | null } | null, price?: { __typename?: 'priceSummary', dailyIncentivePrice?: number | null, dailyRentalPrice?: number | null } | null } | null };

export type Get_Transporter_Dedicated_Review_PayablesQueryVariables = Exact<{
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<PayableSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Get_Transporter_Dedicated_Review_PayablesQuery = { __typename?: 'Query', paginatedPayables?: { __typename?: 'paginatedPayables', count: number, edges?: Array<{ __typename?: 'paginatedPayablesEdge', node?: { __typename?: 'PayableNode', collectedAmount?: any | null, expectedAmount?: any | null, ksuid?: string | null, notes?: string | null, paymentSchedule?: string | null, projectKsuid?: string | null, reviewStatus?: string | null, transporterKsuid?: string | null, type?: string | null, updatedAt?: string | null, vehicleContractCode?: string | null, contract?: { __typename?: 'ContractNode', contractCode?: string | null, dailyIncentivePrice?: any | null, dailyRentalPrice?: any | null, endDate?: string | null, ksuid?: string | null, paymentScheme?: PaymentSchemeType | null, startDate?: string | null, supplyType?: string | null, type?: string | null } | null, payableAdjustments?: Array<{ __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableKsuid?: string | null, reviewStatus?: string | null, status?: string | null, typeIsMinus?: boolean | null, typeName?: string | null } | null> | null, payableFiles?: Array<{ __typename?: 'payableFileNode', ksuid?: string | null, name?: string | null } | null> | null, payableItems?: Array<{ __typename?: 'payableItemNode', amount?: any | null, disburseDate?: string | null, holdReason?: string | null, ksuid?: string | null, paymentSchedule?: string | null, paymentStage?: number | null, reviewStatus?: string | null, reviewStatusReason?: string | null, status?: string | null, type?: string | null, payableAdjustments?: Array<{ __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableItemKsuid?: string | null, reviewedBy?: any | null, typeIsMinus?: boolean | null, updatedAt?: string | null } | null> | null } | null> | null, transporter?: { __typename?: 'TransporterNode', companyKsuid?: string | null, insuranceActive?: boolean | null, company?: { __typename?: 'CompanyNode', name?: string | null, companyDocuments?: Array<{ __typename?: 'CompanyDocumentNode', documentType?: string | null, documentUpload?: string | null, expiryDate?: string | null, ksuid?: string | null, metadata?: string | null } | null> | null } | null } | null, vehicleAllocation?: { __typename?: 'VehicleAllocationNode', companyVehicle?: { __typename?: 'CompanyVehicleNode', vehicle?: { __typename?: 'VehicleNode', licensePlateNumber?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type Save_Payable_Item_AdjustmentMutationVariables = Exact<{
  amount: Scalars['Int'];
  ksuid?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payableItemKsuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableAdjustmentStatusEnum>;
  typeName?: InputMaybe<PayableAdjustmentTypeEnum>;
}>;


export type Save_Payable_Item_AdjustmentMutation = { __typename?: 'Mutation', savePayableAdjustment?: { __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableItemKsuid?: string | null, status?: string | null, typeName?: string | null } | null };

export type Review_Oncall_Paginated_PayablesQueryVariables = Exact<{
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<PayableSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Review_Oncall_Paginated_PayablesQuery = { __typename?: 'Query', paginatedPayables?: { __typename?: 'paginatedPayables', count: number, edges?: Array<{ __typename?: 'paginatedPayablesEdge', node?: { __typename?: 'PayableNode', collectedAmount?: any | null, expectedAmount?: any | null, ksuid?: string | null, notes?: string | null, paymentSchedule?: string | null, podUpload?: string | null, projectKsuid?: string | null, reviewStatus?: string | null, transporterKsuid?: string | null, type?: string | null, updatedAt?: string | null, vehicleContractCode?: string | null, contract?: { __typename?: 'ContractNode', contractCode?: string | null, endDate?: string | null, ksuid?: string | null, paymentScheme?: PaymentSchemeType | null, startDate?: string | null, supplyType?: string | null, type?: string | null } | null, deliveryOrder?: { __typename?: 'DeliveryOrder', deliveryDate?: string | null, externalId?: string | null, polUpload?: string | null } | null, payableAdjustments?: Array<{ __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, notes?: string | null, payableKsuid?: string | null, reviewStatus?: string | null, status?: string | null, typeIsMinus?: boolean | null, typeName?: string | null } | null> | null, payableFiles?: Array<{ __typename?: 'payableFileNode', ksuid?: string | null, name?: string | null } | null> | null, payableItems?: Array<{ __typename?: 'payableItemNode', amount?: any | null, disburseDate?: string | null, holdReason?: string | null, ksuid?: string | null, paymentSchedule?: string | null, paymentStage?: number | null, reviewStatus?: string | null, reviewStatusReason?: string | null, status?: string | null, type?: string | null } | null> | null, transporter?: { __typename?: 'TransporterNode', companyKsuid?: string | null, insuranceActive?: boolean | null, company?: { __typename?: 'CompanyNode', name?: string | null, companyDocuments?: Array<{ __typename?: 'CompanyDocumentNode', documentType?: string | null, documentUpload?: string | null, expiryDate?: string | null, ksuid?: string | null, metadata?: string | null } | null> | null } | null } | null, vehicleAllocation?: { __typename?: 'VehicleAllocationNode', companyVehicle?: { __typename?: 'CompanyVehicleNode', vehicle?: { __typename?: 'VehicleNode', licensePlateNumber?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type Paginated_Payable_FilesQueryVariables = Exact<{
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  page: Scalars['Int'];
  payableKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type Paginated_Payable_FilesQuery = { __typename?: 'Query', paginatedPayableFiles?: { __typename?: 'paginatedPayableFiles', count: number, edges?: Array<{ __typename?: 'paginatedPayableFilesEdge', node?: { __typename?: 'payableFileNode', isDeleted?: boolean | null, ksuid?: string | null, name?: string | null, payableKsuid?: string | null, url?: string | null } | null } | null> | null } | null };

export type Transporter_Review_Save_PayableMutationVariables = Exact<{
  holdReason?: InputMaybe<Scalars['String']>;
  ksuid: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableReviewStatusEnum>;
}>;


export type Transporter_Review_Save_PayableMutation = { __typename?: 'Mutation', savePayable?: { __typename?: 'PayableNode', collectedAmount?: any | null, expectedAmount?: any | null, holdReason?: string | null, ksuid?: string | null, notes?: string | null, paymentRequestStatus?: string | null, paymentSchedule?: string | null, potUpload?: string | null, projectKsuid?: string | null, reviewStatus?: string | null, shipperKsuid?: string | null, type?: string | null, deliveryOrder?: { __typename?: 'DeliveryOrder', externalId?: string | null, ksuid?: string | null } | null, project?: { __typename?: 'ProjectNode', ksuid?: string | null, name?: string | null } | null } | null };

export type Transporter_Review_Save_Payable_AdjustmentMutationVariables = Exact<{
  amount: Scalars['Int'];
  ksuid?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PayableAdjustmentStatusEnum>;
  typeName?: InputMaybe<PayableAdjustmentTypeEnum>;
}>;


export type Transporter_Review_Save_Payable_AdjustmentMutation = { __typename?: 'Mutation', savePayableAdjustment?: { __typename?: 'payableAdjustmentNode', amount?: any | null, ksuid?: string | null, payableKsuid?: string | null, notes?: string | null, status?: string | null, typeName?: string | null } | null };

export type Save_Payable_FileMutationVariables = Exact<{
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payableKsuid?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
}>;


export type Save_Payable_FileMutation = { __typename?: 'Mutation', savePayableFile?: { __typename?: 'payableFileNode', isDeleted?: boolean | null, ksuid?: string | null, name?: string | null, payableKsuid?: string | null, url?: string | null } | null };

export type Transporter_Review_Save_Payable_ItemMutationVariables = Exact<{
  awb?: InputMaybe<PayableItemAwbInput>;
  awbKsuid?: InputMaybe<Scalars['String']>;
  dspUpload?: InputMaybe<Scalars['String']>;
  holdReason?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  potUpload?: InputMaybe<Scalars['String']>;
  reviewStatusReason?: InputMaybe<Scalars['String']>;
  reviewStatus?: InputMaybe<PayableItemReviewStatusEnum>;
  status?: InputMaybe<PayableItemStatusEnum>;
}>;


export type Transporter_Review_Save_Payable_ItemMutation = { __typename?: 'Mutation', savePayableItem?: { __typename?: 'payableItemNode', awbKsuid?: string | null, dspUpload?: string | null, holdReason?: string | null, ksuid?: string | null, notes?: string | null, payableKsuid?: string | null, potUpload?: string | null, status?: string | null, type?: string | null, awb?: { __typename?: 'AwbNode', actualCompleted?: string | null, awbId?: string | null, cancelReason?: string | null, codAmount?: any | null, collectedCodAmount?: any | null, completeStatus?: AwbCompleteStatusEnum | null, deliveryDate?: string | null, dropOrder?: number | null, itemDetails?: string | null, ksuid?: string | null, status?: string | null, taskId?: string | null, updatedAt?: string | null } | null } | null };

export type Paginated_List_Do_FleetsQueryVariables = Exact<{
  searchProjectId?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
  searchShipmentDate?: InputMaybe<FilterDoDeliveryDate>;
}>;


export type Paginated_List_Do_FleetsQuery = { __typename?: 'Query', paginatedDeliveryOrders?: { __typename?: 'DeliveryOrderConnection', count: number, edges?: Array<{ __typename?: 'DeliveryOrderConnectionEdge', cursor: string, node?: { __typename?: 'DeliveryOrder', externalId?: string | null, ksuid?: string | null } | null } | null> | null } | null };

export type Receivables_Fleets_CountsQueryVariables = Exact<{ [key: string]: never; }>;


export type Receivables_Fleets_CountsQuery = { __typename?: 'Query', notInvoicedCount?: { __typename?: 'paginatedReceivables', count: number } | null, onGoingInvoiceCount?: { __typename?: 'paginatedReceivables', count: number } | null, partiallyInvoiceCount?: { __typename?: 'paginatedReceivables', count: number } | null, partiallyPaidCount?: { __typename?: 'paginatedReceivables', count: number } | null, paidCount?: { __typename?: 'paginatedReceivables', count: number } | null };

export type Paginated_Do_Receivables_CountQueryVariables = Exact<{ [key: string]: never; }>;


export type Paginated_Do_Receivables_CountQuery = { __typename?: 'Query', notInvoicedCount?: { __typename?: 'paginatedReceivables', count: number } | null, partiallyInvoicedCount?: { __typename?: 'paginatedReceivables', count: number } | null, ongoingInvoiceCount?: { __typename?: 'paginatedReceivables', count: number } | null, partiallyPaidCount?: { __typename?: 'paginatedReceivables', count: number } | null, paidCount?: { __typename?: 'paginatedReceivables', count: number } | null };

export type Paginated_Delivery_OrdersQueryVariables = Exact<{
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
}>;


export type Paginated_Delivery_OrdersQuery = { __typename?: 'Query', paginatedDeliveryOrders?: { __typename?: 'DeliveryOrderConnection', count: number, edges?: Array<{ __typename?: 'DeliveryOrderConnectionEdge', cursor: string, node?: { __typename?: 'DeliveryOrder', externalId?: string | null, ksuid?: string | null } | null } | null> | null } | null };

export type Save_Do_AllocationMutationVariables = Exact<{
  actualOvertimeHours?: InputMaybe<Scalars['Float']>;
  actualPricingUnit?: InputMaybe<Scalars['Float']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  companyDriverKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleReplacementKsuid?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  discount?: InputMaybe<Scalars['Boolean']>;
  discountFlatValue?: InputMaybe<Scalars['Float']>;
  discountPercentageMaxAmount?: InputMaybe<Scalars['Float']>;
  discountPercentageValue?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<Scalars['String']>;
  doNumber?: InputMaybe<Scalars['String']>;
  driverNotes?: InputMaybe<Scalars['String']>;
  extraHelperAmount?: InputMaybe<Scalars['Int']>;
  extraHelperPrice?: InputMaybe<Scalars['Float']>;
  insuranceLoadValue?: InputMaybe<Scalars['Float']>;
  insurancePrice?: InputMaybe<Scalars['Float']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  isCancel?: InputMaybe<Scalars['Boolean']>;
  ksuid?: InputMaybe<Scalars['String']>;
  originKsuid?: InputMaybe<Scalars['String']>;
  podReturnAddress?: InputMaybe<Scalars['String']>;
  podReturnPrice?: InputMaybe<Scalars['Float']>;
  priceFinal?: InputMaybe<Scalars['Float']>;
  priceSuggestion?: InputMaybe<Scalars['Float']>;
  productType?: InputMaybe<DoProductTypeEnum>;
  projectKsuid?: InputMaybe<Scalars['String']>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperNotes?: InputMaybe<Scalars['String']>;
}>;


export type Save_Do_AllocationMutation = { __typename?: 'Mutation', saveDeliveryOrder?: { __typename?: 'DeliveryOrder', jobKsuid?: string | null, ksuid?: string | null, shipmentKsuid?: string | null } | null };

export type Get_Driver_OptionsQueryVariables = Exact<{
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  page: Scalars['Int'];
  projectKsuid?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  withContractActiveOnDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type Get_Driver_OptionsQuery = { __typename?: 'Query', paginatedDrivers?: { __typename?: 'DriverConnection', count: number, edges?: Array<{ __typename?: 'DriverConnectionEdge', node?: { __typename?: 'CompanyDriver', ksuid?: string | null, contracts?: Array<{ __typename?: 'BasicContractNode', status?: Status | null, supplyType?: string | null, ksuid?: string | null, type?: string | null } | null> | null, driver?: { __typename?: 'Driver', contactNumber?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Get_Transporter_OptionsQueryVariables = Exact<{
  first: Scalars['Int'];
  page: Scalars['Int'];
  filterByTypes?: InputMaybe<Array<InputMaybe<TransporterType>> | InputMaybe<TransporterType>>;
  searchName?: InputMaybe<Scalars['String']>;
}>;


export type Get_Transporter_OptionsQuery = { __typename?: 'Query', paginatedTransporters?: { __typename?: 'paginatedTransporters', count: number, edges?: Array<{ __typename?: 'paginatedTransportersEdge', node?: { __typename?: 'TransporterNode', companyKsuid?: string | null, company?: { __typename?: 'CompanyNode', name?: string | null } | null } | null } | null> | null } | null };

export type Get_Vehicle_OptionsQueryVariables = Exact<{
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  isReplacementFleet?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  projectKsuid?: InputMaybe<Scalars['String']>;
  searchLicensePlate?: InputMaybe<Scalars['String']>;
  withContractActiveOnDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type Get_Vehicle_OptionsQuery = { __typename?: 'Query', paginatedVehicles?: { __typename?: 'paginatedVehicles', count: number, edges?: Array<{ __typename?: 'paginatedVehiclesEdge', node?: { __typename?: 'CompanyVehicleNode', ksuid: string, contracts?: Array<{ __typename?: 'BasicContractNode', status?: Status | null, supplyType?: string | null, ksuid?: string | null, type?: string | null } | null> | null, vehicle?: { __typename?: 'VehicleNode', licensePlateNumber?: string | null, vehicleType?: { __typename?: 'MDVehicleNode', name?: string | null, subType?: string | null, type?: string | null } | null } | null } | null } | null> | null } | null };

export type Save_Do_Allocation_FormMutationVariables = Exact<{
  companyDriverKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleKsuid?: InputMaybe<Scalars['String']>;
  companyVehicleReplacementKsuid?: InputMaybe<Scalars['String']>;
  doNumber?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
}>;


export type Save_Do_Allocation_FormMutation = { __typename?: 'Mutation', saveDeliveryOrder?: { __typename?: 'DeliveryOrder', jobKsuid?: string | null, ksuid?: string | null, shipmentKsuid?: string | null } | null };

export type Get_Shipment_DispatchQueryVariables = Exact<{
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchPaymentStage?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchVehicleContractCode?: InputMaybe<Scalars['String']>;
  searchPotUpload?: InputMaybe<Scalars['String']>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchReviewStatus?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  filterBySupplyType?: InputMaybe<Array<InputMaybe<ContractSupplyType>> | InputMaybe<ContractSupplyType>>;
  filterByShipmentDate?: InputMaybe<Scalars['DateTime']>;
  filterByContractType?: InputMaybe<Array<InputMaybe<ContractType>> | InputMaybe<ContractType>>;
  filterByTransporterType?: InputMaybe<Array<InputMaybe<TransporterType>> | InputMaybe<TransporterType>>;
}>;


export type Get_Shipment_DispatchQuery = { __typename?: 'Query', paginatedDispatchGroups?: { __typename?: 'paginatedDispatchGroups', count: number, edges?: Array<{ __typename?: 'paginatedDispatchGroupsEdge', node?: { __typename?: 'DispatchGroups', contractType?: string | null, pipelines?: Array<{ __typename?: 'DispatchGroupPipelineNode', pipelineCode?: string | null, contracts?: Array<{ __typename?: 'DispatchGroupPipelineContractNode', endDate?: string | null, rentalPrice?: number | null, startDate?: string | null, supplyType?: string | null } | null> | null, dispatches?: Array<{ __typename?: 'DispatchGroupPipelineDispatchesNode', plateNumber?: string | null, replacementEndDate?: string | null, replacementFleetPlate?: string | null, replacementStartDate?: string | null, drivenBy?: { __typename?: 'DispatchGroupPipelineDispatchesDrivenByNode', contact?: string | null, expirationDate?: string | null, helperContact?: string | null, helperName?: string | null, ktp?: string | null, name?: string | null, npwp?: string | null, replacementDriverEndDate?: string | null, replacementDriverName?: string | null, replacementDriverStartDate?: string | null, sim?: string | null } | null } | null> | null, fleet?: { __typename?: 'DispatchGroupPipelineFleetNode', fleetBodyType?: string | null, fleetType?: string | null } | null, transporter?: { __typename?: 'DispatchGroupPipelineTransporterNode', name?: string | null, transporterType?: string | null } | null } | null> | null, project?: { __typename?: 'DispatchGroupProjectNode', alias?: string | null, ksuid?: string | null, name?: string | null } | null, shipper?: { __typename?: 'DispatchGroupShipperNode', alias?: string | null, ksuid?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Monitoring_ListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchAwbId?: InputMaybe<Scalars['String']>;
  searchContractCode?: InputMaybe<Scalars['String']>;
  searchDestinationPhone?: InputMaybe<Scalars['String']>;
  searchDestinationName?: InputMaybe<Scalars['String']>;
  searchDestinationZipcode?: InputMaybe<Scalars['String']>;
  searchDoNumber?: InputMaybe<Scalars['String']>;
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchItemDetails?: InputMaybe<Scalars['String']>;
  searchOriginName?: InputMaybe<Scalars['String']>;
  searchTaskId?: InputMaybe<Scalars['String']>;
  searchTourId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<AwbSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  statuses?: InputMaybe<Array<InputMaybe<AwbStatusEnum>> | InputMaybe<AwbStatusEnum>>;
  searchCancelReason?: InputMaybe<Scalars['String']>;
  searchCompleteStatuses?: InputMaybe<Array<InputMaybe<AwbCompleteStatusEnum>> | InputMaybe<AwbCompleteStatusEnum>>;
  searchDestinationCity?: InputMaybe<Scalars['String']>;
  searchDriverId?: InputMaybe<Scalars['String']>;
  searchIncompleteReasons?: InputMaybe<Array<InputMaybe<AwbIncompleteReason>> | InputMaybe<AwbIncompleteReason>>;
  searchProjectName?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchTransporterName?: InputMaybe<Scalars['String']>;
  searchVehicleId?: InputMaybe<Scalars['String']>;
  searchVehicleLicensePlate?: InputMaybe<Scalars['String']>;
}>;


export type Monitoring_ListQuery = { __typename?: 'Query', paginatedAwbs?: { __typename?: 'paginatedAwbs', count: number, edges?: Array<{ __typename?: 'paginatedAwbsEdge', cursor: string, node?: { __typename?: 'AwbNode', awbId?: string | null, actualOvertimeHours?: number | null, actualPricingUnit?: number | null, cancelReason?: string | null, codAmount?: any | null, completeStatus?: AwbCompleteStatusEnum | null, deliveryDate?: string | null, destinationZipcode?: string | null, dropOrder?: number | null, incompleteReason?: string | null, itemDetails?: string | null, ksuid?: string | null, latestPossibleCompleted?: string | null, podUpload?: string | null, taskId?: string | null, timestampStatus?: string | null, tourId?: string | null, status?: string | null, updatedAt?: string | null, deliveryOrder?: { __typename?: 'DeliveryOrder', externalId?: string | null, ksuid?: string | null, polUpload?: string | null, companyDriver?: { __typename?: 'CompanyDriver', ksuid?: string | null, driver?: { __typename?: 'Driver', name?: string | null } | null } | null, companyVehicle?: { __typename?: 'CompanyVehicleNode', ksuid: string, vehicle?: { __typename?: 'VehicleNode', licensePlateNumber?: string | null } | null } | null, contract?: { __typename?: 'ContractNode', contractCode?: string | null } | null, job?: { __typename?: 'JobNode', doNumber?: string | null } | null, project?: { __typename?: 'ProjectNode', name?: string | null } | null, shipper?: { __typename?: 'CompanyNode', name?: string | null } | null, transporter?: { __typename?: 'CompanyNode', name?: string | null } | null } | null, job?: { __typename?: 'JobNode', destinationAddress?: string | null, destinationCity?: string | null, destinationGpsLat?: number | null, destinationGpsLng?: number | null, destinationName?: string | null, destinationWarehouseKsuid?: string | null, originAddress?: string | null, originCity?: string | null, originGpsLat?: number | null, originGpsLng?: number | null, originName?: string | null, originWarehouseKsuid?: string | null, destination?: { __typename?: 'Warehouse', notes?: string | null, picName?: string | null, picTelephone?: string | null } | null } | null } | null } | null> | null } | null };

export type Save_Shipment_MonitoringsMutationVariables = Exact<{
  actualOvertimeHours?: InputMaybe<Scalars['Float']>;
  actualPricingUnit?: InputMaybe<Scalars['Float']>;
  awbId?: InputMaybe<Scalars['String']>;
  cancelReason?: InputMaybe<Scalars['String']>;
  codAmount?: InputMaybe<Scalars['Float']>;
  completeStatus?: InputMaybe<AwbCompleteStatusEnum>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrder?: InputMaybe<DeliveryOrderInput>;
  destination?: InputMaybe<WarehouseInputType>;
  incompleteReason?: InputMaybe<AwbIncompleteReason>;
  latestPossibleCompleted?: InputMaybe<Scalars['DateTime']>;
  originKsuid?: InputMaybe<Scalars['String']>;
  podUpload?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AwbStatusEnum>;
  taskId?: InputMaybe<Scalars['String']>;
  timestampStatus?: InputMaybe<Scalars['DateTime']>;
}>;


export type Save_Shipment_MonitoringsMutation = { __typename?: 'Mutation', saveAwb?: { __typename?: 'AwbNode', awbId?: string | null } | null };

export type Shipment_ListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<AwbSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  statuses?: InputMaybe<Array<InputMaybe<AwbStatusEnum>> | InputMaybe<AwbStatusEnum>>;
}>;


export type Shipment_ListQuery = { __typename?: 'Query', paginatedAwbs?: { __typename?: 'paginatedAwbs', count: number, edges?: Array<{ __typename?: 'paginatedAwbsEdge', cursor: string, node?: { __typename?: 'AwbNode', awbId?: string | null, codAmount?: any | null, deliveryDate?: string | null, destinationPhone?: string | null, destinationZipcode?: string | null, dropOrder?: number | null, latestPossibleCompleted?: string | null, itemDetails?: string | null, ksuid?: string | null, taskId?: string | null, tourId?: string | null, job?: { __typename?: 'JobNode', destinationAddress?: string | null, destinationCity?: string | null, destinationGpsLat?: number | null, destinationGpsLng?: number | null, destinationName?: string | null, destinationWarehouseKsuid?: string | null, originAddress?: string | null, originCity?: string | null, originGpsLat?: number | null, originGpsLng?: number | null, originName?: string | null, originWarehouseKsuid?: string | null, productType?: string | null, destination?: { __typename?: 'Warehouse', country?: string | null } | null, loadsCapacity?: { __typename?: 'LoadsCapacityNode', capacity?: number | null, unit?: string | null } | null } | null } | null } | null> | null } | null };

export type Delivery_Order_DetailsQueryVariables = Exact<{
  ksuid?: InputMaybe<Scalars['String']>;
}>;


export type Delivery_Order_DetailsQuery = { __typename?: 'Query', deliveryOrderDetails?: { __typename?: 'DeliveryOrder', actualOvertimeHours?: number | null, allocationStatus?: string | null, cancelReason?: string | null, companyDriverKsuid?: string | null, companyVehicleKsuid?: string | null, companyVehicleReplacementKsuid?: string | null, contractDriverKsuid?: string | null, contractVehicleKsuid?: string | null, deliveryDate?: string | null, discount?: boolean | null, discountFlatValue?: number | null, discountPercentageMax?: number | null, discountPercentageValue?: number | null, discountType?: string | null, driverNotes?: string | null, externalId?: string | null, extraHelperAmount?: number | null, extraHelperPrice?: number | null, insuranceLoadValue?: number | null, insurancePrice?: number | null, internalNotes?: string | null, plannedPricingUnit?: number | null, podReturnAddress?: string | null, podReturnPrice?: number | null, polUpload?: string | null, priceFinal?: number | null, priceSuggestion?: number | null, projectKsuid?: string | null, shipperKsuid?: string | null, shipperNotes?: string | null, status?: string | null, tourId?: string | null, transporterDriverKsuid?: string | null, transporterPrice?: any | null, transporterVehicleKsuid?: string | null, awbs?: Array<{ __typename?: 'AwbJobNode', actualOvertimeHours?: number | null, actualPricingUnit?: number | null, awbId?: string | null, cancelReason?: string | null, codAmount?: any | null, collectedCodAmount?: any | null, completeStatus?: AwbCompleteStatusEnum | null, deliveryDate?: string | null, incompleteReason?: string | null, ksuid?: string | null, latestPossibleCompleted?: string | null, podUpload?: string | null, shipmentNotes?: string | null, status?: string | null, taskId?: string | null, timestampStatus?: string | null, job?: { __typename?: 'JobNode', doNumber?: string | null, destinationAddress?: string | null, destinationGpsLat?: number | null, destinationGpsLng?: number | null, destinationName?: string | null, destinationWarehouseKsuid?: string | null, ksuid?: string | null, originName?: string | null, originWarehouseKsuid?: string | null, destination?: { __typename?: 'Warehouse', notes?: string | null, picName?: string | null, picTelephone?: string | null } | null } | null } | null> | null, companyDriver?: { __typename?: 'CompanyDriver', ksuid?: string | null, driver?: { __typename?: 'Driver', contactNumber?: string | null, name?: string | null, ksuid?: string | null } | null } | null, companyVehicle?: { __typename?: 'CompanyVehicleNode', dimension?: string | null, vehicle?: { __typename?: 'VehicleNode', capacity?: number | null, capacityUnit?: string | null, ksuid: string, licensePlateNumber?: string | null, vehicleType?: { __typename?: 'MDVehicleNode', subType?: string | null, type?: string | null } | null } | null } | null, companyVehicleReplacement?: { __typename?: 'CompanyVehicleNode', dimension?: string | null, ksuid: string, vehicle?: { __typename?: 'VehicleNode', capacity?: number | null, capacityUnit?: string | null, ksuid: string, licensePlateNumber?: string | null, vehicleType?: { __typename?: 'MDVehicleNode', subType?: string | null, type?: string | null } | null } | null } | null, contractDriver?: { __typename?: 'ContractNode', contractCode?: string | null, endDate?: string | null, ksuid?: string | null, startDate?: string | null, supplyType?: string | null, type?: string | null } | null, contractVehicle?: { __typename?: 'ContractNode', contractCode?: string | null, endDate?: string | null, ksuid?: string | null, startDate?: string | null, supplyType?: string | null, type?: string | null, vehicleAllocations?: Array<{ __typename?: 'VehicleAllocationNode', vehicleContractCode?: string | null } | null> | null } | null, job?: { __typename?: 'JobNode', doNumber?: string | null, ksuid?: string | null, originAddress?: string | null, originGpsLat?: number | null, originGpsLng?: number | null, originName?: string | null, originWarehouseKsuid?: string | null, productType?: string | null, shipperCompanyKsuid?: string | null, origin?: { __typename?: 'Warehouse', picName?: string | null, picTelephone?: string | null } | null, shipment?: { __typename?: 'ShipmentType', status?: string | null } | null } | null, project?: { __typename?: 'ProjectNode', codFee?: boolean | null, codFlat?: number | null, codPercentage?: number | null, codType?: string | null, endDate?: string | null, ksuid?: string | null, name?: string | null, overtimeFee?: number | null, pricingScheme?: string | null, schemePrice?: number | null, schemeUnit?: string | null, startDate?: string | null, type?: string | null, unitValue?: number | null, minValue?: number | null, projectVehicles?: Array<{ __typename?: 'ProjectVehicleNode', capacity?: number | null } | null> | null } | null, receivable?: { __typename?: 'ReceivableDeliveryOrder', codFee?: number | null, shipperPriceFinal?: number | null } | null, shipper?: { __typename?: 'CompanyNode', name?: string | null, ksuid?: string | null, phoneNumber?: string | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', phoneNumber?: string | null } | null> | null } | null, transporterDriver?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null } | null, transporterVehicle?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', phoneNumber?: string | null } | null> | null } | null } | null };

export type Get_Audit_EventsQueryVariables = Exact<{
  resourceKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type Get_Audit_EventsQuery = { __typename?: 'Query', auditEvents?: Array<{ __typename?: 'EventNode', actorKsuid?: string | null, actorName?: string | null, createdAt?: string | null, eventName?: string | null, ksuid?: string | null, metadata?: any | null, resourceKsuid?: string | null } | null> | null };

export type Save_Do_AwbMutationVariables = Exact<{
  awbId?: InputMaybe<Scalars['String']>;
  codAmount?: InputMaybe<Scalars['Float']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']>;
  deliveryOrder?: InputMaybe<DeliveryOrderInput>;
  destination?: InputMaybe<WarehouseInputType>;
  dropOrder?: InputMaybe<Scalars['Int']>;
  itemDetails?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  latestPossibleCompleted?: InputMaybe<Scalars['DateTime']>;
  originKsuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AwbStatusEnum>;
  taskId?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['String']>;
}>;


export type Save_Do_AwbMutation = { __typename?: 'Mutation', saveAwb?: { __typename?: 'AwbNode', awbId?: string | null } | null };

export type Save_Shipper_LocationsMutationVariables = Exact<{
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  coordinate?: InputMaybe<CoordinateInput>;
  district?: InputMaybe<Scalars['String']>;
  googleMapUrl?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  operatingHoursData?: InputMaybe<Array<InputMaybe<WarehouseOperatingHourInput>> | InputMaybe<WarehouseOperatingHourInput>>;
  picName?: InputMaybe<Scalars['String']>;
  picTelephone?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<WarehouseStatusEnum>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type Save_Shipper_LocationsMutation = { __typename?: 'Mutation', saveWarehouse?: { __typename?: 'Warehouse', address?: string | null, averageRating?: string | null, city?: string | null, companyKsuid?: string | null, country?: string | null, district?: string | null, driverNotes?: string | null, geofenceRadiusKm?: number | null, googleMapUrl?: string | null, ksuid?: string | null, name?: string | null, notes?: string | null, picName?: string | null, picTelephone?: string | null, province?: string | null, status?: any | null, type?: string | null, coordinate?: { __typename?: 'Coordinate', latitude?: number | null, longitude?: number | null } | null, mdDistrict?: { __typename?: 'MdDistrict', id?: string | null, name?: string | null } | null, operatingHoursData?: Array<{ __typename?: 'WarehouseOperatingHour', closingHour?: string | null, day?: string | null, openingHour?: string | null } | null> | null } | null };

export type Shipper_LocationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<WarehouseSortInput>;
}>;


export type Shipper_LocationsQuery = { __typename?: 'Query', paginatedWarehouses?: { __typename?: 'WarehouseConnection', count: number, edges?: Array<{ __typename?: 'WarehouseConnectionEdge', cursor: string, node?: { __typename?: 'Warehouse', address?: string | null, averageRating?: string | null, city?: string | null, companyKsuid?: string | null, country?: string | null, district?: string | null, driverNotes?: string | null, geofenceRadiusKm?: number | null, googleMapUrl?: string | null, ksuid?: string | null, name?: string | null, notes?: string | null, picName?: string | null, picTelephone?: string | null, province?: string | null, status?: any | null, type?: string | null, coordinate?: { __typename?: 'Coordinate', latitude?: number | null, longitude?: number | null } | null, mdDistrict?: { __typename?: 'MdDistrict', id?: string | null, name?: string | null, city?: { __typename?: 'MdCity', id?: string | null, name?: string | null, province?: { __typename?: 'MdProvince', id?: string | null, name?: string | null } | null } | null } | null, operatingHoursData?: Array<{ __typename?: 'WarehouseOperatingHour', closingHour?: string | null, day?: string | null, openingHour?: string | null } | null> | null, shipper?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Save_Shipper_ProjectMutationVariables = Exact<{
  codFlat?: InputMaybe<Scalars['Float']>;
  codPercentage?: InputMaybe<Scalars['Float']>;
  codType?: InputMaybe<ProjectCodType>;
  enableTiering?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  ksuid?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  overtimeFee?: InputMaybe<Scalars['Float']>;
  paymentScheduleOffset?: InputMaybe<Scalars['Int']>;
  paymentScheduleTime?: InputMaybe<Scalars['String']>;
  paymentScheduleUsingWeekday?: InputMaybe<Scalars['Boolean']>;
  paymentWorkingDays?: InputMaybe<Array<InputMaybe<ProjectPaymentWorkingDays>> | InputMaybe<ProjectPaymentWorkingDays>>;
  pricingScheme?: InputMaybe<ProjectPricingScheme>;
  projectBanks?: InputMaybe<Array<InputMaybe<ProjectBankInput>> | InputMaybe<ProjectBankInput>>;
  projectVehicles?: InputMaybe<Array<InputMaybe<ProjectVehicleInput>> | InputMaybe<ProjectVehicleInput>>;
  routeType?: InputMaybe<ProjectRouteType>;
  schemePrice?: InputMaybe<Scalars['Float']>;
  schemeUnit?: InputMaybe<ProjectSchemeUnit>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  tieredBy?: InputMaybe<ProjectTieredBy>;
  tierValue?: InputMaybe<Scalars['Float']>;
  tkbmFee?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ProjectType>;
  unitValue?: InputMaybe<Scalars['Float']>;
}>;


export type Save_Shipper_ProjectMutation = { __typename?: 'Mutation', saveProject?: { __typename?: 'ProjectNode', capacity?: number | null, capacityUnit?: string | null, codFee?: boolean | null, codFlat?: number | null, codPercentage?: number | null, codType?: string | null, endDate?: string | null, ksuid?: string | null, minValue?: number | null, name?: string | null, overtimeFee?: number | null, paymentScheduleOffset?: number | null, paymentScheduleUsingWeekday?: boolean | null, pricingScheme?: string | null, routeType?: string | null, schemePrice?: number | null, schemeUnit?: string | null, startDate?: string | null, status?: string | null, tieredBy?: string | null, tierValue?: number | null, type?: string | null, unitValue?: number | null, shipper?: { __typename?: 'CompanyNode', email?: string | null, ksuid?: string | null, name?: string | null, phoneNumber?: string | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', division?: string | null, email?: string | null, ksuid?: string | null, name?: string | null, position?: string | null } | null> | null } | null, vehicle?: { __typename?: 'MDVehicleMasterNode', id: string, subTruckType?: string | null, vehicleType?: string | null } | null } | null };

export type Save_ShipperMutationVariables = Exact<{
  address?: InputMaybe<Scalars['String']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingGmapsLocation?: InputMaybe<Scalars['String']>;
  billingOfficeDistrict?: InputMaybe<Scalars['String']>;
  billingPostalCode?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<CompanyPicInput>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>> | InputMaybe<DocumentInput>>;
  gmapsLocation?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<ShipperIndustryEnum>;
  invoiceAttention?: InputMaybe<Scalars['String']>;
  invoiceCode?: InputMaybe<Scalars['String']>;
  invoiceDetails?: InputMaybe<Scalars['String']>;
  invoiceEntity?: InputMaybe<InvoiceEntityEnum>;
  invoiceReceiptDeadline?: InputMaybe<Scalars['String']>;
  invoiceReceiptSchedule?: InputMaybe<Scalars['String']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officeDistrict?: InputMaybe<Scalars['String']>;
  paymentDays?: InputMaybe<Scalars['Int']>;
  paymentTerms?: InputMaybe<ShipperPaymentTerms>;
  postalCode?: InputMaybe<Scalars['String']>;
  salesChannel?: InputMaybe<Scalars['String']>;
  salesName?: InputMaybe<Scalars['String']>;
  salesStartDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  type?: InputMaybe<ShipperAccountType>;
}>;


export type Save_ShipperMutation = { __typename?: 'Mutation', saveShipper?: { __typename?: 'ShipperNode', company?: { __typename?: 'CompanyNode', email?: string | null, ksuid?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null };

export type Shipper_ListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  sortBy?: InputMaybe<ShipperSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  searchDocumentTypes?: InputMaybe<Array<InputMaybe<ShipperDocumentType>> | InputMaybe<ShipperDocumentType>>;
  searchOfficeDistrict?: InputMaybe<Scalars['String']>;
  searchPhoneNumber?: InputMaybe<Scalars['String']>;
  searchProjectTypes?: InputMaybe<Array<InputMaybe<ShipperProjectType>> | InputMaybe<ShipperProjectType>>;
  searchSalesName?: InputMaybe<Scalars['String']>;
  searchShipperId?: InputMaybe<Scalars['String']>;
  searchShipperName?: InputMaybe<Scalars['String']>;
  searchStatuses?: InputMaybe<Array<InputMaybe<Status>> | InputMaybe<Status>>;
  searchTypes?: InputMaybe<Array<InputMaybe<ShipperAccountType>> | InputMaybe<ShipperAccountType>>;
}>;


export type Shipper_ListQuery = { __typename?: 'Query', paginatedShippers?: { __typename?: 'paginatedShippers', count: number, edges?: Array<{ __typename?: 'paginatedShippersEdge', cursor: string, node?: { __typename?: 'ShipperNode', billingAddress?: string | null, billingGmapsLocation?: string | null, billingOfficeDistrict?: string | null, billingPostalCode?: string | null, brand?: string | null, companyKsuid?: string | null, contractUpload?: string | null, gmapsLocation?: string | null, industry?: string | null, invoiceAttention?: string | null, invoiceCode?: string | null, invoiceDetails?: string | null, invoiceEntity?: InvoiceEntityEnum | null, invoiceReceiptDeadline?: string | null, invoiceReceiptSchedule?: string | null, officeDistrict?: string | null, paymentDays?: number | null, paymentTerms?: string | null, postalCode?: string | null, salesChannel?: string | null, salesName?: string | null, salesStartDate?: string | null, sameAsBillingAddress?: boolean | null, status?: Status | null, type?: string | null, company?: { __typename?: 'CompanyNode', address?: string | null, ksuid?: string | null, name?: string | null, companyDocuments?: Array<{ __typename?: 'CompanyDocumentNode', ksuid?: string | null, documentType?: string | null, documentUpload?: string | null, expiryDate?: string | null, metadata?: string | null } | null> | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', division?: string | null, name?: string | null, phoneNumber?: string | null, email?: string | null } | null> | null } | null, projects?: Array<{ __typename?: 'ProjectNode', type?: string | null } | null> | null } | null } | null> | null } | null };

export type Save_ContractMutationVariables = Exact<{
  agreementFileLink?: InputMaybe<Scalars['String']>;
  codFee?: InputMaybe<Scalars['Boolean']>;
  codFlat?: InputMaybe<Scalars['Float']>;
  codPercentage?: InputMaybe<Scalars['Float']>;
  codType?: InputMaybe<ContractCodType>;
  downtimeFee?: InputMaybe<Scalars['Float']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  ksuid?: InputMaybe<Scalars['String']>;
  numberOfDropPoint?: InputMaybe<Scalars['Int']>;
  overtimeFee?: InputMaybe<Scalars['Float']>;
  paymentScheme?: InputMaybe<PaymentSchemeType>;
  price?: InputMaybe<Scalars['Float']>;
  projectKsuid?: InputMaybe<Scalars['String']>;
  projectName?: InputMaybe<Scalars['String']>;
  schemeType?: InputMaybe<ContractSchemeType>;
  shipperKsuid?: InputMaybe<Scalars['String']>;
  shipperName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  supplyType?: InputMaybe<ContractSupplyType>;
  transporterKsuid?: InputMaybe<Scalars['String']>;
  travelingExpenses?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ContractType>;
  unfulfilledFee?: InputMaybe<Scalars['Float']>;
  vehicleAllocations?: InputMaybe<Array<InputMaybe<VehicleAllocationInput>> | InputMaybe<VehicleAllocationInput>>;
  vehicleQuantity?: InputMaybe<Scalars['Int']>;
}>;


export type Save_ContractMutation = { __typename?: 'Mutation', saveContract?: { __typename?: 'ContractNode', contractCode?: string | null } | null };

export type Transporter_DriversQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchDriverName?: InputMaybe<Scalars['String']>;
  searchDriverPhoneNumber?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<CompanyDriverSortByEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Transporter_DriversQuery = { __typename?: 'Query', paginatedDrivers?: { __typename?: 'DriverConnection', count: number, edges?: Array<{ __typename?: 'DriverConnectionEdge', node?: { __typename?: 'CompanyDriver', dedicatedToContract?: boolean | null, ksuid?: string | null, status?: string | null, companyDriverDocuments?: Array<{ __typename?: 'CompanyDriverDocumentNode', documentType?: string | null, expiryDate?: string | null, ksuid?: string | null, metadata?: string | null, files?: Array<{ __typename?: 'File', fileName?: string | null, ksuid?: string | null, url?: { __typename?: 'URL', full?: string | null } | null } | null> | null } | null> | null, dedicatedContract?: { __typename?: 'BasicContractNode', contractCode?: string | null, ksuid?: string | null } | null, driver?: { __typename?: 'Driver', contactNumber?: string | null, driverLicenseExpiryDate?: string | null, driverLicenseNumber?: string | null, driverLicenseType?: string | null, idCardNumber?: string | null, name?: string | null } | null, transporter?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Save_VehicleMutationVariables = Exact<{
  capacity?: InputMaybe<Scalars['Float']>;
  capacityUnit?: InputMaybe<CapacityUnitEnum>;
  companyKsuid?: InputMaybe<Scalars['String']>;
  contractKsuid?: InputMaybe<Scalars['String']>;
  dedicatedToContract?: InputMaybe<Scalars['Boolean']>;
  dimension?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>> | InputMaybe<DocumentInput>>;
  height?: InputMaybe<Scalars['Float']>;
  ksuid?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['Float']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  vehiclePlateType?: InputMaybe<VehiclePlateType>;
  vehicleTypeId?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
}>;


export type Save_VehicleMutation = { __typename?: 'Mutation', saveVehicle?: { __typename?: 'CompanyVehicleNode', ksuid: string, status?: string | null } | null };

export type Transporter_FleetsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  ksuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchLicensePlate?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<VehicleSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Transporter_FleetsQuery = { __typename?: 'Query', paginatedVehicles?: { __typename?: 'paginatedVehicles', count: number, edges?: Array<{ __typename?: 'paginatedVehiclesEdge', node?: { __typename?: 'CompanyVehicleNode', dedicatedToContract?: boolean | null, dimension?: string | null, ksuid: string, status?: string | null, companyVehicleDocuments?: Array<{ __typename?: 'CompanyDriverDocumentNode', documentType?: string | null, expiryDate?: string | null, ksuid?: string | null, metadata?: string | null, files?: Array<{ __typename?: 'File', fileName?: string | null, ksuid?: string | null, uploadedAt?: string | null, url?: { __typename?: 'URL', full?: string | null, preview?: string | null } | null } | null> | null } | null> | null, dedicatedContract?: { __typename?: 'BasicContractNode', ksuid?: string | null, contractCode?: string | null } | null, transporter?: { __typename?: 'CompanyNode', ksuid?: string | null, name?: string | null } | null, vehicle?: { __typename?: 'VehicleNode', capacity?: number | null, capacityUnit?: string | null, height?: number | null, ksuid: string, length?: number | null, licensePlateNumber?: string | null, vehiclePlateType?: string | null, width?: number | null, vehicleType?: { __typename?: 'MDVehicleNode', name?: string | null, subType?: string | null, type?: string | null } | null } | null } | null } | null> | null } | null };

export type Get_Transporter_Pipeline_DetailsQueryVariables = Exact<{
  pipelineCode: Scalars['String'];
}>;


export type Get_Transporter_Pipeline_DetailsQuery = { __typename?: 'Query', transporterPipelineDetails?: { __typename?: 'TransporterPipelineNode', agreementType?: AgreementType | null, areaCoverage?: string | null, cluster?: string | null, city?: string | null, codServices?: boolean | null, contractType?: ContractType | null, duplicatedFrom?: string | null, notes?: string | null, paymentScheme?: PaymentSchemeType | null, pipelineCode?: string | null, proofOfSigning?: string | null, status?: PipelineStatus | null, statusTimestamp?: any | null, supplyType?: ContractSupplyType | null, drivers?: Array<{ __typename?: 'TPDriverNode', bankName?: string | null, bankAccountNumber?: string | null, bankOwnerName?: string | null, branch?: string | null, contact?: string | null, expirationDate?: string | null, helperName?: string | null, helperContact?: string | null, ktp?: string | null, name?: string | null, npwp?: string | null, replacementDriverEndDate?: string | null, replacementDriverName?: string | null, replacementDriverStartDate?: string | null, sim?: string | null } | null> | null, fleet?: { __typename?: 'TPFleetNode', fleetBodyType?: FleetBodyType | null, fleetType?: FleetType | null, fleetDetails?: Array<{ __typename?: 'FleetDetailsNode', brand?: string | null, ccMesin?: string | null, fleetColor?: string | null, kir?: string | null, kirExpirationDate?: string | null, noRangka?: string | null, noMesin?: string | null, plateNumber?: string | null, plateColor?: VehiclePlateType | null, productionDate?: string | null, replacementFleetStartDate?: string | null, replacementFleetEndDate?: string | null, replacementFleetPlate?: string | null, taxExpirationDate?: string | null, drivenBy?: { __typename?: 'TPDriverNode', name?: string | null, contact?: string | null, sim?: string | null, expirationDate?: string | null, ktp?: string | null, npwp?: string | null, helperName?: string | null, helperContact?: string | null, replacementDriverName?: string | null, replacementDriverStartDate?: string | null, replacementDriverEndDate?: string | null } | null } | null> | null } | null, project?: { __typename?: 'TPProjectNode', alias?: string | null, ksuid?: string | null, name?: string | null } | null, shipper?: { __typename?: 'TPShipperNode', alias?: string | null, ksuid?: string | null, name?: string | null } | null, routePriceDetails?: Array<{ __typename?: 'RoutePriceDetailNode', pickupRoute?: string | null, dropOffRoute?: string | null, startDate?: string | null, endDate?: string | null, rentalPrice?: number | null, unfulfillFee?: number | null, tipPrice?: number | null } | null> | null, transporter?: { __typename?: 'TPTransporterPipelineNode', accountType?: TransporterAccountType | null, bankName?: string | null, bankAccountNumber?: string | null, bankOwnerName?: string | null, branch?: string | null, documentLink?: string | null, documents?: any | null, email?: string | null, name?: string | null, picName?: string | null, picPhoneNumber?: string | null, poolCityProvince?: string | null, poolPostalCode?: string | null, poolFullAddress?: string | null, transporterType?: TransporterType | null } | null } | null };

export type Save_Transporter_Pipeline_DetailsMutationVariables = Exact<{
  agreementType?: InputMaybe<AgreementType>;
  areaCoverage?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cluster?: InputMaybe<Scalars['String']>;
  codServices?: InputMaybe<Scalars['Boolean']>;
  contractType?: InputMaybe<ContractType>;
  drivers?: InputMaybe<Array<InputMaybe<DriverInput>> | InputMaybe<DriverInput>>;
  fleet?: InputMaybe<FleetInput>;
  paymentScheme?: InputMaybe<PaymentSchemeType>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  proofOfSigning?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ProjectInput>;
  routePriceDetails?: InputMaybe<Array<InputMaybe<RoutePriceDetail>> | InputMaybe<RoutePriceDetail>>;
  shipper?: InputMaybe<ShipperInput>;
  supplyType?: InputMaybe<ContractSupplyType>;
  transporter?: InputMaybe<TransporterInput>;
}>;


export type Save_Transporter_Pipeline_DetailsMutation = { __typename?: 'Mutation', saveTransporterPipeline?: { __typename?: 'TransporterPipelineNode', pipelineCode?: string | null } | null };

export type Get_Agreement_Document_DetailsQueryVariables = Exact<{
  pipelineCode: Scalars['String'];
}>;


export type Get_Agreement_Document_DetailsQuery = { __typename?: 'Query', transporterPipelineDetails?: { __typename?: 'TransporterPipelineNode', pipelineCode?: string | null, routePriceDetails?: Array<{ __typename?: 'RoutePriceDetailNode', startDate?: string | null, endDate?: string | null, rentalPrice?: number | null, unfulfillFee?: number | null, tipPrice?: number | null } | null> | null, transporter?: { __typename?: 'TPTransporterPipelineNode', name?: string | null, accountType?: TransporterAccountType | null, transporterType?: TransporterType | null, documents?: any | null, bankName?: string | null, bankAccountNumber?: string | null, bankOwnerName?: string | null, branch?: string | null, poolCityProvince?: string | null, poolPostalCode?: string | null, poolFullAddress?: string | null } | null, fleet?: { __typename?: 'TPFleetNode', fleetType?: FleetType | null, fleetBodyType?: FleetBodyType | null, fleetDetails?: Array<{ __typename?: 'FleetDetailsNode', plateNumber?: string | null, plateColor?: VehiclePlateType | null, brand?: string | null, productionDate?: string | null, ccMesin?: string | null, noRangka?: string | null, noMesin?: string | null, fleetColor?: string | null, drivenBy?: { __typename?: 'TPDriverNode', name?: string | null, contact?: string | null, sim?: string | null, expirationDate?: string | null, ktp?: string | null, npwp?: string | null } | null } | null> | null } | null } | null };

export type Get_Driver_Pipeline_OptionsQueryVariables = Exact<{
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchDriverName?: InputMaybe<Scalars['String']>;
}>;


export type Get_Driver_Pipeline_OptionsQuery = { __typename?: 'Query', paginatedDrivers?: { __typename?: 'DriverConnection', count: number, edges?: Array<{ __typename?: 'DriverConnectionEdge', node?: { __typename?: 'CompanyDriver', ksuid?: string | null, contracts?: Array<{ __typename?: 'BasicContractNode', status?: Status | null, supplyType?: string | null, ksuid?: string | null, type?: string | null } | null> | null, driver?: { __typename?: 'Driver', contactNumber?: string | null, name?: string | null } | null } | null } | null> | null } | null };

export type Get_Project_Pipeline_OptionsQueryVariables = Exact<{
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchName?: InputMaybe<Scalars['String']>;
  searchShipperKsuid?: InputMaybe<Scalars['String']>;
}>;


export type Get_Project_Pipeline_OptionsQuery = { __typename?: 'Query', paginatedProjects?: { __typename?: 'paginatedProjects', count: number, edges?: Array<{ __typename?: 'paginatedProjectsEdge', node?: { __typename?: 'ProjectNode', ksuid?: string | null, name?: string | null } | null } | null> | null } | null };

export type Get_Shipper_OptionsQueryVariables = Exact<{
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchShipperName?: InputMaybe<Scalars['String']>;
}>;


export type Get_Shipper_OptionsQuery = { __typename?: 'Query', paginatedShippers?: { __typename?: 'paginatedShippers', count: number, edges?: Array<{ __typename?: 'paginatedShippersEdge', node?: { __typename?: 'ShipperNode', companyKsuid?: string | null, company?: { __typename?: 'CompanyNode', name?: string | null } | null } | null } | null> | null } | null };

export type Get_Transporter_Pipeline_OptionsQueryVariables = Exact<{
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchName?: InputMaybe<Scalars['String']>;
}>;


export type Get_Transporter_Pipeline_OptionsQuery = { __typename?: 'Query', paginatedTransporters?: { __typename?: 'paginatedTransporters', count: number, edges?: Array<{ __typename?: 'paginatedTransportersEdge', node?: { __typename?: 'TransporterNode', companyKsuid?: string | null, company?: { __typename?: 'CompanyNode', name?: string | null } | null } | null } | null> | null } | null };

export type Get_Vehicle_Pipeline_OptionsQueryVariables = Exact<{
  companyKsuids?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first: Scalars['Int'];
  page: Scalars['Int'];
  searchLicensePlate?: InputMaybe<Scalars['String']>;
}>;


export type Get_Vehicle_Pipeline_OptionsQuery = { __typename?: 'Query', paginatedVehicles?: { __typename?: 'paginatedVehicles', count: number, edges?: Array<{ __typename?: 'paginatedVehiclesEdge', node?: { __typename?: 'CompanyVehicleNode', ksuid: string, contracts?: Array<{ __typename?: 'BasicContractNode', status?: Status | null, supplyType?: string | null, ksuid?: string | null, type?: string | null } | null> | null, vehicle?: { __typename?: 'VehicleNode', licensePlateNumber?: string | null, vehicleType?: { __typename?: 'MDVehicleNode', name?: string | null, subType?: string | null, type?: string | null } | null } | null } | null } | null> | null } | null };

export type Save_Transporter_Pipeline_CsvMutationVariables = Exact<{
  areaCoverage?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cluster?: InputMaybe<Scalars['String']>;
  codServices?: InputMaybe<Scalars['Boolean']>;
  contractType?: InputMaybe<ContractType>;
  drivers?: InputMaybe<Array<InputMaybe<DriverInput>> | InputMaybe<DriverInput>>;
  fleet?: InputMaybe<FleetInput>;
  paymentScheme?: InputMaybe<PaymentSchemeType>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ProjectInput>;
  routePriceDetails?: InputMaybe<Array<InputMaybe<RoutePriceDetail>> | InputMaybe<RoutePriceDetail>>;
  shipper?: InputMaybe<ShipperInput>;
  source?: InputMaybe<Source>;
  supplyType?: InputMaybe<ContractSupplyType>;
  transporter?: InputMaybe<TransporterInput>;
}>;


export type Save_Transporter_Pipeline_CsvMutation = { __typename?: 'Mutation', saveTransporterPipeline?: { __typename?: 'TransporterPipelineNode', pipelineCode?: string | null } | null };

export type Update_Transporter_Pipeline_StatusMutationVariables = Exact<{
  notes?: InputMaybe<Scalars['String']>;
  pipelineCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PipelineStatus>;
}>;


export type Update_Transporter_Pipeline_StatusMutation = { __typename?: 'Mutation', updateTransporterPipelineStatus?: { __typename?: 'TransporterPipelineNode', pipelineCode?: string | null } | null };

export type Update_Agreement_Created_StatusMutationVariables = Exact<{
  pipelineCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PipelineStatus>;
}>;


export type Update_Agreement_Created_StatusMutation = { __typename?: 'Mutation', updateTransporterPipelineStatus?: { __typename?: 'TransporterPipelineNode', pipelineCode?: string | null } | null };

export type Save_TransporterMutationVariables = Exact<{
  accountType?: InputMaybe<TransporterAccountType>;
  address: Scalars['String'];
  bankAccountHolder?: InputMaybe<Scalars['String']>;
  bankAccountNumber: Scalars['String'];
  bankBranch: Scalars['String'];
  bankName: Scalars['String'];
  contact?: InputMaybe<CompanyPicInput>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>> | InputMaybe<DocumentInput>>;
  gmapsLocation: Scalars['String'];
  initial: Scalars['String'];
  insuranceActive?: InputMaybe<Scalars['Boolean']>;
  insuranceEndDate?: InputMaybe<Scalars['DateTime']>;
  insuranceStartDate?: InputMaybe<Scalars['DateTime']>;
  ksuid?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  officeDistrict: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  skbOwnership?: InputMaybe<Scalars['String']>;
  taxVat: Scalars['Float'];
  taxWht: Scalars['Float'];
  status?: InputMaybe<Status>;
  type?: InputMaybe<TransporterType>;
}>;


export type Save_TransporterMutation = { __typename?: 'Mutation', saveTransporter?: { __typename?: 'TransporterNode', accountType?: string | null, bankAccountNumber?: string | null, bankBranch?: string | null, bankName?: string | null, companyKsuid?: string | null, initial?: string | null, status?: Status | null, taxVat?: number | null, taxWht?: number | null, type?: string | null, company?: { __typename?: 'CompanyNode', email?: string | null, ksuid?: string | null, name?: string | null, phoneNumber?: string | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', division?: string | null, email?: string | null, ksuid?: string | null, name?: string | null } | null> | null } | null } | null };

export type Transporter_ListQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  searchBankAccountHolder?: InputMaybe<Scalars['String']>;
  searchBankAccountNumber?: InputMaybe<Scalars['String']>;
  searchBankName?: InputMaybe<Scalars['String']>;
  searchInitial?: InputMaybe<Scalars['String']>;
  searchName?: InputMaybe<Scalars['String']>;
  searchStatus?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<TransporterSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type Transporter_ListQuery = { __typename?: 'Query', paginatedTransporters?: { __typename?: 'paginatedTransporters', count: number, edges?: Array<{ __typename?: 'paginatedTransportersEdge', node?: { __typename?: 'TransporterNode', accountType?: string | null, bankAccountHolder?: string | null, bankAccountNumber?: string | null, bankBranch?: string | null, bankName?: string | null, companyKsuid?: string | null, gmapsLocation?: string | null, initial?: string | null, insuranceEndDate?: string | null, insuranceStartDate?: string | null, officeDistrict?: string | null, skbOwnership?: string | null, status?: Status | null, taxVat?: number | null, taxWht?: number | null, type?: string | null, company?: { __typename?: 'CompanyNode', address?: string | null, name?: string | null, companyDocuments?: Array<{ __typename?: 'CompanyDocumentNode', documentType?: string | null, documentUpload?: string | null, expiryDate?: string | null, ksuid?: string | null, metadata?: string | null } | null> | null, companyPics?: Array<{ __typename?: 'CompanyPICNode', email?: string | null, name?: string | null, phoneNumber?: string | null, position?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type All_Md_VehicleQueryVariables = Exact<{ [key: string]: never; }>;


export type All_Md_VehicleQuery = { __typename?: 'Query', allMDVehicle?: Array<{ __typename?: 'MDVehicleMasterNode', id: string, subTruckType?: string | null, vehicleType?: string | null } | null> | null };
